(() => {

// NOTICE!! THIS IS REQUIRED TO MAKE YOUR NETO SHOPPING CART WORK
// DO NOT REMOVE UNLESS YOU REALLY KNOW WHAT YOU ARE DOING
var $8b5bbe8eeb487c73$var$nCustom = {
    vars: {
        focused: $('body'),
        lastFocused: $('body')
    },
    funcs: {
        initPageFuncs: function() {
            // Ajax Wish List
            $.addToWishList({
                class: 'wishlist_toggle',
                textclass: 'wishlist_text',
                htmlon: '<svg><use xlink:href="#icon-wishlist"></use></svg>',
                htmloff: '<svg><use xlink:href="#icon-wishlist-full"></use></svg>',
                tooltip_css: 'whltooltips',
                imageon: '',
                imageoff: ''
            });
            // Ajax Add To Cart
            $.addToCartInit({
                cart_id: 'cartcontents',
                target_id: 'cartcontentsheader',
                image_rel: 'itmimg'
            });
            // Renders the instant search results - edit design of ajax results here
            $.initSearchField({
                result_header: '<ul class="nav nav-list">',
                result_body: '<li><a href="##url##" search-keyword="##keyword##"><div class="img"><img border="0" src="##thumb##" width="36" height="36"/></div><span class="title">##model##</span></a></li>',
                result_footer: '</ul>',
                category_header: '<ul class="nav nav-list">',
                category_body: '<li><a href="##url##"><span class="thumb"><div class="img"><img border="0" src="##thumb##" width="36" height="36"/></div></span><span class="title">##fullname##</span> <span class="label label-default">##typename##</span></a></li>',
                category_footer: '</ul>'
            });
        },
        // For child product multi-add to cart function
        checkValidQty: function() {
            // var found = 0;
            // $('#multiitemadd :input').each(function() {
            // 	if ($(this).attr('id').match(/^qty/)) {
            // 		if ($(this).val() > 0) {
            // 			found = 1;
            // 		}
            // 	}
            // });
            // if (found == 0) {
            // 	$.nPopupBox('Please specify a quantity before adding to cart');
            // 	return false;
            // }
            return true;
        },
        // Capture the last item focused
        updateFocused: function() {
            $8b5bbe8eeb487c73$var$nCustom.vars.lastFocused = $8b5bbe8eeb487c73$var$nCustom.vars.focused;
        },
        // Place focus on popup
        popupFocus: function() {
            var popUp = document.getElementById('npopupDesc');
            // Configures the observer
            var config = {
                childList: true
            };
            // Create an observer instance
            var popUpObserver = new MutationObserver(function(mutations) {
                mutations.forEach(function(mutation) {
                    // Initial observer
                    if (mutation.addedNodes['0']) {
                        $8b5bbe8eeb487c73$var$nCustom.funcs.updateFocused();
                        // focus on the popup
                        $(popUp).attr('tabindex', '-1').trigger('focus');
                    } else {
                        $(popUp).attr('tabindex', '').trigger('focus');
                        // Observer closing popup
                        $($8b5bbe8eeb487c73$var$nCustom.vars.lastFocused).trigger('focus');
                    }
                });
            });
            // Pass in the target node, as well as the observer options
            if (popUp) popUpObserver.observe(popUp, config);
        },
        buttonLoading: function() {
            var loadingText = $(this).attr('data-loading-text');
            var originalText = $(this).html();
            $(this).html(loadingText).addClass('disabled').prop('disabled', true);
            var pendingButton = this;
            setTimeout(function() {
                $(pendingButton).html(originalText).removeClass('disabled').prop('disabled', false);
            }, 3000);
        },
        windowPopup: function(url, width, height) {
            // Calculate the position of the popup so it’s centered on the screen.
            var left = screen.width / 2 - width / 2, top = screen.height / 2 - height / 2;
            window.open(url, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,width=' + width + ',height=' + height + ',top=' + top + ',left=' + left);
        },
        // Will remove/add class from element
        classToggle: function(element, css, type) {
            if (type) type == 'add' ? $(element).addClass(css) : $(element).removeClass(css);
        }
    }
};
$(document).ready(function() {
    // Neto functionalty
    $8b5bbe8eeb487c73$var$nCustom.funcs.initPageFuncs();
    $8b5bbe8eeb487c73$var$nCustom.funcs.popupFocus();
    // Jquery Ui Date Picker
    $('.datepicker').datepicker({
        dateFormat: 'dd/mm/yy'
    });
    // Carousel
    $('.carousel').carousel();
    // Tooltip
    $('[data-toggle="tooltip"]').tooltip();
});
// Capture the current element the user focused in
$(document).on('focusin', function() {
    $8b5bbe8eeb487c73$var$nCustom.vars.focused = document.activeElement;
});
// Btn loading state
$(document).on('click', '.btn-loads', $8b5bbe8eeb487c73$var$nCustom.funcs.buttonLoading);
// Social media share
$('.js-social-share').on('click', function(e) {
    e.preventDefault();
    $8b5bbe8eeb487c73$var$nCustom.funcs.windowPopup($(this).attr('href'), 500, 300);
});
// Mobile menu
$('.nToggleMenu').on('click', function() {
    var toggleTarget = $(this).attr('data-target');
    $(toggleTarget).slideToggle();
});
// Invoice page
$('#cart_items').on('click', '[data-body-add]', function(e) {
    e.preventDefault();
    $8b5bbe8eeb487c73$var$nCustom.funcs.classToggle('body', $(this).attr('data-body-add'), 'add');
});
$('#cart_items').on('click', '[data-body-remove]', function(e) {
    e.preventDefault();
    $8b5bbe8eeb487c73$var$nCustom.funcs.classToggle('body', $(this).attr('data-body-remove'), 'remove');
});
$('#_jstl__buying_options').on('click', '.js-notifymodal-in-stock', function(e) {
    e.preventDefault();
    // Get values
    var sku = $(this).attr('data-sku');
    var $wrapper = $('#notifymodal .checkbox');
    var $terms = $('#notifymodal .terms_box');
    var $helpText = $('#notifymodal .checkbox .help-block');
    // Validate form
    if (!$.isChecked($terms)) {
        $wrapper.addClass('has-error');
        $helpText.removeClass('hidden');
        return false;
    } else {
        $wrapper.removeClass('has-error');
        $helpText.addClass('hidden');
        // Dismiss modal
        $('#notifymodal').modal('hide');
        // Send information
        $.addNotifyBackInStock(sku, '');
        $terms.attr('checked', false);
        return true;
    }
});
// Multi add child products
$('.multi-add').on('click', function() {
    $.addMultipleCartItems('multiitemadd');
    return false;
});
$(document).ready(function() {
    $.compatListInit({});
    $(".compatibility_list").change(function() {
        $.buildCompatList($(this));
    });
});
// Update Order Summary on Add to Cart
window.nAddItemCallbacks.push($8b5bbe8eeb487c73$var$updateOrderSummary);
window.nAddMultiItemsCallbacks.push($8b5bbe8eeb487c73$var$updateOrderSummary);
window.nRemoveItemCallbacks.push($8b5bbe8eeb487c73$var$updateOrderSummary);
// Update Order Summary
function $8b5bbe8eeb487c73$var$updateOrderSummary() {
    $.load_ajax_template('_order_summary', {});
}


const $33151c6d3bf6cc96$export$c99e242bffb864af = window.innerWidth;
const $33151c6d3bf6cc96$export$83c62512efb68338 = window.innerHeight;
function $33151c6d3bf6cc96$export$f531f92e2a15358f() {
    window.resetEvent = new Event('reset');
    window.popupsClosedEvent = new Event('popupsClosed');
    window.popupOpenEvent = new Event('popupOpen');
    window.qtyChangeEvent = new Event('qtyChange');
    window.resetQtyEvent = new Event('resetQty');
    window.itemsLoadedEvent = new Event('itemsLoaded');
}
function $33151c6d3bf6cc96$export$4a59b34ae617836() {
    const doc = document.documentElement;
    doc.style.setProperty('--app-height', `${$33151c6d3bf6cc96$export$83c62512efb68338}px`);
}
function $33151c6d3bf6cc96$export$515dbd4fb6a22d5a() {
    window.addEventListener('resize', $33151c6d3bf6cc96$export$4a59b34ae617836);
}
function $33151c6d3bf6cc96$export$5cf963806c4f5dc7(el) {
    const rect = el.getBoundingClientRect();
    return rect.top >= 0 && rect.bottom <= $33151c6d3bf6cc96$export$83c62512efb68338;
}
function $33151c6d3bf6cc96$export$62976f5619263b39(el) {
    const rect = el.getBoundingClientRect();
    return rect.top >= 0 && rect.top <= $33151c6d3bf6cc96$export$83c62512efb68338;
}
function $33151c6d3bf6cc96$export$53a0910f038337bd(el, offset) {
    const scroll = el.getBoundingClientRect().top + window.scrollY - offset;
    window.scroll({
        top: scroll,
        behavior: 'smooth'
    });
}
function $33151c6d3bf6cc96$export$924fdf84dc385218(price) {
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
    }).format(price);
}
var $33151c6d3bf6cc96$export$7b1795bf935bef37 = /*#__PURE__*/ function(ShowHide) {
    ShowHide["SHOW_MORE"] = "SHOW MORE";
    ShowHide["SHOW_LESS"] = "SHOW LESS";
    return ShowHide;
}({});


class $5faf9ae567940230$export$129a32eedafa97c5 {
    constructor(popup, triger, close){
        this.popup = null;
        this.triger = null;
        this.close = null;
        this.overlay = document.getElementById('overlay');
        this.isOpen = false;
        this.popup = document.querySelector(popup);
        this.triger = document.querySelectorAll(triger);
        this.close = document.querySelectorAll(close);
    }
    recunstruct(popup, triger, close) {
        this.reset();
        if (popup) {
            this.popup = document.querySelector(popup);
            this.popup?.classList.add('init');
        }
        if (triger) this.triger = document.querySelectorAll(triger);
        if (close) this.close = document.querySelectorAll(close);
    }
    init() {
        this.popup?.classList.add('init');
        this.openPopup();
        this.overlayClose();
        this.setClose();
        this.resetSlider();
    }
    reset() {
        if (this.popup && this.triger) {
            this.popup.dataset.open = 'false';
            this.triger.forEach((item)=>{
                item.dataset.open = 'false';
                item.classList.remove('activeClass', 'jsPopupOpen');
            });
            this.popup.classList.remove('activeClass', 'jsPopupOpen');
        }
    }
    overlayClose() {
        this.overlay?.addEventListener('click', ()=>{
            this.isOpen = false;
            this.setOverlay();
        });
    }
    openPopup() {
        if (this.popup && this.triger) this.triger.forEach((item)=>{
            item.addEventListener('click', this.onTriggerClick.bind(this));
        });
    }
    onTriggerClick() {
        if (this.popup) {
            if (!this.isOpen) {
                this.isOpen = true;
                this.setOverlay();
                window.dispatchEvent(window.popupOpenEvent);
            } else {
                this.isOpen = false;
                this.setOverlay();
            }
        }
    }
    setOverlay() {
        if (this.popup && this.triger) {
            if (this.isOpen) {
                this.closeAll();
                this.popup.classList.add('activeClass', 'jsPopupOpen');
                this.popup.dataset.open = 'true';
                this.triger.forEach((item)=>{
                    item.dataset.open = 'true';
                    item.classList.add('activeClass', 'jsPopupOpen');
                });
                this.overlay?.classList.add('activeClass');
                document.documentElement.style.overflow = 'hidden';
                document.body.classList.add('activeClass');
            } else {
                this.popup.classList.remove('activeClass', 'jsPopupOpen');
                this.popup.dataset.open = 'false';
                this.triger.forEach((item)=>{
                    item.dataset.open = 'false';
                    item.classList.remove('activeClass', 'jsPopupOpen');
                });
                this.overlay?.classList.remove('activeClass');
                document.documentElement.style.overflow = 'auto';
                document.body.classList.remove('activeClass');
            }
        }
    }
    setClose() {
        this.close?.forEach((item)=>{
            item.addEventListener('click', ()=>{
                this.isOpen = false;
                this.setOverlay();
            });
        });
    }
    resetSlider() {
        window.addEventListener('closePopups', ()=>{
            this.closeAll();
        });
    }
    closeAll() {
        const popups = document.querySelectorAll('.jsPopupOpen');
        this.overlay?.classList.remove('activeClass');
        document.documentElement.style.overflow = 'auto';
        document.body.classList.remove('activeClass');
        window.dispatchEvent(window.popupsClosedEvent);
        popups.forEach((item)=>{
            item.classList.remove('activeClass', 'jsPopupOpen');
            item.dataset.open = 'false';
        });
    }
}


const $c11f0a32cd89d9db$var$popupCalls = {
    init () {
        const menu = new (0, $5faf9ae567940230$export$129a32eedafa97c5)('#jsMenuWrap', '#jsOpenMenu', '#jsCloseMenu');
        menu.init();
        const account = new (0, $5faf9ae567940230$export$129a32eedafa97c5)('#jsAccountWrap', '#jsOpenAccount', '#jsCloseAccount');
        account.init();
        const help = new (0, $5faf9ae567940230$export$129a32eedafa97c5)('#jsHelpWrap', '#jsOpenHelp', '#jsCloseHelp');
        help.init();
        const cart = new (0, $5faf9ae567940230$export$129a32eedafa97c5)('#jsCartWrap', '#jsOpenCart', '#jsCloseCart');
        cart.init();
        const filter = new (0, $5faf9ae567940230$export$129a32eedafa97c5)('#jsFilterWrap', '#jsOpenFilter', '#jsCloseFilter');
        filter.init();
    }
};
var $c11f0a32cd89d9db$export$2e2bcd8739ae039 = $c11f0a32cd89d9db$var$popupCalls;


const $240c1a48eb8b8a29$var$searchInput = {
    input: document.querySelector('.jsSearchInput'),
    btn: document.getElementById('jsSearchBtn'),
    init () {
        this.resetSearchInput();
    },
    resetSearchInput () {
        if (this.input) this.input.addEventListener('input', ()=>{
            const inputValue = this.input.value;
            if (this.input.value !== '') this.btn.classList.remove('d-none');
            if (this.input.value === '') this.btn.classList.add('d-none');
            this.btn.addEventListener('click', ()=>{
                this.input.value = '';
                this.btn.classList.add('d-none');
            });
        });
    }
};
var $240c1a48eb8b8a29$export$2e2bcd8739ae039 = $240c1a48eb8b8a29$var$searchInput;


const $d4e2d81e80d5910a$var$mobMenu = {
    nextLevel: document.querySelectorAll('.jsNextLevel'),
    prevLevel: document.querySelectorAll('.jsPrevLevel'),
    close: document.getElementById('jsCloseMenu'),
    megamenuBtn: document.getElementById('jsToggleMegamenu'),
    megamenuWrap: document.getElementById('jsMegamenuWrap'),
    links: document.querySelectorAll('.jsDropdownBtns'),
    overlay: document.getElementById('dropdownOverlay'),
    init () {
        this.setNextLevel();
        this.setPrevLevel();
        this.toggleMegaMenu();
        this.menuOverlay();
    },
    setNextLevel () {
        this.nextLevel.forEach((item)=>{
            const subMenu = item.nextElementSibling;
            if (subMenu) item.addEventListener('click', (e)=>{
                e.preventDefault();
                subMenu.classList.add('activeClass');
            });
            this.close.addEventListener('click', ()=>{
                subMenu.classList.remove('activeClass');
            });
        });
    },
    setPrevLevel () {
        this.prevLevel.forEach((item)=>{
            const menu = item.parentElement?.parentElement;
            if (menu) item.addEventListener('click', ()=>{
                menu?.classList.remove('activeClass');
            });
            this.close.addEventListener('click', ()=>{
                menu?.classList.remove('activeClass');
            });
        });
    },
    toggleMegaMenu () {
        if (!this.megamenuBtn || !this.megamenuWrap) return;
        let closeTimer;
        const CLOSE_DELAY_MS = 140;
        const open = ()=>{
            if (closeTimer !== undefined) {
                window.clearTimeout(closeTimer);
                closeTimer = undefined;
            }
            this.megamenuWrap.classList.add('activeClass');
            this.megamenuBtn.classList.add('activeClass');
        };
        const close = ()=>{
            if (closeTimer !== undefined) window.clearTimeout(closeTimer);
            closeTimer = window.setTimeout(()=>{
                this.megamenuWrap.classList.remove('activeClass');
                this.megamenuBtn.classList.remove('activeClass');
                closeTimer = undefined;
            }, CLOSE_DELAY_MS);
        };
        this.megamenuBtn.addEventListener('pointerenter', open);
        this.megamenuBtn.addEventListener('pointerleave', close);
        this.megamenuWrap.addEventListener('pointerenter', open);
        this.megamenuWrap.addEventListener('pointerleave', close);
        this.megamenuBtn.addEventListener('focusin', open);
        this.megamenuBtn.addEventListener('focusout', close);
    },
    menuOverlay () {
        let openTimeout;
        let closeTimeout;
        const openOverlay = ()=>{
            clearTimeout(closeTimeout);
            clearTimeout(openTimeout);
            openTimeout = setTimeout(()=>{
                this.overlay.classList.add('activeClass');
            }, 100);
        };
        const closeOverlay = ()=>{
            clearTimeout(openTimeout);
            clearTimeout(closeTimeout);
            closeTimeout = setTimeout(()=>{
                this.overlay.classList.remove('activeClass');
            }, 120);
        };
        this.links.forEach((item)=>{
            item.addEventListener('mouseenter', openOverlay);
            item.addEventListener('mouseleave', closeOverlay);
        });
    }
};
var $d4e2d81e80d5910a$export$2e2bcd8739ae039 = $d4e2d81e80d5910a$var$mobMenu;



const $90d1518f9fdd1c26$var$HOVER_DELAY = 250;
const $90d1518f9fdd1c26$var$headerHoverPopups = {
    btns: Array.from(document.querySelectorAll('.jsPopupBtns')),
    wraps: Array.from(document.querySelectorAll('.jsPopupWraps')),
    overlay: document.getElementById('jsPopupOverlay'),
    openTimer: null,
    init () {
        if ((0, $33151c6d3bf6cc96$export$c99e242bffb864af) > 1200) {
            this.setHoverState();
            this.removeHoverState();
        }
        this.setClosePopupListener();
    },
    setHoverState () {
        this.btns.forEach((btn)=>{
            btn.addEventListener('mouseenter', ()=>{
                this.handleHover(btn);
            });
            btn.addEventListener('mouseleave', ()=>{
                this.clearOpenTimer();
            });
        });
        this.wraps.forEach((wrap)=>{
            wrap.addEventListener('mouseenter', ()=>{
                this.clearOpenTimer();
            });
        });
    },
    handleHover (activeBtn) {
        const popupId = activeBtn.getAttribute('data-popup');
        this.clearOpenTimer();
        this.openTimer = setTimeout(()=>{
            this.btns.forEach((btn)=>{
                const wrap = this.getWrapForButton(btn);
                const isActive = btn.getAttribute('data-popup') === popupId;
                btn.classList.toggle('activeClass', isActive);
                if (wrap) wrap.classList.toggle('activeClass', isActive);
            });
            if (this.overlay) this.overlay.classList.add('activeClass');
            this.openTimer = null;
        }, $90d1518f9fdd1c26$var$HOVER_DELAY);
    },
    getWrapForButton (btn) {
        const btnPopupId = btn.getAttribute('data-popup');
        return this.wraps.find((wrap)=>wrap.getAttribute('data-popup') === btnPopupId) || null;
    },
    removeHoverState () {
        window.addEventListener('mouseover', (event)=>{
            this.handleMouseOut(event);
        });
    },
    handleMouseOut (event) {
        const target = event.target;
        if (!this.isHoveredElement(target)) {
            this.clearOpenTimer();
            this.closePopups();
        }
    },
    isHoveredElement (target) {
        return [
            ...this.btns,
            ...this.wraps
        ].some((element)=>element === target || element.contains(target));
    },
    clearOpenTimer () {
        if (this.openTimer) {
            clearTimeout(this.openTimer);
            this.openTimer = null;
        }
    },
    setClosePopupListener () {
        if (this.overlay) this.overlay.addEventListener('click', ()=>{
            this.closePopups();
        });
        const closeButtons = document.querySelectorAll('.close-popup');
        closeButtons.forEach((closeBtn)=>{
            closeBtn.addEventListener('click', (event)=>{
                event.stopPropagation();
                this.closePopups();
            });
        });
    },
    closePopups () {
        this.clearOpenTimer();
        this.btns.forEach((btn)=>{
            btn.classList.remove('activeClass');
        });
        this.wraps.forEach((wrap)=>{
            wrap.classList.remove('activeClass');
        });
        if (this.overlay) this.overlay.classList.remove('activeClass');
    }
};
var $90d1518f9fdd1c26$export$2e2bcd8739ae039 = $90d1518f9fdd1c26$var$headerHoverPopups;


const $2f802d016426be0c$var$megamenu = {
    init () {
        this.setMegamenu();
    },
    setMegamenu () {
        document.addEventListener('DOMContentLoaded', ()=>{
            const sublists = document.querySelectorAll('.desk-nav__sublist-list');
            sublists.forEach((ul)=>{
                if (ul.dataset.megamenuReady === 'true') return;
                ul.dataset.megamenuReady = 'true';
                const levelTwoItems = Array.from(ul.querySelectorAll('.desk-nav__subitem--lvl2'));
                if (levelTwoItems.length <= 1) return;
                const hasNested = levelTwoItems.some((li)=>li.querySelector('ul'));
                const columns = hasNested ? 6 : 4;
                const perColumn = Math.ceil(levelTwoItems.length / columns);
                ul.innerHTML = '';
                for(let i = 0; i < columns; i++){
                    const columnItems = levelTwoItems.slice(i * perColumn, (i + 1) * perColumn);
                    if (!columnItems.length) continue;
                    const columnWrapper = document.createElement('li');
                    columnWrapper.className = 'desk-nav__column';
                    columnItems.forEach((li)=>{
                        columnWrapper.appendChild(li);
                    });
                    ul.appendChild(columnWrapper);
                }
            });
        });
    }
};
var $2f802d016426be0c$export$2e2bcd8739ae039 = $2f802d016426be0c$var$megamenu;


function $ca9ce22b174df7eb$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $ca9ce22b174df7eb$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $ca9ce22b174df7eb$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $ca9ce22b174df7eb$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
/*!
 * Splide.js
 * Version  : 4.1.4
 * License  : MIT
 * Copyright: 2022 Naotoshi Fujita
 */ var $ca9ce22b174df7eb$var$MEDIA_PREFERS_REDUCED_MOTION = "(prefers-reduced-motion: reduce)";
var $ca9ce22b174df7eb$var$CREATED = 1;
var $ca9ce22b174df7eb$var$MOUNTED = 2;
var $ca9ce22b174df7eb$var$IDLE = 3;
var $ca9ce22b174df7eb$var$MOVING = 4;
var $ca9ce22b174df7eb$var$SCROLLING = 5;
var $ca9ce22b174df7eb$var$DRAGGING = 6;
var $ca9ce22b174df7eb$var$DESTROYED = 7;
var $ca9ce22b174df7eb$var$STATES = {
    CREATED: $ca9ce22b174df7eb$var$CREATED,
    MOUNTED: $ca9ce22b174df7eb$var$MOUNTED,
    IDLE: $ca9ce22b174df7eb$var$IDLE,
    MOVING: $ca9ce22b174df7eb$var$MOVING,
    SCROLLING: $ca9ce22b174df7eb$var$SCROLLING,
    DRAGGING: $ca9ce22b174df7eb$var$DRAGGING,
    DESTROYED: $ca9ce22b174df7eb$var$DESTROYED
};
function $ca9ce22b174df7eb$var$empty(array) {
    array.length = 0;
}
function $ca9ce22b174df7eb$var$slice(arrayLike, start, end) {
    return Array.prototype.slice.call(arrayLike, start, end);
}
function $ca9ce22b174df7eb$var$apply(func) {
    return func.bind.apply(func, [
        null
    ].concat($ca9ce22b174df7eb$var$slice(arguments, 1)));
}
var $ca9ce22b174df7eb$var$nextTick = setTimeout;
var $ca9ce22b174df7eb$var$noop = function noop() {};
function $ca9ce22b174df7eb$var$raf(func) {
    return requestAnimationFrame(func);
}
function $ca9ce22b174df7eb$var$typeOf(type, subject) {
    return typeof subject === type;
}
function $ca9ce22b174df7eb$var$isObject(subject) {
    return !$ca9ce22b174df7eb$var$isNull(subject) && $ca9ce22b174df7eb$var$typeOf("object", subject);
}
var $ca9ce22b174df7eb$var$isArray = Array.isArray;
var $ca9ce22b174df7eb$var$isFunction = $ca9ce22b174df7eb$var$apply($ca9ce22b174df7eb$var$typeOf, "function");
var $ca9ce22b174df7eb$var$isString = $ca9ce22b174df7eb$var$apply($ca9ce22b174df7eb$var$typeOf, "string");
var $ca9ce22b174df7eb$var$isUndefined = $ca9ce22b174df7eb$var$apply($ca9ce22b174df7eb$var$typeOf, "undefined");
function $ca9ce22b174df7eb$var$isNull(subject) {
    return subject === null;
}
function $ca9ce22b174df7eb$var$isHTMLElement(subject) {
    try {
        return subject instanceof (subject.ownerDocument.defaultView || window).HTMLElement;
    } catch (e) {
        return false;
    }
}
function $ca9ce22b174df7eb$var$toArray(value) {
    return $ca9ce22b174df7eb$var$isArray(value) ? value : [
        value
    ];
}
function $ca9ce22b174df7eb$var$forEach(values, iteratee) {
    $ca9ce22b174df7eb$var$toArray(values).forEach(iteratee);
}
function $ca9ce22b174df7eb$var$includes(array, value) {
    return array.indexOf(value) > -1;
}
function $ca9ce22b174df7eb$var$push(array, items) {
    array.push.apply(array, $ca9ce22b174df7eb$var$toArray(items));
    return array;
}
function $ca9ce22b174df7eb$var$toggleClass(elm, classes, add) {
    if (elm) $ca9ce22b174df7eb$var$forEach(classes, function(name) {
        if (name) elm.classList[add ? "add" : "remove"](name);
    });
}
function $ca9ce22b174df7eb$var$addClass(elm, classes) {
    $ca9ce22b174df7eb$var$toggleClass(elm, $ca9ce22b174df7eb$var$isString(classes) ? classes.split(" ") : classes, true);
}
function $ca9ce22b174df7eb$var$append(parent, children) {
    $ca9ce22b174df7eb$var$forEach(children, parent.appendChild.bind(parent));
}
function $ca9ce22b174df7eb$var$before(nodes, ref) {
    $ca9ce22b174df7eb$var$forEach(nodes, function(node) {
        var parent = (ref || node).parentNode;
        if (parent) parent.insertBefore(node, ref);
    });
}
function $ca9ce22b174df7eb$var$matches(elm, selector) {
    return $ca9ce22b174df7eb$var$isHTMLElement(elm) && (elm["msMatchesSelector"] || elm.matches).call(elm, selector);
}
function $ca9ce22b174df7eb$var$children(parent, selector) {
    var children2 = parent ? $ca9ce22b174df7eb$var$slice(parent.children) : [];
    return selector ? children2.filter(function(child) {
        return $ca9ce22b174df7eb$var$matches(child, selector);
    }) : children2;
}
function $ca9ce22b174df7eb$var$child(parent, selector) {
    return selector ? $ca9ce22b174df7eb$var$children(parent, selector)[0] : parent.firstElementChild;
}
var $ca9ce22b174df7eb$var$ownKeys = Object.keys;
function $ca9ce22b174df7eb$var$forOwn(object, iteratee, right) {
    if (object) (right ? $ca9ce22b174df7eb$var$ownKeys(object).reverse() : $ca9ce22b174df7eb$var$ownKeys(object)).forEach(function(key) {
        key !== "__proto__" && iteratee(object[key], key);
    });
    return object;
}
function $ca9ce22b174df7eb$var$assign(object) {
    $ca9ce22b174df7eb$var$slice(arguments, 1).forEach(function(source) {
        $ca9ce22b174df7eb$var$forOwn(source, function(value, key) {
            object[key] = source[key];
        });
    });
    return object;
}
function $ca9ce22b174df7eb$var$merge(object) {
    $ca9ce22b174df7eb$var$slice(arguments, 1).forEach(function(source) {
        $ca9ce22b174df7eb$var$forOwn(source, function(value, key) {
            if ($ca9ce22b174df7eb$var$isArray(value)) object[key] = value.slice();
            else if ($ca9ce22b174df7eb$var$isObject(value)) object[key] = $ca9ce22b174df7eb$var$merge({}, $ca9ce22b174df7eb$var$isObject(object[key]) ? object[key] : {}, value);
            else object[key] = value;
        });
    });
    return object;
}
function $ca9ce22b174df7eb$var$omit(object, keys) {
    $ca9ce22b174df7eb$var$forEach(keys || $ca9ce22b174df7eb$var$ownKeys(object), function(key) {
        delete object[key];
    });
}
function $ca9ce22b174df7eb$var$removeAttribute(elms, attrs) {
    $ca9ce22b174df7eb$var$forEach(elms, function(elm) {
        $ca9ce22b174df7eb$var$forEach(attrs, function(attr) {
            elm && elm.removeAttribute(attr);
        });
    });
}
function $ca9ce22b174df7eb$var$setAttribute(elms, attrs, value) {
    if ($ca9ce22b174df7eb$var$isObject(attrs)) $ca9ce22b174df7eb$var$forOwn(attrs, function(value2, name) {
        $ca9ce22b174df7eb$var$setAttribute(elms, name, value2);
    });
    else $ca9ce22b174df7eb$var$forEach(elms, function(elm) {
        $ca9ce22b174df7eb$var$isNull(value) || value === "" ? $ca9ce22b174df7eb$var$removeAttribute(elm, attrs) : elm.setAttribute(attrs, String(value));
    });
}
function $ca9ce22b174df7eb$var$create(tag, attrs, parent) {
    var elm = document.createElement(tag);
    if (attrs) $ca9ce22b174df7eb$var$isString(attrs) ? $ca9ce22b174df7eb$var$addClass(elm, attrs) : $ca9ce22b174df7eb$var$setAttribute(elm, attrs);
    parent && $ca9ce22b174df7eb$var$append(parent, elm);
    return elm;
}
function $ca9ce22b174df7eb$var$style(elm, prop, value) {
    if ($ca9ce22b174df7eb$var$isUndefined(value)) return getComputedStyle(elm)[prop];
    if (!$ca9ce22b174df7eb$var$isNull(value)) elm.style[prop] = "" + value;
}
function $ca9ce22b174df7eb$var$display(elm, display2) {
    $ca9ce22b174df7eb$var$style(elm, "display", display2);
}
function $ca9ce22b174df7eb$var$focus(elm) {
    elm["setActive"] && elm["setActive"]() || elm.focus({
        preventScroll: true
    });
}
function $ca9ce22b174df7eb$var$getAttribute(elm, attr) {
    return elm.getAttribute(attr);
}
function $ca9ce22b174df7eb$var$hasClass(elm, className) {
    return elm && elm.classList.contains(className);
}
function $ca9ce22b174df7eb$var$rect(target) {
    return target.getBoundingClientRect();
}
function $ca9ce22b174df7eb$var$remove(nodes) {
    $ca9ce22b174df7eb$var$forEach(nodes, function(node) {
        if (node && node.parentNode) node.parentNode.removeChild(node);
    });
}
function $ca9ce22b174df7eb$var$parseHtml(html) {
    return $ca9ce22b174df7eb$var$child(new DOMParser().parseFromString(html, "text/html").body);
}
function $ca9ce22b174df7eb$var$prevent(e, stopPropagation) {
    e.preventDefault();
    if (stopPropagation) {
        e.stopPropagation();
        e.stopImmediatePropagation();
    }
}
function $ca9ce22b174df7eb$var$query(parent, selector) {
    return parent && parent.querySelector(selector);
}
function $ca9ce22b174df7eb$var$queryAll(parent, selector) {
    return selector ? $ca9ce22b174df7eb$var$slice(parent.querySelectorAll(selector)) : [];
}
function $ca9ce22b174df7eb$var$removeClass(elm, classes) {
    $ca9ce22b174df7eb$var$toggleClass(elm, classes, false);
}
function $ca9ce22b174df7eb$var$timeOf(e) {
    return e.timeStamp;
}
function $ca9ce22b174df7eb$var$unit(value) {
    return $ca9ce22b174df7eb$var$isString(value) ? value : value ? value + "px" : "";
}
var $ca9ce22b174df7eb$var$PROJECT_CODE = "splide";
var $ca9ce22b174df7eb$var$DATA_ATTRIBUTE = "data-" + $ca9ce22b174df7eb$var$PROJECT_CODE;
function $ca9ce22b174df7eb$var$assert(condition, message) {
    if (!condition) throw new Error("[" + $ca9ce22b174df7eb$var$PROJECT_CODE + "] " + (message || ""));
}
var $ca9ce22b174df7eb$var$min = Math.min, $ca9ce22b174df7eb$var$max = Math.max, $ca9ce22b174df7eb$var$floor = Math.floor, $ca9ce22b174df7eb$var$ceil = Math.ceil, $ca9ce22b174df7eb$var$abs = Math.abs;
function $ca9ce22b174df7eb$var$approximatelyEqual(x, y, epsilon) {
    return $ca9ce22b174df7eb$var$abs(x - y) < epsilon;
}
function $ca9ce22b174df7eb$var$between(number, x, y, exclusive) {
    var minimum = $ca9ce22b174df7eb$var$min(x, y);
    var maximum = $ca9ce22b174df7eb$var$max(x, y);
    return exclusive ? minimum < number && number < maximum : minimum <= number && number <= maximum;
}
function $ca9ce22b174df7eb$var$clamp(number, x, y) {
    var minimum = $ca9ce22b174df7eb$var$min(x, y);
    var maximum = $ca9ce22b174df7eb$var$max(x, y);
    return $ca9ce22b174df7eb$var$min($ca9ce22b174df7eb$var$max(minimum, number), maximum);
}
function $ca9ce22b174df7eb$var$sign(x) {
    return +(x > 0) - +(x < 0);
}
function $ca9ce22b174df7eb$var$camelToKebab(string) {
    return string.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
}
function $ca9ce22b174df7eb$var$format(string, replacements) {
    $ca9ce22b174df7eb$var$forEach(replacements, function(replacement) {
        string = string.replace("%s", "" + replacement);
    });
    return string;
}
function $ca9ce22b174df7eb$var$pad(number) {
    return number < 10 ? "0" + number : "" + number;
}
var $ca9ce22b174df7eb$var$ids = {};
function $ca9ce22b174df7eb$var$uniqueId(prefix) {
    return "" + prefix + $ca9ce22b174df7eb$var$pad($ca9ce22b174df7eb$var$ids[prefix] = ($ca9ce22b174df7eb$var$ids[prefix] || 0) + 1);
}
function $ca9ce22b174df7eb$export$c473e36ef1bda729() {
    var listeners = [];
    function bind(targets, events, callback, options) {
        forEachEvent(targets, events, function(target, event, namespace) {
            var isEventTarget = "addEventListener" in target;
            var remover = isEventTarget ? target.removeEventListener.bind(target, event, callback, options) : target["removeListener"].bind(target, callback);
            isEventTarget ? target.addEventListener(event, callback, options) : target["addListener"](callback);
            listeners.push([
                target,
                event,
                namespace,
                callback,
                remover
            ]);
        });
    }
    function unbind(targets, events, callback) {
        forEachEvent(targets, events, function(target, event, namespace) {
            listeners = listeners.filter(function(listener) {
                if (listener[0] === target && listener[1] === event && listener[2] === namespace && (!callback || listener[3] === callback)) {
                    listener[4]();
                    return false;
                }
                return true;
            });
        });
    }
    function dispatch(target, type, detail) {
        var e;
        var bubbles = true;
        if (typeof CustomEvent === "function") e = new CustomEvent(type, {
            bubbles: bubbles,
            detail: detail
        });
        else {
            e = document.createEvent("CustomEvent");
            e.initCustomEvent(type, bubbles, false, detail);
        }
        target.dispatchEvent(e);
        return e;
    }
    function forEachEvent(targets, events, iteratee) {
        $ca9ce22b174df7eb$var$forEach(targets, function(target) {
            target && $ca9ce22b174df7eb$var$forEach(events, function(events2) {
                events2.split(" ").forEach(function(eventNS) {
                    var fragment = eventNS.split(".");
                    iteratee(target, fragment[0], fragment[1]);
                });
            });
        });
    }
    function destroy() {
        listeners.forEach(function(data) {
            data[4]();
        });
        $ca9ce22b174df7eb$var$empty(listeners);
    }
    return {
        bind: bind,
        unbind: unbind,
        dispatch: dispatch,
        destroy: destroy
    };
}
var $ca9ce22b174df7eb$export$d300dc1a2634364b = "mounted";
var $ca9ce22b174df7eb$export$d8dac49b4532735a = "ready";
var $ca9ce22b174df7eb$export$2aa493d7c3275167 = "move";
var $ca9ce22b174df7eb$export$fe5802204b967f0d = "moved";
var $ca9ce22b174df7eb$export$5adb665701eda1ce = "click";
var $ca9ce22b174df7eb$export$92e3eae133acac4c = "active";
var $ca9ce22b174df7eb$export$6bcbb81035c12cea = "inactive";
var $ca9ce22b174df7eb$export$6a5b3445e4066a53 = "visible";
var $ca9ce22b174df7eb$export$8c5c7a21d54563e9 = "hidden";
var $ca9ce22b174df7eb$export$7f4701ac5e05e39f = "refresh";
var $ca9ce22b174df7eb$export$db40ab7c0855fa5c = "updated";
var $ca9ce22b174df7eb$export$7e019dae5103a285 = "resize";
var $ca9ce22b174df7eb$export$d637eba1e9e28482 = "resized";
var $ca9ce22b174df7eb$export$e84bf5065c9087ac = "drag";
var $ca9ce22b174df7eb$export$8e9f636d2c722196 = "dragging";
var $ca9ce22b174df7eb$export$90ea576bd3fdeb60 = "dragged";
var $ca9ce22b174df7eb$export$49801896908b5e33 = "scroll";
var $ca9ce22b174df7eb$export$ff8164bff3202b9 = "scrolled";
var $ca9ce22b174df7eb$export$6cbac5b662a31e1b = "overflow";
var $ca9ce22b174df7eb$export$88c4cf7419e470cd = "destroy";
var $ca9ce22b174df7eb$export$8647f6b043e04e9d = "arrows:mounted";
var $ca9ce22b174df7eb$export$d467f9343b961f75 = "arrows:updated";
var $ca9ce22b174df7eb$export$bf89a4e4349c9778 = "pagination:mounted";
var $ca9ce22b174df7eb$export$eb2019082ed6de0b = "pagination:updated";
var $ca9ce22b174df7eb$export$84015c33508f94ec = "navigation:mounted";
var $ca9ce22b174df7eb$export$23663268a31b79e2 = "autoplay:play";
var $ca9ce22b174df7eb$export$185723258309b608 = "autoplay:playing";
var $ca9ce22b174df7eb$export$16a1e4f3d0368265 = "autoplay:pause";
var $ca9ce22b174df7eb$export$9f64346e17f0ec8e = "lazyload:loaded";
var $ca9ce22b174df7eb$export$6d5af59619d10e6a = "sk";
var $ca9ce22b174df7eb$export$f0af896383d5adff = "sh";
var $ca9ce22b174df7eb$export$28dea85f216954dc = "ei";
function $ca9ce22b174df7eb$export$f188226459c8a3ff(Splide2) {
    var bus = Splide2 ? Splide2.event.bus : document.createDocumentFragment();
    var binder = $ca9ce22b174df7eb$export$c473e36ef1bda729();
    function on(events, callback) {
        binder.bind(bus, $ca9ce22b174df7eb$var$toArray(events).join(" "), function(e) {
            callback.apply(callback, $ca9ce22b174df7eb$var$isArray(e.detail) ? e.detail : []);
        });
    }
    function emit(event) {
        binder.dispatch(bus, event, $ca9ce22b174df7eb$var$slice(arguments, 1));
    }
    if (Splide2) Splide2.event.on($ca9ce22b174df7eb$export$88c4cf7419e470cd, binder.destroy);
    return $ca9ce22b174df7eb$var$assign(binder, {
        bus: bus,
        on: on,
        off: $ca9ce22b174df7eb$var$apply(binder.unbind, bus),
        emit: emit
    });
}
function $ca9ce22b174df7eb$export$46ad21b25b6dccf0(interval, onInterval, onUpdate, limit) {
    var now = Date.now;
    var startTime;
    var rate = 0;
    var id;
    var paused = true;
    var count = 0;
    function update() {
        if (!paused) {
            rate = interval ? $ca9ce22b174df7eb$var$min((now() - startTime) / interval, 1) : 1;
            onUpdate && onUpdate(rate);
            if (rate >= 1) {
                onInterval();
                startTime = now();
                if (limit && ++count >= limit) return pause();
            }
            id = $ca9ce22b174df7eb$var$raf(update);
        }
    }
    function start(resume) {
        resume || cancel();
        startTime = now() - (resume ? rate * interval : 0);
        paused = false;
        id = $ca9ce22b174df7eb$var$raf(update);
    }
    function pause() {
        paused = true;
    }
    function rewind() {
        startTime = now();
        rate = 0;
        if (onUpdate) onUpdate(rate);
    }
    function cancel() {
        id && cancelAnimationFrame(id);
        rate = 0;
        id = 0;
        paused = true;
    }
    function set(time) {
        interval = time;
    }
    function isPaused() {
        return paused;
    }
    return {
        start: start,
        rewind: rewind,
        pause: pause,
        cancel: cancel,
        set: set,
        isPaused: isPaused
    };
}
function $ca9ce22b174df7eb$export$7254cc27399e90bd(initialState) {
    var state = initialState;
    function set(value) {
        state = value;
    }
    function is(states) {
        return $ca9ce22b174df7eb$var$includes($ca9ce22b174df7eb$var$toArray(states), state);
    }
    return {
        set: set,
        is: is
    };
}
function $ca9ce22b174df7eb$export$efff0f5979573c99(func, duration) {
    var interval = $ca9ce22b174df7eb$export$46ad21b25b6dccf0(duration || 0, func, null, 1);
    return function() {
        interval.isPaused() && interval.start();
    };
}
function $ca9ce22b174df7eb$var$Media(Splide2, Components2, options) {
    var state = Splide2.state;
    var breakpoints = options.breakpoints || {};
    var reducedMotion = options.reducedMotion || {};
    var binder = $ca9ce22b174df7eb$export$c473e36ef1bda729();
    var queries = [];
    function setup() {
        var isMin = options.mediaQuery === "min";
        $ca9ce22b174df7eb$var$ownKeys(breakpoints).sort(function(n, m) {
            return isMin ? +n - +m : +m - +n;
        }).forEach(function(key) {
            register(breakpoints[key], "(" + (isMin ? "min" : "max") + "-width:" + key + "px)");
        });
        register(reducedMotion, $ca9ce22b174df7eb$var$MEDIA_PREFERS_REDUCED_MOTION);
        update();
    }
    function destroy(completely) {
        if (completely) binder.destroy();
    }
    function register(options2, query) {
        var queryList = matchMedia(query);
        binder.bind(queryList, "change", update);
        queries.push([
            options2,
            queryList
        ]);
    }
    function update() {
        var destroyed = state.is($ca9ce22b174df7eb$var$DESTROYED);
        var direction = options.direction;
        var merged = queries.reduce(function(merged2, entry) {
            return $ca9ce22b174df7eb$var$merge(merged2, entry[1].matches ? entry[0] : {});
        }, {});
        $ca9ce22b174df7eb$var$omit(options);
        set(merged);
        if (options.destroy) Splide2.destroy(options.destroy === "completely");
        else if (destroyed) {
            destroy(true);
            Splide2.mount();
        } else direction !== options.direction && Splide2.refresh();
    }
    function reduce(enable) {
        if (matchMedia($ca9ce22b174df7eb$var$MEDIA_PREFERS_REDUCED_MOTION).matches) enable ? $ca9ce22b174df7eb$var$merge(options, reducedMotion) : $ca9ce22b174df7eb$var$omit(options, $ca9ce22b174df7eb$var$ownKeys(reducedMotion));
    }
    function set(opts, base, notify) {
        $ca9ce22b174df7eb$var$merge(options, opts);
        base && $ca9ce22b174df7eb$var$merge(Object.getPrototypeOf(options), opts);
        if (notify || !state.is($ca9ce22b174df7eb$var$CREATED)) Splide2.emit($ca9ce22b174df7eb$export$db40ab7c0855fa5c, options);
    }
    return {
        setup: setup,
        destroy: destroy,
        reduce: reduce,
        set: set
    };
}
var $ca9ce22b174df7eb$var$ARROW = "Arrow";
var $ca9ce22b174df7eb$var$ARROW_LEFT = $ca9ce22b174df7eb$var$ARROW + "Left";
var $ca9ce22b174df7eb$var$ARROW_RIGHT = $ca9ce22b174df7eb$var$ARROW + "Right";
var $ca9ce22b174df7eb$var$ARROW_UP = $ca9ce22b174df7eb$var$ARROW + "Up";
var $ca9ce22b174df7eb$var$ARROW_DOWN = $ca9ce22b174df7eb$var$ARROW + "Down";
var $ca9ce22b174df7eb$export$373e92e0788ff06e = "ltr";
var $ca9ce22b174df7eb$export$850f7749a2909601 = "rtl";
var $ca9ce22b174df7eb$export$97170d9824b89709 = "ttb";
var $ca9ce22b174df7eb$var$ORIENTATION_MAP = {
    width: [
        "height"
    ],
    left: [
        "top",
        "right"
    ],
    right: [
        "bottom",
        "left"
    ],
    x: [
        "y"
    ],
    X: [
        "Y"
    ],
    Y: [
        "X"
    ],
    ArrowLeft: [
        $ca9ce22b174df7eb$var$ARROW_UP,
        $ca9ce22b174df7eb$var$ARROW_RIGHT
    ],
    ArrowRight: [
        $ca9ce22b174df7eb$var$ARROW_DOWN,
        $ca9ce22b174df7eb$var$ARROW_LEFT
    ]
};
function $ca9ce22b174df7eb$var$Direction(Splide2, Components2, options) {
    function resolve(prop, axisOnly, direction) {
        direction = direction || options.direction;
        var index = direction === $ca9ce22b174df7eb$export$850f7749a2909601 && !axisOnly ? 1 : direction === $ca9ce22b174df7eb$export$97170d9824b89709 ? 0 : -1;
        return $ca9ce22b174df7eb$var$ORIENTATION_MAP[prop] && $ca9ce22b174df7eb$var$ORIENTATION_MAP[prop][index] || prop.replace(/width|left|right/i, function(match, offset) {
            var replacement = $ca9ce22b174df7eb$var$ORIENTATION_MAP[match.toLowerCase()][index] || match;
            return offset > 0 ? replacement.charAt(0).toUpperCase() + replacement.slice(1) : replacement;
        });
    }
    function orient(value) {
        return value * (options.direction === $ca9ce22b174df7eb$export$850f7749a2909601 ? 1 : -1);
    }
    return {
        resolve: resolve,
        orient: orient
    };
}
var $ca9ce22b174df7eb$var$ROLE = "role";
var $ca9ce22b174df7eb$var$TAB_INDEX = "tabindex";
var $ca9ce22b174df7eb$var$DISABLED = "disabled";
var $ca9ce22b174df7eb$var$ARIA_PREFIX = "aria-";
var $ca9ce22b174df7eb$var$ARIA_CONTROLS = $ca9ce22b174df7eb$var$ARIA_PREFIX + "controls";
var $ca9ce22b174df7eb$var$ARIA_CURRENT = $ca9ce22b174df7eb$var$ARIA_PREFIX + "current";
var $ca9ce22b174df7eb$var$ARIA_SELECTED = $ca9ce22b174df7eb$var$ARIA_PREFIX + "selected";
var $ca9ce22b174df7eb$var$ARIA_LABEL = $ca9ce22b174df7eb$var$ARIA_PREFIX + "label";
var $ca9ce22b174df7eb$var$ARIA_LABELLEDBY = $ca9ce22b174df7eb$var$ARIA_PREFIX + "labelledby";
var $ca9ce22b174df7eb$var$ARIA_HIDDEN = $ca9ce22b174df7eb$var$ARIA_PREFIX + "hidden";
var $ca9ce22b174df7eb$var$ARIA_ORIENTATION = $ca9ce22b174df7eb$var$ARIA_PREFIX + "orientation";
var $ca9ce22b174df7eb$var$ARIA_ROLEDESCRIPTION = $ca9ce22b174df7eb$var$ARIA_PREFIX + "roledescription";
var $ca9ce22b174df7eb$var$ARIA_LIVE = $ca9ce22b174df7eb$var$ARIA_PREFIX + "live";
var $ca9ce22b174df7eb$var$ARIA_BUSY = $ca9ce22b174df7eb$var$ARIA_PREFIX + "busy";
var $ca9ce22b174df7eb$var$ARIA_ATOMIC = $ca9ce22b174df7eb$var$ARIA_PREFIX + "atomic";
var $ca9ce22b174df7eb$var$ALL_ATTRIBUTES = [
    $ca9ce22b174df7eb$var$ROLE,
    $ca9ce22b174df7eb$var$TAB_INDEX,
    $ca9ce22b174df7eb$var$DISABLED,
    $ca9ce22b174df7eb$var$ARIA_CONTROLS,
    $ca9ce22b174df7eb$var$ARIA_CURRENT,
    $ca9ce22b174df7eb$var$ARIA_LABEL,
    $ca9ce22b174df7eb$var$ARIA_LABELLEDBY,
    $ca9ce22b174df7eb$var$ARIA_HIDDEN,
    $ca9ce22b174df7eb$var$ARIA_ORIENTATION,
    $ca9ce22b174df7eb$var$ARIA_ROLEDESCRIPTION
];
var $ca9ce22b174df7eb$var$CLASS_PREFIX = $ca9ce22b174df7eb$var$PROJECT_CODE + "__";
var $ca9ce22b174df7eb$var$STATUS_CLASS_PREFIX = "is-";
var $ca9ce22b174df7eb$export$93b21159ad85c843 = $ca9ce22b174df7eb$var$PROJECT_CODE;
var $ca9ce22b174df7eb$export$7738b09ac0a98952 = $ca9ce22b174df7eb$var$CLASS_PREFIX + "track";
var $ca9ce22b174df7eb$export$19cc2a5451235cae = $ca9ce22b174df7eb$var$CLASS_PREFIX + "list";
var $ca9ce22b174df7eb$export$8d922915837a38d3 = $ca9ce22b174df7eb$var$CLASS_PREFIX + "slide";
var $ca9ce22b174df7eb$export$2c1ba4a4f1aa4947 = $ca9ce22b174df7eb$export$8d922915837a38d3 + "--clone";
var $ca9ce22b174df7eb$export$e9ba7e444ba60a12 = $ca9ce22b174df7eb$export$8d922915837a38d3 + "__container";
var $ca9ce22b174df7eb$export$a26cbd955fecf11e = $ca9ce22b174df7eb$var$CLASS_PREFIX + "arrows";
var $ca9ce22b174df7eb$export$516e7d18e13a2dca = $ca9ce22b174df7eb$var$CLASS_PREFIX + "arrow";
var $ca9ce22b174df7eb$export$58ea3db24c33b76 = $ca9ce22b174df7eb$export$516e7d18e13a2dca + "--prev";
var $ca9ce22b174df7eb$export$4885afd7098a65c2 = $ca9ce22b174df7eb$export$516e7d18e13a2dca + "--next";
var $ca9ce22b174df7eb$export$cbf8e5a0ab95eda3 = $ca9ce22b174df7eb$var$CLASS_PREFIX + "pagination";
var $ca9ce22b174df7eb$export$52f2cca6a5eee805 = $ca9ce22b174df7eb$export$cbf8e5a0ab95eda3 + "__page";
var $ca9ce22b174df7eb$export$4c82dc32b1c4ace5 = $ca9ce22b174df7eb$var$CLASS_PREFIX + "progress";
var $ca9ce22b174df7eb$export$2c9b091c749f4409 = $ca9ce22b174df7eb$export$4c82dc32b1c4ace5 + "__bar";
var $ca9ce22b174df7eb$export$a29701deef84b825 = $ca9ce22b174df7eb$var$CLASS_PREFIX + "toggle";
var $ca9ce22b174df7eb$export$d9d247d51b430dbb = $ca9ce22b174df7eb$export$a29701deef84b825 + "__play";
var $ca9ce22b174df7eb$export$3529f201a419925b = $ca9ce22b174df7eb$export$a29701deef84b825 + "__pause";
var $ca9ce22b174df7eb$export$3e5381ee3fab8374 = $ca9ce22b174df7eb$var$CLASS_PREFIX + "spinner";
var $ca9ce22b174df7eb$export$bb78d7c200da8960 = $ca9ce22b174df7eb$var$CLASS_PREFIX + "sr";
var $ca9ce22b174df7eb$export$7761661e2d5b9388 = $ca9ce22b174df7eb$var$STATUS_CLASS_PREFIX + "initialized";
var $ca9ce22b174df7eb$export$72d36ecf3758cb4b = $ca9ce22b174df7eb$var$STATUS_CLASS_PREFIX + "active";
var $ca9ce22b174df7eb$export$e423ac4972f5e196 = $ca9ce22b174df7eb$var$STATUS_CLASS_PREFIX + "prev";
var $ca9ce22b174df7eb$export$457a2d20827a2779 = $ca9ce22b174df7eb$var$STATUS_CLASS_PREFIX + "next";
var $ca9ce22b174df7eb$export$53ca4621bbab9a = $ca9ce22b174df7eb$var$STATUS_CLASS_PREFIX + "visible";
var $ca9ce22b174df7eb$export$d22ec4ccb7996ba2 = $ca9ce22b174df7eb$var$STATUS_CLASS_PREFIX + "loading";
var $ca9ce22b174df7eb$export$b6f202a162a09100 = $ca9ce22b174df7eb$var$STATUS_CLASS_PREFIX + "focus-in";
var $ca9ce22b174df7eb$export$cd908cd1dd625e29 = $ca9ce22b174df7eb$var$STATUS_CLASS_PREFIX + "overflow";
var $ca9ce22b174df7eb$export$49f9eaea10ebf193 = [
    $ca9ce22b174df7eb$export$72d36ecf3758cb4b,
    $ca9ce22b174df7eb$export$53ca4621bbab9a,
    $ca9ce22b174df7eb$export$e423ac4972f5e196,
    $ca9ce22b174df7eb$export$457a2d20827a2779,
    $ca9ce22b174df7eb$export$d22ec4ccb7996ba2,
    $ca9ce22b174df7eb$export$b6f202a162a09100,
    $ca9ce22b174df7eb$export$cd908cd1dd625e29
];
var $ca9ce22b174df7eb$export$ba41d43e4a419565 = {
    slide: $ca9ce22b174df7eb$export$8d922915837a38d3,
    clone: $ca9ce22b174df7eb$export$2c1ba4a4f1aa4947,
    arrows: $ca9ce22b174df7eb$export$a26cbd955fecf11e,
    arrow: $ca9ce22b174df7eb$export$516e7d18e13a2dca,
    prev: $ca9ce22b174df7eb$export$58ea3db24c33b76,
    next: $ca9ce22b174df7eb$export$4885afd7098a65c2,
    pagination: $ca9ce22b174df7eb$export$cbf8e5a0ab95eda3,
    page: $ca9ce22b174df7eb$export$52f2cca6a5eee805,
    spinner: $ca9ce22b174df7eb$export$3e5381ee3fab8374
};
function $ca9ce22b174df7eb$var$closest(from, selector) {
    if ($ca9ce22b174df7eb$var$isFunction(from.closest)) return from.closest(selector);
    var elm = from;
    while(elm && elm.nodeType === 1){
        if ($ca9ce22b174df7eb$var$matches(elm, selector)) break;
        elm = elm.parentElement;
    }
    return elm;
}
var $ca9ce22b174df7eb$var$FRICTION = 5;
var $ca9ce22b174df7eb$var$LOG_INTERVAL = 200;
var $ca9ce22b174df7eb$var$POINTER_DOWN_EVENTS = "touchstart mousedown";
var $ca9ce22b174df7eb$var$POINTER_MOVE_EVENTS = "touchmove mousemove";
var $ca9ce22b174df7eb$var$POINTER_UP_EVENTS = "touchend touchcancel mouseup click";
function $ca9ce22b174df7eb$var$Elements(Splide2, Components2, options) {
    var _EventInterface = $ca9ce22b174df7eb$export$f188226459c8a3ff(Splide2), on = _EventInterface.on, bind = _EventInterface.bind;
    var root = Splide2.root;
    var i18n = options.i18n;
    var elements = {};
    var slides = [];
    var rootClasses = [];
    var trackClasses = [];
    var track;
    var list;
    var isUsingKey;
    function setup() {
        collect();
        init();
        update();
    }
    function mount() {
        on($ca9ce22b174df7eb$export$7f4701ac5e05e39f, destroy);
        on($ca9ce22b174df7eb$export$7f4701ac5e05e39f, setup);
        on($ca9ce22b174df7eb$export$db40ab7c0855fa5c, update);
        bind(document, $ca9ce22b174df7eb$var$POINTER_DOWN_EVENTS + " keydown", function(e) {
            isUsingKey = e.type === "keydown";
        }, {
            capture: true
        });
        bind(root, "focusin", function() {
            $ca9ce22b174df7eb$var$toggleClass(root, $ca9ce22b174df7eb$export$b6f202a162a09100, !!isUsingKey);
        });
    }
    function destroy(completely) {
        var attrs = $ca9ce22b174df7eb$var$ALL_ATTRIBUTES.concat("style");
        $ca9ce22b174df7eb$var$empty(slides);
        $ca9ce22b174df7eb$var$removeClass(root, rootClasses);
        $ca9ce22b174df7eb$var$removeClass(track, trackClasses);
        $ca9ce22b174df7eb$var$removeAttribute([
            track,
            list
        ], attrs);
        $ca9ce22b174df7eb$var$removeAttribute(root, completely ? attrs : [
            "style",
            $ca9ce22b174df7eb$var$ARIA_ROLEDESCRIPTION
        ]);
    }
    function update() {
        $ca9ce22b174df7eb$var$removeClass(root, rootClasses);
        $ca9ce22b174df7eb$var$removeClass(track, trackClasses);
        rootClasses = getClasses($ca9ce22b174df7eb$export$93b21159ad85c843);
        trackClasses = getClasses($ca9ce22b174df7eb$export$7738b09ac0a98952);
        $ca9ce22b174df7eb$var$addClass(root, rootClasses);
        $ca9ce22b174df7eb$var$addClass(track, trackClasses);
        $ca9ce22b174df7eb$var$setAttribute(root, $ca9ce22b174df7eb$var$ARIA_LABEL, options.label);
        $ca9ce22b174df7eb$var$setAttribute(root, $ca9ce22b174df7eb$var$ARIA_LABELLEDBY, options.labelledby);
    }
    function collect() {
        track = find("." + $ca9ce22b174df7eb$export$7738b09ac0a98952);
        list = $ca9ce22b174df7eb$var$child(track, "." + $ca9ce22b174df7eb$export$19cc2a5451235cae);
        $ca9ce22b174df7eb$var$assert(track && list, "A track/list element is missing.");
        $ca9ce22b174df7eb$var$push(slides, $ca9ce22b174df7eb$var$children(list, "." + $ca9ce22b174df7eb$export$8d922915837a38d3 + ":not(." + $ca9ce22b174df7eb$export$2c1ba4a4f1aa4947 + ")"));
        $ca9ce22b174df7eb$var$forOwn({
            arrows: $ca9ce22b174df7eb$export$a26cbd955fecf11e,
            pagination: $ca9ce22b174df7eb$export$cbf8e5a0ab95eda3,
            prev: $ca9ce22b174df7eb$export$58ea3db24c33b76,
            next: $ca9ce22b174df7eb$export$4885afd7098a65c2,
            bar: $ca9ce22b174df7eb$export$2c9b091c749f4409,
            toggle: $ca9ce22b174df7eb$export$a29701deef84b825
        }, function(className, key) {
            elements[key] = find("." + className);
        });
        $ca9ce22b174df7eb$var$assign(elements, {
            root: root,
            track: track,
            list: list,
            slides: slides
        });
    }
    function init() {
        var id = root.id || $ca9ce22b174df7eb$var$uniqueId($ca9ce22b174df7eb$var$PROJECT_CODE);
        var role = options.role;
        root.id = id;
        track.id = track.id || id + "-track";
        list.id = list.id || id + "-list";
        if (!$ca9ce22b174df7eb$var$getAttribute(root, $ca9ce22b174df7eb$var$ROLE) && root.tagName !== "SECTION" && role) $ca9ce22b174df7eb$var$setAttribute(root, $ca9ce22b174df7eb$var$ROLE, role);
        $ca9ce22b174df7eb$var$setAttribute(root, $ca9ce22b174df7eb$var$ARIA_ROLEDESCRIPTION, i18n.carousel);
        $ca9ce22b174df7eb$var$setAttribute(list, $ca9ce22b174df7eb$var$ROLE, "presentation");
    }
    function find(selector) {
        var elm = $ca9ce22b174df7eb$var$query(root, selector);
        return elm && $ca9ce22b174df7eb$var$closest(elm, "." + $ca9ce22b174df7eb$export$93b21159ad85c843) === root ? elm : void 0;
    }
    function getClasses(base) {
        return [
            base + "--" + options.type,
            base + "--" + options.direction,
            options.drag && base + "--draggable",
            options.isNavigation && base + "--nav",
            base === $ca9ce22b174df7eb$export$93b21159ad85c843 && $ca9ce22b174df7eb$export$72d36ecf3758cb4b
        ];
    }
    return $ca9ce22b174df7eb$var$assign(elements, {
        setup: setup,
        mount: mount,
        destroy: destroy
    });
}
var $ca9ce22b174df7eb$export$e5a58a5ee5b54c22 = "slide";
var $ca9ce22b174df7eb$export$f42383286ed1223d = "loop";
var $ca9ce22b174df7eb$export$742b62a5690c060 = "fade";
function $ca9ce22b174df7eb$var$Slide$1(Splide2, index, slideIndex, slide) {
    var event = $ca9ce22b174df7eb$export$f188226459c8a3ff(Splide2);
    var on = event.on, emit = event.emit, bind = event.bind;
    var Components = Splide2.Components, root = Splide2.root, options = Splide2.options;
    var isNavigation = options.isNavigation, updateOnMove = options.updateOnMove, i18n = options.i18n, pagination = options.pagination, slideFocus = options.slideFocus;
    var resolve = Components.Direction.resolve;
    var styles = $ca9ce22b174df7eb$var$getAttribute(slide, "style");
    var label = $ca9ce22b174df7eb$var$getAttribute(slide, $ca9ce22b174df7eb$var$ARIA_LABEL);
    var isClone = slideIndex > -1;
    var container = $ca9ce22b174df7eb$var$child(slide, "." + $ca9ce22b174df7eb$export$e9ba7e444ba60a12);
    var destroyed;
    function mount() {
        if (!isClone) {
            slide.id = root.id + "-slide" + $ca9ce22b174df7eb$var$pad(index + 1);
            $ca9ce22b174df7eb$var$setAttribute(slide, $ca9ce22b174df7eb$var$ROLE, pagination ? "tabpanel" : "group");
            $ca9ce22b174df7eb$var$setAttribute(slide, $ca9ce22b174df7eb$var$ARIA_ROLEDESCRIPTION, i18n.slide);
            $ca9ce22b174df7eb$var$setAttribute(slide, $ca9ce22b174df7eb$var$ARIA_LABEL, label || $ca9ce22b174df7eb$var$format(i18n.slideLabel, [
                index + 1,
                Splide2.length
            ]));
        }
        listen();
    }
    function listen() {
        bind(slide, "click", $ca9ce22b174df7eb$var$apply(emit, $ca9ce22b174df7eb$export$5adb665701eda1ce, self));
        bind(slide, "keydown", $ca9ce22b174df7eb$var$apply(emit, $ca9ce22b174df7eb$export$6d5af59619d10e6a, self));
        on([
            $ca9ce22b174df7eb$export$fe5802204b967f0d,
            $ca9ce22b174df7eb$export$f0af896383d5adff,
            $ca9ce22b174df7eb$export$ff8164bff3202b9
        ], update);
        on($ca9ce22b174df7eb$export$84015c33508f94ec, initNavigation);
        if (updateOnMove) on($ca9ce22b174df7eb$export$2aa493d7c3275167, onMove);
    }
    function destroy() {
        destroyed = true;
        event.destroy();
        $ca9ce22b174df7eb$var$removeClass(slide, $ca9ce22b174df7eb$export$49f9eaea10ebf193);
        $ca9ce22b174df7eb$var$removeAttribute(slide, $ca9ce22b174df7eb$var$ALL_ATTRIBUTES);
        $ca9ce22b174df7eb$var$setAttribute(slide, "style", styles);
        $ca9ce22b174df7eb$var$setAttribute(slide, $ca9ce22b174df7eb$var$ARIA_LABEL, label || "");
    }
    function initNavigation() {
        var controls = Splide2.splides.map(function(target) {
            var Slide2 = target.splide.Components.Slides.getAt(index);
            return Slide2 ? Slide2.slide.id : "";
        }).join(" ");
        $ca9ce22b174df7eb$var$setAttribute(slide, $ca9ce22b174df7eb$var$ARIA_LABEL, $ca9ce22b174df7eb$var$format(i18n.slideX, (isClone ? slideIndex : index) + 1));
        $ca9ce22b174df7eb$var$setAttribute(slide, $ca9ce22b174df7eb$var$ARIA_CONTROLS, controls);
        $ca9ce22b174df7eb$var$setAttribute(slide, $ca9ce22b174df7eb$var$ROLE, slideFocus ? "button" : "");
        slideFocus && $ca9ce22b174df7eb$var$removeAttribute(slide, $ca9ce22b174df7eb$var$ARIA_ROLEDESCRIPTION);
    }
    function onMove() {
        if (!destroyed) update();
    }
    function update() {
        if (!destroyed) {
            var curr = Splide2.index;
            updateActivity();
            updateVisibility();
            $ca9ce22b174df7eb$var$toggleClass(slide, $ca9ce22b174df7eb$export$e423ac4972f5e196, index === curr - 1);
            $ca9ce22b174df7eb$var$toggleClass(slide, $ca9ce22b174df7eb$export$457a2d20827a2779, index === curr + 1);
        }
    }
    function updateActivity() {
        var active = isActive();
        if (active !== $ca9ce22b174df7eb$var$hasClass(slide, $ca9ce22b174df7eb$export$72d36ecf3758cb4b)) {
            $ca9ce22b174df7eb$var$toggleClass(slide, $ca9ce22b174df7eb$export$72d36ecf3758cb4b, active);
            $ca9ce22b174df7eb$var$setAttribute(slide, $ca9ce22b174df7eb$var$ARIA_CURRENT, isNavigation && active || "");
            emit(active ? $ca9ce22b174df7eb$export$92e3eae133acac4c : $ca9ce22b174df7eb$export$6bcbb81035c12cea, self);
        }
    }
    function updateVisibility() {
        var visible = isVisible();
        var hidden = !visible && (!isActive() || isClone);
        if (!Splide2.state.is([
            $ca9ce22b174df7eb$var$MOVING,
            $ca9ce22b174df7eb$var$SCROLLING
        ])) $ca9ce22b174df7eb$var$setAttribute(slide, $ca9ce22b174df7eb$var$ARIA_HIDDEN, hidden || "");
        $ca9ce22b174df7eb$var$setAttribute($ca9ce22b174df7eb$var$queryAll(slide, options.focusableNodes || ""), $ca9ce22b174df7eb$var$TAB_INDEX, hidden ? -1 : "");
        if (slideFocus) $ca9ce22b174df7eb$var$setAttribute(slide, $ca9ce22b174df7eb$var$TAB_INDEX, hidden ? -1 : 0);
        if (visible !== $ca9ce22b174df7eb$var$hasClass(slide, $ca9ce22b174df7eb$export$53ca4621bbab9a)) {
            $ca9ce22b174df7eb$var$toggleClass(slide, $ca9ce22b174df7eb$export$53ca4621bbab9a, visible);
            emit(visible ? $ca9ce22b174df7eb$export$6a5b3445e4066a53 : $ca9ce22b174df7eb$export$8c5c7a21d54563e9, self);
        }
        if (!visible && document.activeElement === slide) {
            var Slide2 = Components.Slides.getAt(Splide2.index);
            Slide2 && $ca9ce22b174df7eb$var$focus(Slide2.slide);
        }
    }
    function style$1(prop, value, useContainer) {
        $ca9ce22b174df7eb$var$style(useContainer && container || slide, prop, value);
    }
    function isActive() {
        var curr = Splide2.index;
        return curr === index || options.cloneStatus && curr === slideIndex;
    }
    function isVisible() {
        if (Splide2.is($ca9ce22b174df7eb$export$742b62a5690c060)) return isActive();
        var trackRect = $ca9ce22b174df7eb$var$rect(Components.Elements.track);
        var slideRect = $ca9ce22b174df7eb$var$rect(slide);
        var left = resolve("left", true);
        var right = resolve("right", true);
        return $ca9ce22b174df7eb$var$floor(trackRect[left]) <= $ca9ce22b174df7eb$var$ceil(slideRect[left]) && $ca9ce22b174df7eb$var$floor(slideRect[right]) <= $ca9ce22b174df7eb$var$ceil(trackRect[right]);
    }
    function isWithin(from, distance) {
        var diff = $ca9ce22b174df7eb$var$abs(from - index);
        if (!isClone && (options.rewind || Splide2.is($ca9ce22b174df7eb$export$f42383286ed1223d))) diff = $ca9ce22b174df7eb$var$min(diff, Splide2.length - diff);
        return diff <= distance;
    }
    var self = {
        index: index,
        slideIndex: slideIndex,
        slide: slide,
        container: container,
        isClone: isClone,
        mount: mount,
        destroy: destroy,
        update: update,
        style: style$1,
        isWithin: isWithin
    };
    return self;
}
function $ca9ce22b174df7eb$var$Slides(Splide2, Components2, options) {
    var _EventInterface2 = $ca9ce22b174df7eb$export$f188226459c8a3ff(Splide2), on = _EventInterface2.on, emit = _EventInterface2.emit, bind = _EventInterface2.bind;
    var _Components2$Elements = Components2.Elements, slides = _Components2$Elements.slides, list = _Components2$Elements.list;
    var Slides2 = [];
    function mount() {
        init();
        on($ca9ce22b174df7eb$export$7f4701ac5e05e39f, destroy);
        on($ca9ce22b174df7eb$export$7f4701ac5e05e39f, init);
    }
    function init() {
        slides.forEach(function(slide, index) {
            register(slide, index, -1);
        });
    }
    function destroy() {
        forEach$1(function(Slide2) {
            Slide2.destroy();
        });
        $ca9ce22b174df7eb$var$empty(Slides2);
    }
    function update() {
        forEach$1(function(Slide2) {
            Slide2.update();
        });
    }
    function register(slide, index, slideIndex) {
        var object = $ca9ce22b174df7eb$var$Slide$1(Splide2, index, slideIndex, slide);
        object.mount();
        Slides2.push(object);
        Slides2.sort(function(Slide1, Slide2) {
            return Slide1.index - Slide2.index;
        });
    }
    function get(excludeClones) {
        return excludeClones ? filter(function(Slide2) {
            return !Slide2.isClone;
        }) : Slides2;
    }
    function getIn(page) {
        var Controller = Components2.Controller;
        var index = Controller.toIndex(page);
        var max = Controller.hasFocus() ? 1 : options.perPage;
        return filter(function(Slide2) {
            return $ca9ce22b174df7eb$var$between(Slide2.index, index, index + max - 1);
        });
    }
    function getAt(index) {
        return filter(index)[0];
    }
    function add(items, index) {
        $ca9ce22b174df7eb$var$forEach(items, function(slide) {
            if ($ca9ce22b174df7eb$var$isString(slide)) slide = $ca9ce22b174df7eb$var$parseHtml(slide);
            if ($ca9ce22b174df7eb$var$isHTMLElement(slide)) {
                var ref = slides[index];
                ref ? $ca9ce22b174df7eb$var$before(slide, ref) : $ca9ce22b174df7eb$var$append(list, slide);
                $ca9ce22b174df7eb$var$addClass(slide, options.classes.slide);
                observeImages(slide, $ca9ce22b174df7eb$var$apply(emit, $ca9ce22b174df7eb$export$7e019dae5103a285));
            }
        });
        emit($ca9ce22b174df7eb$export$7f4701ac5e05e39f);
    }
    function remove$1(matcher) {
        $ca9ce22b174df7eb$var$remove(filter(matcher).map(function(Slide2) {
            return Slide2.slide;
        }));
        emit($ca9ce22b174df7eb$export$7f4701ac5e05e39f);
    }
    function forEach$1(iteratee, excludeClones) {
        get(excludeClones).forEach(iteratee);
    }
    function filter(matcher) {
        return Slides2.filter($ca9ce22b174df7eb$var$isFunction(matcher) ? matcher : function(Slide2) {
            return $ca9ce22b174df7eb$var$isString(matcher) ? $ca9ce22b174df7eb$var$matches(Slide2.slide, matcher) : $ca9ce22b174df7eb$var$includes($ca9ce22b174df7eb$var$toArray(matcher), Slide2.index);
        });
    }
    function style(prop, value, useContainer) {
        forEach$1(function(Slide2) {
            Slide2.style(prop, value, useContainer);
        });
    }
    function observeImages(elm, callback) {
        var images = $ca9ce22b174df7eb$var$queryAll(elm, "img");
        var length = images.length;
        if (length) images.forEach(function(img) {
            bind(img, "load error", function() {
                if (!--length) callback();
            });
        });
        else callback();
    }
    function getLength(excludeClones) {
        return excludeClones ? slides.length : Slides2.length;
    }
    function isEnough() {
        return Slides2.length > options.perPage;
    }
    return {
        mount: mount,
        destroy: destroy,
        update: update,
        register: register,
        get: get,
        getIn: getIn,
        getAt: getAt,
        add: add,
        remove: remove$1,
        forEach: forEach$1,
        filter: filter,
        style: style,
        getLength: getLength,
        isEnough: isEnough
    };
}
function $ca9ce22b174df7eb$var$Layout(Splide2, Components2, options) {
    var _EventInterface3 = $ca9ce22b174df7eb$export$f188226459c8a3ff(Splide2), on = _EventInterface3.on, bind = _EventInterface3.bind, emit = _EventInterface3.emit;
    var Slides = Components2.Slides;
    var resolve = Components2.Direction.resolve;
    var _Components2$Elements2 = Components2.Elements, root = _Components2$Elements2.root, track = _Components2$Elements2.track, list = _Components2$Elements2.list;
    var getAt = Slides.getAt, styleSlides = Slides.style;
    var vertical;
    var rootRect;
    var overflow;
    function mount() {
        init();
        bind(window, "resize load", $ca9ce22b174df7eb$export$efff0f5979573c99($ca9ce22b174df7eb$var$apply(emit, $ca9ce22b174df7eb$export$7e019dae5103a285)));
        on([
            $ca9ce22b174df7eb$export$db40ab7c0855fa5c,
            $ca9ce22b174df7eb$export$7f4701ac5e05e39f
        ], init);
        on($ca9ce22b174df7eb$export$7e019dae5103a285, resize);
    }
    function init() {
        vertical = options.direction === $ca9ce22b174df7eb$export$97170d9824b89709;
        $ca9ce22b174df7eb$var$style(root, "maxWidth", $ca9ce22b174df7eb$var$unit(options.width));
        $ca9ce22b174df7eb$var$style(track, resolve("paddingLeft"), cssPadding(false));
        $ca9ce22b174df7eb$var$style(track, resolve("paddingRight"), cssPadding(true));
        resize(true);
    }
    function resize(force) {
        var newRect = $ca9ce22b174df7eb$var$rect(root);
        if (force || rootRect.width !== newRect.width || rootRect.height !== newRect.height) {
            $ca9ce22b174df7eb$var$style(track, "height", cssTrackHeight());
            styleSlides(resolve("marginRight"), $ca9ce22b174df7eb$var$unit(options.gap));
            styleSlides("width", cssSlideWidth());
            styleSlides("height", cssSlideHeight(), true);
            rootRect = newRect;
            emit($ca9ce22b174df7eb$export$d637eba1e9e28482);
            if (overflow !== (overflow = isOverflow())) {
                $ca9ce22b174df7eb$var$toggleClass(root, $ca9ce22b174df7eb$export$cd908cd1dd625e29, overflow);
                emit($ca9ce22b174df7eb$export$6cbac5b662a31e1b, overflow);
            }
        }
    }
    function cssPadding(right) {
        var padding = options.padding;
        var prop = resolve(right ? "right" : "left");
        return padding && $ca9ce22b174df7eb$var$unit(padding[prop] || ($ca9ce22b174df7eb$var$isObject(padding) ? 0 : padding)) || "0px";
    }
    function cssTrackHeight() {
        var height = "";
        if (vertical) {
            height = cssHeight();
            $ca9ce22b174df7eb$var$assert(height, "height or heightRatio is missing.");
            height = "calc(" + height + " - " + cssPadding(false) + " - " + cssPadding(true) + ")";
        }
        return height;
    }
    function cssHeight() {
        return $ca9ce22b174df7eb$var$unit(options.height || $ca9ce22b174df7eb$var$rect(list).width * options.heightRatio);
    }
    function cssSlideWidth() {
        return options.autoWidth ? null : $ca9ce22b174df7eb$var$unit(options.fixedWidth) || (vertical ? "" : cssSlideSize());
    }
    function cssSlideHeight() {
        return $ca9ce22b174df7eb$var$unit(options.fixedHeight) || (vertical ? options.autoHeight ? null : cssSlideSize() : cssHeight());
    }
    function cssSlideSize() {
        var gap = $ca9ce22b174df7eb$var$unit(options.gap);
        return "calc((100%" + (gap && " + " + gap) + ")/" + (options.perPage || 1) + (gap && " - " + gap) + ")";
    }
    function listSize() {
        return $ca9ce22b174df7eb$var$rect(list)[resolve("width")];
    }
    function slideSize(index, withoutGap) {
        var Slide = getAt(index || 0);
        return Slide ? $ca9ce22b174df7eb$var$rect(Slide.slide)[resolve("width")] + (withoutGap ? 0 : getGap()) : 0;
    }
    function totalSize(index, withoutGap) {
        var Slide = getAt(index);
        if (Slide) {
            var right = $ca9ce22b174df7eb$var$rect(Slide.slide)[resolve("right")];
            var left = $ca9ce22b174df7eb$var$rect(list)[resolve("left")];
            return $ca9ce22b174df7eb$var$abs(right - left) + (withoutGap ? 0 : getGap());
        }
        return 0;
    }
    function sliderSize(withoutGap) {
        return totalSize(Splide2.length - 1) - totalSize(0) + slideSize(0, withoutGap);
    }
    function getGap() {
        var Slide = getAt(0);
        return Slide && parseFloat($ca9ce22b174df7eb$var$style(Slide.slide, resolve("marginRight"))) || 0;
    }
    function getPadding(right) {
        return parseFloat($ca9ce22b174df7eb$var$style(track, resolve("padding" + (right ? "Right" : "Left")))) || 0;
    }
    function isOverflow() {
        return Splide2.is($ca9ce22b174df7eb$export$742b62a5690c060) || sliderSize(true) > listSize();
    }
    return {
        mount: mount,
        resize: resize,
        listSize: listSize,
        slideSize: slideSize,
        sliderSize: sliderSize,
        totalSize: totalSize,
        getPadding: getPadding,
        isOverflow: isOverflow
    };
}
var $ca9ce22b174df7eb$var$MULTIPLIER = 2;
function $ca9ce22b174df7eb$var$Clones(Splide2, Components2, options) {
    var event = $ca9ce22b174df7eb$export$f188226459c8a3ff(Splide2);
    var on = event.on;
    var Elements = Components2.Elements, Slides = Components2.Slides;
    var resolve = Components2.Direction.resolve;
    var clones = [];
    var cloneCount;
    function mount() {
        on($ca9ce22b174df7eb$export$7f4701ac5e05e39f, remount);
        on([
            $ca9ce22b174df7eb$export$db40ab7c0855fa5c,
            $ca9ce22b174df7eb$export$7e019dae5103a285
        ], observe);
        if (cloneCount = computeCloneCount()) {
            generate(cloneCount);
            Components2.Layout.resize(true);
        }
    }
    function remount() {
        destroy();
        mount();
    }
    function destroy() {
        $ca9ce22b174df7eb$var$remove(clones);
        $ca9ce22b174df7eb$var$empty(clones);
        event.destroy();
    }
    function observe() {
        var count = computeCloneCount();
        if (cloneCount !== count) {
            if (cloneCount < count || !count) event.emit($ca9ce22b174df7eb$export$7f4701ac5e05e39f);
        }
    }
    function generate(count) {
        var slides = Slides.get().slice();
        var length = slides.length;
        if (length) {
            while(slides.length < count)$ca9ce22b174df7eb$var$push(slides, slides);
            $ca9ce22b174df7eb$var$push(slides.slice(-count), slides.slice(0, count)).forEach(function(Slide, index) {
                var isHead = index < count;
                var clone = cloneDeep(Slide.slide, index);
                isHead ? $ca9ce22b174df7eb$var$before(clone, slides[0].slide) : $ca9ce22b174df7eb$var$append(Elements.list, clone);
                $ca9ce22b174df7eb$var$push(clones, clone);
                Slides.register(clone, index - count + (isHead ? 0 : length), Slide.index);
            });
        }
    }
    function cloneDeep(elm, index) {
        var clone = elm.cloneNode(true);
        $ca9ce22b174df7eb$var$addClass(clone, options.classes.clone);
        clone.id = Splide2.root.id + "-clone" + $ca9ce22b174df7eb$var$pad(index + 1);
        return clone;
    }
    function computeCloneCount() {
        var clones2 = options.clones;
        if (!Splide2.is($ca9ce22b174df7eb$export$f42383286ed1223d)) clones2 = 0;
        else if ($ca9ce22b174df7eb$var$isUndefined(clones2)) {
            var fixedSize = options[resolve("fixedWidth")] && Components2.Layout.slideSize(0);
            var fixedCount = fixedSize && $ca9ce22b174df7eb$var$ceil($ca9ce22b174df7eb$var$rect(Elements.track)[resolve("width")] / fixedSize);
            clones2 = fixedCount || options[resolve("autoWidth")] && Splide2.length || options.perPage * $ca9ce22b174df7eb$var$MULTIPLIER;
        }
        return clones2;
    }
    return {
        mount: mount,
        destroy: destroy
    };
}
function $ca9ce22b174df7eb$var$Move(Splide2, Components2, options) {
    var _EventInterface4 = $ca9ce22b174df7eb$export$f188226459c8a3ff(Splide2), on = _EventInterface4.on, emit = _EventInterface4.emit;
    var set = Splide2.state.set;
    var _Components2$Layout = Components2.Layout, slideSize = _Components2$Layout.slideSize, getPadding = _Components2$Layout.getPadding, totalSize = _Components2$Layout.totalSize, listSize = _Components2$Layout.listSize, sliderSize = _Components2$Layout.sliderSize;
    var _Components2$Directio = Components2.Direction, resolve = _Components2$Directio.resolve, orient = _Components2$Directio.orient;
    var _Components2$Elements3 = Components2.Elements, list = _Components2$Elements3.list, track = _Components2$Elements3.track;
    var Transition;
    function mount() {
        Transition = Components2.Transition;
        on([
            $ca9ce22b174df7eb$export$d300dc1a2634364b,
            $ca9ce22b174df7eb$export$d637eba1e9e28482,
            $ca9ce22b174df7eb$export$db40ab7c0855fa5c,
            $ca9ce22b174df7eb$export$7f4701ac5e05e39f
        ], reposition);
    }
    function reposition() {
        if (!Components2.Controller.isBusy()) {
            Components2.Scroll.cancel();
            jump(Splide2.index);
            Components2.Slides.update();
        }
    }
    function move(dest, index, prev, callback) {
        if (dest !== index && canShift(dest > prev)) {
            cancel();
            translate(shift(getPosition(), dest > prev), true);
        }
        set($ca9ce22b174df7eb$var$MOVING);
        emit($ca9ce22b174df7eb$export$2aa493d7c3275167, index, prev, dest);
        Transition.start(index, function() {
            set($ca9ce22b174df7eb$var$IDLE);
            emit($ca9ce22b174df7eb$export$fe5802204b967f0d, index, prev, dest);
            callback && callback();
        });
    }
    function jump(index) {
        translate(toPosition(index, true));
    }
    function translate(position, preventLoop) {
        if (!Splide2.is($ca9ce22b174df7eb$export$742b62a5690c060)) {
            var destination = preventLoop ? position : loop(position);
            $ca9ce22b174df7eb$var$style(list, "transform", "translate" + resolve("X") + "(" + destination + "px)");
            position !== destination && emit($ca9ce22b174df7eb$export$f0af896383d5adff);
        }
    }
    function loop(position) {
        if (Splide2.is($ca9ce22b174df7eb$export$f42383286ed1223d)) {
            var index = toIndex(position);
            var exceededMax = index > Components2.Controller.getEnd();
            var exceededMin = index < 0;
            if (exceededMin || exceededMax) position = shift(position, exceededMax);
        }
        return position;
    }
    function shift(position, backwards) {
        var excess = position - getLimit(backwards);
        var size = sliderSize();
        position -= orient(size * ($ca9ce22b174df7eb$var$ceil($ca9ce22b174df7eb$var$abs(excess) / size) || 1)) * (backwards ? 1 : -1);
        return position;
    }
    function cancel() {
        translate(getPosition(), true);
        Transition.cancel();
    }
    function toIndex(position) {
        var Slides = Components2.Slides.get();
        var index = 0;
        var minDistance = Infinity;
        for(var i = 0; i < Slides.length; i++){
            var slideIndex = Slides[i].index;
            var distance = $ca9ce22b174df7eb$var$abs(toPosition(slideIndex, true) - position);
            if (distance <= minDistance) {
                minDistance = distance;
                index = slideIndex;
            } else break;
        }
        return index;
    }
    function toPosition(index, trimming) {
        var position = orient(totalSize(index - 1) - offset(index));
        return trimming ? trim(position) : position;
    }
    function getPosition() {
        var left = resolve("left");
        return $ca9ce22b174df7eb$var$rect(list)[left] - $ca9ce22b174df7eb$var$rect(track)[left] + orient(getPadding(false));
    }
    function trim(position) {
        if (options.trimSpace && Splide2.is($ca9ce22b174df7eb$export$e5a58a5ee5b54c22)) position = $ca9ce22b174df7eb$var$clamp(position, 0, orient(sliderSize(true) - listSize()));
        return position;
    }
    function offset(index) {
        var focus = options.focus;
        return focus === "center" ? (listSize() - slideSize(index, true)) / 2 : +focus * slideSize(index) || 0;
    }
    function getLimit(max) {
        return toPosition(max ? Components2.Controller.getEnd() : 0, !!options.trimSpace);
    }
    function canShift(backwards) {
        var shifted = orient(shift(getPosition(), backwards));
        return backwards ? shifted >= 0 : shifted <= list[resolve("scrollWidth")] - $ca9ce22b174df7eb$var$rect(track)[resolve("width")];
    }
    function exceededLimit(max, position) {
        position = $ca9ce22b174df7eb$var$isUndefined(position) ? getPosition() : position;
        var exceededMin = max !== true && orient(position) < orient(getLimit(false));
        var exceededMax = max !== false && orient(position) > orient(getLimit(true));
        return exceededMin || exceededMax;
    }
    return {
        mount: mount,
        move: move,
        jump: jump,
        translate: translate,
        shift: shift,
        cancel: cancel,
        toIndex: toIndex,
        toPosition: toPosition,
        getPosition: getPosition,
        getLimit: getLimit,
        exceededLimit: exceededLimit,
        reposition: reposition
    };
}
function $ca9ce22b174df7eb$var$Controller(Splide2, Components2, options) {
    var _EventInterface5 = $ca9ce22b174df7eb$export$f188226459c8a3ff(Splide2), on = _EventInterface5.on, emit = _EventInterface5.emit;
    var Move = Components2.Move;
    var getPosition = Move.getPosition, getLimit = Move.getLimit, toPosition = Move.toPosition;
    var _Components2$Slides = Components2.Slides, isEnough = _Components2$Slides.isEnough, getLength = _Components2$Slides.getLength;
    var omitEnd = options.omitEnd;
    var isLoop = Splide2.is($ca9ce22b174df7eb$export$f42383286ed1223d);
    var isSlide = Splide2.is($ca9ce22b174df7eb$export$e5a58a5ee5b54c22);
    var getNext = $ca9ce22b174df7eb$var$apply(getAdjacent, false);
    var getPrev = $ca9ce22b174df7eb$var$apply(getAdjacent, true);
    var currIndex = options.start || 0;
    var endIndex;
    var prevIndex = currIndex;
    var slideCount;
    var perMove;
    var perPage;
    function mount() {
        init();
        on([
            $ca9ce22b174df7eb$export$db40ab7c0855fa5c,
            $ca9ce22b174df7eb$export$7f4701ac5e05e39f,
            $ca9ce22b174df7eb$export$28dea85f216954dc
        ], init);
        on($ca9ce22b174df7eb$export$d637eba1e9e28482, onResized);
    }
    function init() {
        slideCount = getLength(true);
        perMove = options.perMove;
        perPage = options.perPage;
        endIndex = getEnd();
        var index = $ca9ce22b174df7eb$var$clamp(currIndex, 0, omitEnd ? endIndex : slideCount - 1);
        if (index !== currIndex) {
            currIndex = index;
            Move.reposition();
        }
    }
    function onResized() {
        if (endIndex !== getEnd()) emit($ca9ce22b174df7eb$export$28dea85f216954dc);
    }
    function go(control, allowSameIndex, callback) {
        if (!isBusy()) {
            var dest = parse(control);
            var index = loop(dest);
            if (index > -1 && (allowSameIndex || index !== currIndex)) {
                setIndex(index);
                Move.move(dest, index, prevIndex, callback);
            }
        }
    }
    function scroll(destination, duration, snap, callback) {
        Components2.Scroll.scroll(destination, duration, snap, function() {
            var index = loop(Move.toIndex(getPosition()));
            setIndex(omitEnd ? $ca9ce22b174df7eb$var$min(index, endIndex) : index);
            callback && callback();
        });
    }
    function parse(control) {
        var index = currIndex;
        if ($ca9ce22b174df7eb$var$isString(control)) {
            var _ref = control.match(/([+\-<>])(\d+)?/) || [], indicator = _ref[1], number = _ref[2];
            if (indicator === "+" || indicator === "-") index = computeDestIndex(currIndex + +("" + indicator + (+number || 1)), currIndex);
            else if (indicator === ">") index = number ? toIndex(+number) : getNext(true);
            else if (indicator === "<") index = getPrev(true);
        } else index = isLoop ? control : $ca9ce22b174df7eb$var$clamp(control, 0, endIndex);
        return index;
    }
    function getAdjacent(prev, destination) {
        var number = perMove || (hasFocus() ? 1 : perPage);
        var dest = computeDestIndex(currIndex + number * (prev ? -1 : 1), currIndex, !(perMove || hasFocus()));
        if (dest === -1 && isSlide) {
            if (!$ca9ce22b174df7eb$var$approximatelyEqual(getPosition(), getLimit(!prev), 1)) return prev ? 0 : endIndex;
        }
        return destination ? dest : loop(dest);
    }
    function computeDestIndex(dest, from, snapPage) {
        if (isEnough() || hasFocus()) {
            var index = computeMovableDestIndex(dest);
            if (index !== dest) {
                from = dest;
                dest = index;
                snapPage = false;
            }
            if (dest < 0 || dest > endIndex) {
                if (!perMove && ($ca9ce22b174df7eb$var$between(0, dest, from, true) || $ca9ce22b174df7eb$var$between(endIndex, from, dest, true))) dest = toIndex(toPage(dest));
                else {
                    if (isLoop) dest = snapPage ? dest < 0 ? -(slideCount % perPage || perPage) : slideCount : dest;
                    else if (options.rewind) dest = dest < 0 ? endIndex : 0;
                    else dest = -1;
                }
            } else if (snapPage && dest !== from) dest = toIndex(toPage(from) + (dest < from ? -1 : 1));
        } else dest = -1;
        return dest;
    }
    function computeMovableDestIndex(dest) {
        if (isSlide && options.trimSpace === "move" && dest !== currIndex) {
            var position = getPosition();
            while(position === toPosition(dest, true) && $ca9ce22b174df7eb$var$between(dest, 0, Splide2.length - 1, !options.rewind))dest < currIndex ? --dest : ++dest;
        }
        return dest;
    }
    function loop(index) {
        return isLoop ? (index + slideCount) % slideCount || 0 : index;
    }
    function getEnd() {
        var end = slideCount - (hasFocus() || isLoop && perMove ? 1 : perPage);
        while(omitEnd && end-- > 0)if (toPosition(slideCount - 1, true) !== toPosition(end, true)) {
            end++;
            break;
        }
        return $ca9ce22b174df7eb$var$clamp(end, 0, slideCount - 1);
    }
    function toIndex(page) {
        return $ca9ce22b174df7eb$var$clamp(hasFocus() ? page : perPage * page, 0, endIndex);
    }
    function toPage(index) {
        return hasFocus() ? $ca9ce22b174df7eb$var$min(index, endIndex) : $ca9ce22b174df7eb$var$floor((index >= endIndex ? slideCount - 1 : index) / perPage);
    }
    function toDest(destination) {
        var closest = Move.toIndex(destination);
        return isSlide ? $ca9ce22b174df7eb$var$clamp(closest, 0, endIndex) : closest;
    }
    function setIndex(index) {
        if (index !== currIndex) {
            prevIndex = currIndex;
            currIndex = index;
        }
    }
    function getIndex(prev) {
        return prev ? prevIndex : currIndex;
    }
    function hasFocus() {
        return !$ca9ce22b174df7eb$var$isUndefined(options.focus) || options.isNavigation;
    }
    function isBusy() {
        return Splide2.state.is([
            $ca9ce22b174df7eb$var$MOVING,
            $ca9ce22b174df7eb$var$SCROLLING
        ]) && !!options.waitForTransition;
    }
    return {
        mount: mount,
        go: go,
        scroll: scroll,
        getNext: getNext,
        getPrev: getPrev,
        getAdjacent: getAdjacent,
        getEnd: getEnd,
        setIndex: setIndex,
        getIndex: getIndex,
        toIndex: toIndex,
        toPage: toPage,
        toDest: toDest,
        hasFocus: hasFocus,
        isBusy: isBusy
    };
}
var $ca9ce22b174df7eb$var$XML_NAME_SPACE = "http://www.w3.org/2000/svg";
var $ca9ce22b174df7eb$var$PATH = "m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z";
var $ca9ce22b174df7eb$var$SIZE = 40;
function $ca9ce22b174df7eb$var$Arrows(Splide2, Components2, options) {
    var event = $ca9ce22b174df7eb$export$f188226459c8a3ff(Splide2);
    var on = event.on, bind = event.bind, emit = event.emit;
    var classes = options.classes, i18n = options.i18n;
    var Elements = Components2.Elements, Controller = Components2.Controller;
    var placeholder = Elements.arrows, track = Elements.track;
    var wrapper = placeholder;
    var prev = Elements.prev;
    var next = Elements.next;
    var created;
    var wrapperClasses;
    var arrows = {};
    function mount() {
        init();
        on($ca9ce22b174df7eb$export$db40ab7c0855fa5c, remount);
    }
    function remount() {
        destroy();
        mount();
    }
    function init() {
        var enabled = options.arrows;
        if (enabled && !(prev && next)) createArrows();
        if (prev && next) {
            $ca9ce22b174df7eb$var$assign(arrows, {
                prev: prev,
                next: next
            });
            $ca9ce22b174df7eb$var$display(wrapper, enabled ? "" : "none");
            $ca9ce22b174df7eb$var$addClass(wrapper, wrapperClasses = $ca9ce22b174df7eb$export$a26cbd955fecf11e + "--" + options.direction);
            if (enabled) {
                listen();
                update();
                $ca9ce22b174df7eb$var$setAttribute([
                    prev,
                    next
                ], $ca9ce22b174df7eb$var$ARIA_CONTROLS, track.id);
                emit($ca9ce22b174df7eb$export$8647f6b043e04e9d, prev, next);
            }
        }
    }
    function destroy() {
        event.destroy();
        $ca9ce22b174df7eb$var$removeClass(wrapper, wrapperClasses);
        if (created) {
            $ca9ce22b174df7eb$var$remove(placeholder ? [
                prev,
                next
            ] : wrapper);
            prev = next = null;
        } else $ca9ce22b174df7eb$var$removeAttribute([
            prev,
            next
        ], $ca9ce22b174df7eb$var$ALL_ATTRIBUTES);
    }
    function listen() {
        on([
            $ca9ce22b174df7eb$export$d300dc1a2634364b,
            $ca9ce22b174df7eb$export$fe5802204b967f0d,
            $ca9ce22b174df7eb$export$7f4701ac5e05e39f,
            $ca9ce22b174df7eb$export$ff8164bff3202b9,
            $ca9ce22b174df7eb$export$28dea85f216954dc
        ], update);
        bind(next, "click", $ca9ce22b174df7eb$var$apply(go, ">"));
        bind(prev, "click", $ca9ce22b174df7eb$var$apply(go, "<"));
    }
    function go(control) {
        Controller.go(control, true);
    }
    function createArrows() {
        wrapper = placeholder || $ca9ce22b174df7eb$var$create("div", classes.arrows);
        prev = createArrow(true);
        next = createArrow(false);
        created = true;
        $ca9ce22b174df7eb$var$append(wrapper, [
            prev,
            next
        ]);
        !placeholder && $ca9ce22b174df7eb$var$before(wrapper, track);
    }
    function createArrow(prev2) {
        var arrow = "<button class=\"" + classes.arrow + " " + (prev2 ? classes.prev : classes.next) + "\" type=\"button\"><svg xmlns=\"" + $ca9ce22b174df7eb$var$XML_NAME_SPACE + "\" viewBox=\"0 0 " + $ca9ce22b174df7eb$var$SIZE + " " + $ca9ce22b174df7eb$var$SIZE + "\" width=\"" + $ca9ce22b174df7eb$var$SIZE + "\" height=\"" + $ca9ce22b174df7eb$var$SIZE + "\" focusable=\"false\"><path d=\"" + (options.arrowPath || $ca9ce22b174df7eb$var$PATH) + "\" />";
        return $ca9ce22b174df7eb$var$parseHtml(arrow);
    }
    function update() {
        if (prev && next) {
            var index = Splide2.index;
            var prevIndex = Controller.getPrev();
            var nextIndex = Controller.getNext();
            var prevLabel = prevIndex > -1 && index < prevIndex ? i18n.last : i18n.prev;
            var nextLabel = nextIndex > -1 && index > nextIndex ? i18n.first : i18n.next;
            prev.disabled = prevIndex < 0;
            next.disabled = nextIndex < 0;
            $ca9ce22b174df7eb$var$setAttribute(prev, $ca9ce22b174df7eb$var$ARIA_LABEL, prevLabel);
            $ca9ce22b174df7eb$var$setAttribute(next, $ca9ce22b174df7eb$var$ARIA_LABEL, nextLabel);
            emit($ca9ce22b174df7eb$export$d467f9343b961f75, prev, next, prevIndex, nextIndex);
        }
    }
    return {
        arrows: arrows,
        mount: mount,
        destroy: destroy,
        update: update
    };
}
var $ca9ce22b174df7eb$var$INTERVAL_DATA_ATTRIBUTE = $ca9ce22b174df7eb$var$DATA_ATTRIBUTE + "-interval";
function $ca9ce22b174df7eb$var$Autoplay(Splide2, Components2, options) {
    var _EventInterface6 = $ca9ce22b174df7eb$export$f188226459c8a3ff(Splide2), on = _EventInterface6.on, bind = _EventInterface6.bind, emit = _EventInterface6.emit;
    var interval = $ca9ce22b174df7eb$export$46ad21b25b6dccf0(options.interval, Splide2.go.bind(Splide2, ">"), onAnimationFrame);
    var isPaused = interval.isPaused;
    var Elements = Components2.Elements, _Components2$Elements4 = Components2.Elements, root = _Components2$Elements4.root, toggle = _Components2$Elements4.toggle;
    var autoplay = options.autoplay;
    var hovered;
    var focused;
    var stopped = autoplay === "pause";
    function mount() {
        if (autoplay) {
            listen();
            toggle && $ca9ce22b174df7eb$var$setAttribute(toggle, $ca9ce22b174df7eb$var$ARIA_CONTROLS, Elements.track.id);
            stopped || play();
            update();
        }
    }
    function listen() {
        if (options.pauseOnHover) bind(root, "mouseenter mouseleave", function(e) {
            hovered = e.type === "mouseenter";
            autoToggle();
        });
        if (options.pauseOnFocus) bind(root, "focusin focusout", function(e) {
            focused = e.type === "focusin";
            autoToggle();
        });
        if (toggle) bind(toggle, "click", function() {
            stopped ? play() : pause(true);
        });
        on([
            $ca9ce22b174df7eb$export$2aa493d7c3275167,
            $ca9ce22b174df7eb$export$49801896908b5e33,
            $ca9ce22b174df7eb$export$7f4701ac5e05e39f
        ], interval.rewind);
        on($ca9ce22b174df7eb$export$2aa493d7c3275167, onMove);
    }
    function play() {
        if (isPaused() && Components2.Slides.isEnough()) {
            interval.start(!options.resetProgress);
            focused = hovered = stopped = false;
            update();
            emit($ca9ce22b174df7eb$export$23663268a31b79e2);
        }
    }
    function pause(stop) {
        if (stop === void 0) stop = true;
        stopped = !!stop;
        update();
        if (!isPaused()) {
            interval.pause();
            emit($ca9ce22b174df7eb$export$16a1e4f3d0368265);
        }
    }
    function autoToggle() {
        if (!stopped) hovered || focused ? pause(false) : play();
    }
    function update() {
        if (toggle) {
            $ca9ce22b174df7eb$var$toggleClass(toggle, $ca9ce22b174df7eb$export$72d36ecf3758cb4b, !stopped);
            $ca9ce22b174df7eb$var$setAttribute(toggle, $ca9ce22b174df7eb$var$ARIA_LABEL, options.i18n[stopped ? "play" : "pause"]);
        }
    }
    function onAnimationFrame(rate) {
        var bar = Elements.bar;
        bar && $ca9ce22b174df7eb$var$style(bar, "width", rate * 100 + "%");
        emit($ca9ce22b174df7eb$export$185723258309b608, rate);
    }
    function onMove(index) {
        var Slide = Components2.Slides.getAt(index);
        interval.set(Slide && +$ca9ce22b174df7eb$var$getAttribute(Slide.slide, $ca9ce22b174df7eb$var$INTERVAL_DATA_ATTRIBUTE) || options.interval);
    }
    return {
        mount: mount,
        destroy: interval.cancel,
        play: play,
        pause: pause,
        isPaused: isPaused
    };
}
function $ca9ce22b174df7eb$var$Cover(Splide2, Components2, options) {
    var _EventInterface7 = $ca9ce22b174df7eb$export$f188226459c8a3ff(Splide2), on = _EventInterface7.on;
    function mount() {
        if (options.cover) {
            on($ca9ce22b174df7eb$export$9f64346e17f0ec8e, $ca9ce22b174df7eb$var$apply(toggle, true));
            on([
                $ca9ce22b174df7eb$export$d300dc1a2634364b,
                $ca9ce22b174df7eb$export$db40ab7c0855fa5c,
                $ca9ce22b174df7eb$export$7f4701ac5e05e39f
            ], $ca9ce22b174df7eb$var$apply(cover, true));
        }
    }
    function cover(cover2) {
        Components2.Slides.forEach(function(Slide) {
            var img = $ca9ce22b174df7eb$var$child(Slide.container || Slide.slide, "img");
            if (img && img.src) toggle(cover2, img, Slide);
        });
    }
    function toggle(cover2, img, Slide) {
        Slide.style("background", cover2 ? "center/cover no-repeat url(\"" + img.src + "\")" : "", true);
        $ca9ce22b174df7eb$var$display(img, cover2 ? "none" : "");
    }
    return {
        mount: mount,
        destroy: $ca9ce22b174df7eb$var$apply(cover, false)
    };
}
var $ca9ce22b174df7eb$var$BOUNCE_DIFF_THRESHOLD = 10;
var $ca9ce22b174df7eb$var$BOUNCE_DURATION = 600;
var $ca9ce22b174df7eb$var$FRICTION_FACTOR = 0.6;
var $ca9ce22b174df7eb$var$BASE_VELOCITY = 1.5;
var $ca9ce22b174df7eb$var$MIN_DURATION = 800;
function $ca9ce22b174df7eb$var$Scroll(Splide2, Components2, options) {
    var _EventInterface8 = $ca9ce22b174df7eb$export$f188226459c8a3ff(Splide2), on = _EventInterface8.on, emit = _EventInterface8.emit;
    var set = Splide2.state.set;
    var Move = Components2.Move;
    var getPosition = Move.getPosition, getLimit = Move.getLimit, exceededLimit = Move.exceededLimit, translate = Move.translate;
    var isSlide = Splide2.is($ca9ce22b174df7eb$export$e5a58a5ee5b54c22);
    var interval;
    var callback;
    var friction = 1;
    function mount() {
        on($ca9ce22b174df7eb$export$2aa493d7c3275167, clear);
        on([
            $ca9ce22b174df7eb$export$db40ab7c0855fa5c,
            $ca9ce22b174df7eb$export$7f4701ac5e05e39f
        ], cancel);
    }
    function scroll(destination, duration, snap, onScrolled, noConstrain) {
        var from = getPosition();
        clear();
        if (snap && (!isSlide || !exceededLimit())) {
            var size = Components2.Layout.sliderSize();
            var offset = $ca9ce22b174df7eb$var$sign(destination) * size * $ca9ce22b174df7eb$var$floor($ca9ce22b174df7eb$var$abs(destination) / size) || 0;
            destination = Move.toPosition(Components2.Controller.toDest(destination % size)) + offset;
        }
        var noDistance = $ca9ce22b174df7eb$var$approximatelyEqual(from, destination, 1);
        friction = 1;
        duration = noDistance ? 0 : duration || $ca9ce22b174df7eb$var$max($ca9ce22b174df7eb$var$abs(destination - from) / $ca9ce22b174df7eb$var$BASE_VELOCITY, $ca9ce22b174df7eb$var$MIN_DURATION);
        callback = onScrolled;
        interval = $ca9ce22b174df7eb$export$46ad21b25b6dccf0(duration, onEnd, $ca9ce22b174df7eb$var$apply(update, from, destination, noConstrain), 1);
        set($ca9ce22b174df7eb$var$SCROLLING);
        emit($ca9ce22b174df7eb$export$49801896908b5e33);
        interval.start();
    }
    function onEnd() {
        set($ca9ce22b174df7eb$var$IDLE);
        callback && callback();
        emit($ca9ce22b174df7eb$export$ff8164bff3202b9);
    }
    function update(from, to, noConstrain, rate) {
        var position = getPosition();
        var target = from + (to - from) * easing(rate);
        var diff = (target - position) * friction;
        translate(position + diff);
        if (isSlide && !noConstrain && exceededLimit()) {
            friction *= $ca9ce22b174df7eb$var$FRICTION_FACTOR;
            if ($ca9ce22b174df7eb$var$abs(diff) < $ca9ce22b174df7eb$var$BOUNCE_DIFF_THRESHOLD) scroll(getLimit(exceededLimit(true)), $ca9ce22b174df7eb$var$BOUNCE_DURATION, false, callback, true);
        }
    }
    function clear() {
        if (interval) interval.cancel();
    }
    function cancel() {
        if (interval && !interval.isPaused()) {
            clear();
            onEnd();
        }
    }
    function easing(t) {
        var easingFunc = options.easingFunc;
        return easingFunc ? easingFunc(t) : 1 - Math.pow(1 - t, 4);
    }
    return {
        mount: mount,
        destroy: clear,
        scroll: scroll,
        cancel: cancel
    };
}
var $ca9ce22b174df7eb$var$SCROLL_LISTENER_OPTIONS = {
    passive: false,
    capture: true
};
function $ca9ce22b174df7eb$var$Drag(Splide2, Components2, options) {
    var _EventInterface9 = $ca9ce22b174df7eb$export$f188226459c8a3ff(Splide2), on = _EventInterface9.on, emit = _EventInterface9.emit, bind = _EventInterface9.bind, unbind = _EventInterface9.unbind;
    var state = Splide2.state;
    var Move = Components2.Move, Scroll = Components2.Scroll, Controller = Components2.Controller, track = Components2.Elements.track, reduce = Components2.Media.reduce;
    var _Components2$Directio2 = Components2.Direction, resolve = _Components2$Directio2.resolve, orient = _Components2$Directio2.orient;
    var getPosition = Move.getPosition, exceededLimit = Move.exceededLimit;
    var basePosition;
    var baseEvent;
    var prevBaseEvent;
    var isFree;
    var dragging;
    var exceeded = false;
    var clickPrevented;
    var disabled;
    var target;
    function mount() {
        bind(track, $ca9ce22b174df7eb$var$POINTER_MOVE_EVENTS, $ca9ce22b174df7eb$var$noop, $ca9ce22b174df7eb$var$SCROLL_LISTENER_OPTIONS);
        bind(track, $ca9ce22b174df7eb$var$POINTER_UP_EVENTS, $ca9ce22b174df7eb$var$noop, $ca9ce22b174df7eb$var$SCROLL_LISTENER_OPTIONS);
        bind(track, $ca9ce22b174df7eb$var$POINTER_DOWN_EVENTS, onPointerDown, $ca9ce22b174df7eb$var$SCROLL_LISTENER_OPTIONS);
        bind(track, "click", onClick, {
            capture: true
        });
        bind(track, "dragstart", $ca9ce22b174df7eb$var$prevent);
        on([
            $ca9ce22b174df7eb$export$d300dc1a2634364b,
            $ca9ce22b174df7eb$export$db40ab7c0855fa5c
        ], init);
    }
    function init() {
        var drag = options.drag;
        disable(!drag);
        isFree = drag === "free";
    }
    function onPointerDown(e) {
        clickPrevented = false;
        if (!disabled) {
            var isTouch = isTouchEvent(e);
            if (isDraggable(e.target) && (isTouch || !e.button)) {
                if (!Controller.isBusy()) {
                    target = isTouch ? track : window;
                    dragging = state.is([
                        $ca9ce22b174df7eb$var$MOVING,
                        $ca9ce22b174df7eb$var$SCROLLING
                    ]);
                    prevBaseEvent = null;
                    bind(target, $ca9ce22b174df7eb$var$POINTER_MOVE_EVENTS, onPointerMove, $ca9ce22b174df7eb$var$SCROLL_LISTENER_OPTIONS);
                    bind(target, $ca9ce22b174df7eb$var$POINTER_UP_EVENTS, onPointerUp, $ca9ce22b174df7eb$var$SCROLL_LISTENER_OPTIONS);
                    Move.cancel();
                    Scroll.cancel();
                    save(e);
                } else $ca9ce22b174df7eb$var$prevent(e, true);
            }
        }
    }
    function onPointerMove(e) {
        if (!state.is($ca9ce22b174df7eb$var$DRAGGING)) {
            state.set($ca9ce22b174df7eb$var$DRAGGING);
            emit($ca9ce22b174df7eb$export$e84bf5065c9087ac);
        }
        if (e.cancelable) {
            if (dragging) {
                Move.translate(basePosition + constrain(diffCoord(e)));
                var expired = diffTime(e) > $ca9ce22b174df7eb$var$LOG_INTERVAL;
                var hasExceeded = exceeded !== (exceeded = exceededLimit());
                if (expired || hasExceeded) save(e);
                clickPrevented = true;
                emit($ca9ce22b174df7eb$export$8e9f636d2c722196);
                $ca9ce22b174df7eb$var$prevent(e);
            } else if (isSliderDirection(e)) {
                dragging = shouldStart(e);
                $ca9ce22b174df7eb$var$prevent(e);
            }
        }
    }
    function onPointerUp(e) {
        if (state.is($ca9ce22b174df7eb$var$DRAGGING)) {
            state.set($ca9ce22b174df7eb$var$IDLE);
            emit($ca9ce22b174df7eb$export$90ea576bd3fdeb60);
        }
        if (dragging) {
            move(e);
            $ca9ce22b174df7eb$var$prevent(e);
        }
        unbind(target, $ca9ce22b174df7eb$var$POINTER_MOVE_EVENTS, onPointerMove);
        unbind(target, $ca9ce22b174df7eb$var$POINTER_UP_EVENTS, onPointerUp);
        dragging = false;
    }
    function onClick(e) {
        if (!disabled && clickPrevented) $ca9ce22b174df7eb$var$prevent(e, true);
    }
    function save(e) {
        prevBaseEvent = baseEvent;
        baseEvent = e;
        basePosition = getPosition();
    }
    function move(e) {
        var velocity = computeVelocity(e);
        var destination = computeDestination(velocity);
        var rewind = options.rewind && options.rewindByDrag;
        reduce(false);
        if (isFree) Controller.scroll(destination, 0, options.snap);
        else if (Splide2.is($ca9ce22b174df7eb$export$742b62a5690c060)) Controller.go(orient($ca9ce22b174df7eb$var$sign(velocity)) < 0 ? rewind ? "<" : "-" : rewind ? ">" : "+");
        else if (Splide2.is($ca9ce22b174df7eb$export$e5a58a5ee5b54c22) && exceeded && rewind) Controller.go(exceededLimit(true) ? ">" : "<");
        else Controller.go(Controller.toDest(destination), true);
        reduce(true);
    }
    function shouldStart(e) {
        var thresholds = options.dragMinThreshold;
        var isObj = $ca9ce22b174df7eb$var$isObject(thresholds);
        var mouse = isObj && thresholds.mouse || 0;
        var touch = (isObj ? thresholds.touch : +thresholds) || 10;
        return $ca9ce22b174df7eb$var$abs(diffCoord(e)) > (isTouchEvent(e) ? touch : mouse);
    }
    function isSliderDirection(e) {
        return $ca9ce22b174df7eb$var$abs(diffCoord(e)) > $ca9ce22b174df7eb$var$abs(diffCoord(e, true));
    }
    function computeVelocity(e) {
        if (Splide2.is($ca9ce22b174df7eb$export$f42383286ed1223d) || !exceeded) {
            var time = diffTime(e);
            if (time && time < $ca9ce22b174df7eb$var$LOG_INTERVAL) return diffCoord(e) / time;
        }
        return 0;
    }
    function computeDestination(velocity) {
        return getPosition() + $ca9ce22b174df7eb$var$sign(velocity) * $ca9ce22b174df7eb$var$min($ca9ce22b174df7eb$var$abs(velocity) * (options.flickPower || 600), isFree ? Infinity : Components2.Layout.listSize() * (options.flickMaxPages || 1));
    }
    function diffCoord(e, orthogonal) {
        return coordOf(e, orthogonal) - coordOf(getBaseEvent(e), orthogonal);
    }
    function diffTime(e) {
        return $ca9ce22b174df7eb$var$timeOf(e) - $ca9ce22b174df7eb$var$timeOf(getBaseEvent(e));
    }
    function getBaseEvent(e) {
        return baseEvent === e && prevBaseEvent || baseEvent;
    }
    function coordOf(e, orthogonal) {
        return (isTouchEvent(e) ? e.changedTouches[0] : e)["page" + resolve(orthogonal ? "Y" : "X")];
    }
    function constrain(diff) {
        return diff / (exceeded && Splide2.is($ca9ce22b174df7eb$export$e5a58a5ee5b54c22) ? $ca9ce22b174df7eb$var$FRICTION : 1);
    }
    function isDraggable(target2) {
        var noDrag = options.noDrag;
        return !$ca9ce22b174df7eb$var$matches(target2, "." + $ca9ce22b174df7eb$export$52f2cca6a5eee805 + ", ." + $ca9ce22b174df7eb$export$516e7d18e13a2dca) && (!noDrag || !$ca9ce22b174df7eb$var$matches(target2, noDrag));
    }
    function isTouchEvent(e) {
        return typeof TouchEvent !== "undefined" && e instanceof TouchEvent;
    }
    function isDragging() {
        return dragging;
    }
    function disable(value) {
        disabled = value;
    }
    return {
        mount: mount,
        disable: disable,
        isDragging: isDragging
    };
}
var $ca9ce22b174df7eb$var$NORMALIZATION_MAP = {
    Spacebar: " ",
    Right: $ca9ce22b174df7eb$var$ARROW_RIGHT,
    Left: $ca9ce22b174df7eb$var$ARROW_LEFT,
    Up: $ca9ce22b174df7eb$var$ARROW_UP,
    Down: $ca9ce22b174df7eb$var$ARROW_DOWN
};
function $ca9ce22b174df7eb$var$normalizeKey(key) {
    key = $ca9ce22b174df7eb$var$isString(key) ? key : key.key;
    return $ca9ce22b174df7eb$var$NORMALIZATION_MAP[key] || key;
}
var $ca9ce22b174df7eb$var$KEYBOARD_EVENT = "keydown";
function $ca9ce22b174df7eb$var$Keyboard(Splide2, Components2, options) {
    var _EventInterface10 = $ca9ce22b174df7eb$export$f188226459c8a3ff(Splide2), on = _EventInterface10.on, bind = _EventInterface10.bind, unbind = _EventInterface10.unbind;
    var root = Splide2.root;
    var resolve = Components2.Direction.resolve;
    var target;
    var disabled;
    function mount() {
        init();
        on($ca9ce22b174df7eb$export$db40ab7c0855fa5c, destroy);
        on($ca9ce22b174df7eb$export$db40ab7c0855fa5c, init);
        on($ca9ce22b174df7eb$export$2aa493d7c3275167, onMove);
    }
    function init() {
        var keyboard = options.keyboard;
        if (keyboard) {
            target = keyboard === "global" ? window : root;
            bind(target, $ca9ce22b174df7eb$var$KEYBOARD_EVENT, onKeydown);
        }
    }
    function destroy() {
        unbind(target, $ca9ce22b174df7eb$var$KEYBOARD_EVENT);
    }
    function disable(value) {
        disabled = value;
    }
    function onMove() {
        var _disabled = disabled;
        disabled = true;
        $ca9ce22b174df7eb$var$nextTick(function() {
            disabled = _disabled;
        });
    }
    function onKeydown(e) {
        if (!disabled) {
            var key = $ca9ce22b174df7eb$var$normalizeKey(e);
            if (key === resolve($ca9ce22b174df7eb$var$ARROW_LEFT)) Splide2.go("<");
            else if (key === resolve($ca9ce22b174df7eb$var$ARROW_RIGHT)) Splide2.go(">");
        }
    }
    return {
        mount: mount,
        destroy: destroy,
        disable: disable
    };
}
var $ca9ce22b174df7eb$var$SRC_DATA_ATTRIBUTE = $ca9ce22b174df7eb$var$DATA_ATTRIBUTE + "-lazy";
var $ca9ce22b174df7eb$var$SRCSET_DATA_ATTRIBUTE = $ca9ce22b174df7eb$var$SRC_DATA_ATTRIBUTE + "-srcset";
var $ca9ce22b174df7eb$var$IMAGE_SELECTOR = "[" + $ca9ce22b174df7eb$var$SRC_DATA_ATTRIBUTE + "], [" + $ca9ce22b174df7eb$var$SRCSET_DATA_ATTRIBUTE + "]";
function $ca9ce22b174df7eb$var$LazyLoad(Splide2, Components2, options) {
    var _EventInterface11 = $ca9ce22b174df7eb$export$f188226459c8a3ff(Splide2), on = _EventInterface11.on, off = _EventInterface11.off, bind = _EventInterface11.bind, emit = _EventInterface11.emit;
    var isSequential = options.lazyLoad === "sequential";
    var events = [
        $ca9ce22b174df7eb$export$fe5802204b967f0d,
        $ca9ce22b174df7eb$export$ff8164bff3202b9
    ];
    var entries = [];
    function mount() {
        if (options.lazyLoad) {
            init();
            on($ca9ce22b174df7eb$export$7f4701ac5e05e39f, init);
        }
    }
    function init() {
        $ca9ce22b174df7eb$var$empty(entries);
        register();
        if (isSequential) loadNext();
        else {
            off(events);
            on(events, check);
            check();
        }
    }
    function register() {
        Components2.Slides.forEach(function(Slide) {
            $ca9ce22b174df7eb$var$queryAll(Slide.slide, $ca9ce22b174df7eb$var$IMAGE_SELECTOR).forEach(function(img) {
                var src = $ca9ce22b174df7eb$var$getAttribute(img, $ca9ce22b174df7eb$var$SRC_DATA_ATTRIBUTE);
                var srcset = $ca9ce22b174df7eb$var$getAttribute(img, $ca9ce22b174df7eb$var$SRCSET_DATA_ATTRIBUTE);
                if (src !== img.src || srcset !== img.srcset) {
                    var className = options.classes.spinner;
                    var parent = img.parentElement;
                    var spinner = $ca9ce22b174df7eb$var$child(parent, "." + className) || $ca9ce22b174df7eb$var$create("span", className, parent);
                    entries.push([
                        img,
                        Slide,
                        spinner
                    ]);
                    img.src || $ca9ce22b174df7eb$var$display(img, "none");
                }
            });
        });
    }
    function check() {
        entries = entries.filter(function(data) {
            var distance = options.perPage * ((options.preloadPages || 1) + 1) - 1;
            return data[1].isWithin(Splide2.index, distance) ? load(data) : true;
        });
        entries.length || off(events);
    }
    function load(data) {
        var img = data[0];
        $ca9ce22b174df7eb$var$addClass(data[1].slide, $ca9ce22b174df7eb$export$d22ec4ccb7996ba2);
        bind(img, "load error", $ca9ce22b174df7eb$var$apply(onLoad, data));
        $ca9ce22b174df7eb$var$setAttribute(img, "src", $ca9ce22b174df7eb$var$getAttribute(img, $ca9ce22b174df7eb$var$SRC_DATA_ATTRIBUTE));
        $ca9ce22b174df7eb$var$setAttribute(img, "srcset", $ca9ce22b174df7eb$var$getAttribute(img, $ca9ce22b174df7eb$var$SRCSET_DATA_ATTRIBUTE));
        $ca9ce22b174df7eb$var$removeAttribute(img, $ca9ce22b174df7eb$var$SRC_DATA_ATTRIBUTE);
        $ca9ce22b174df7eb$var$removeAttribute(img, $ca9ce22b174df7eb$var$SRCSET_DATA_ATTRIBUTE);
    }
    function onLoad(data, e) {
        var img = data[0], Slide = data[1];
        $ca9ce22b174df7eb$var$removeClass(Slide.slide, $ca9ce22b174df7eb$export$d22ec4ccb7996ba2);
        if (e.type !== "error") {
            $ca9ce22b174df7eb$var$remove(data[2]);
            $ca9ce22b174df7eb$var$display(img, "");
            emit($ca9ce22b174df7eb$export$9f64346e17f0ec8e, img, Slide);
            emit($ca9ce22b174df7eb$export$7e019dae5103a285);
        }
        isSequential && loadNext();
    }
    function loadNext() {
        entries.length && load(entries.shift());
    }
    return {
        mount: mount,
        destroy: $ca9ce22b174df7eb$var$apply($ca9ce22b174df7eb$var$empty, entries),
        check: check
    };
}
function $ca9ce22b174df7eb$var$Pagination(Splide2, Components2, options) {
    var event = $ca9ce22b174df7eb$export$f188226459c8a3ff(Splide2);
    var on = event.on, emit = event.emit, bind = event.bind;
    var Slides = Components2.Slides, Elements = Components2.Elements, Controller = Components2.Controller;
    var hasFocus = Controller.hasFocus, getIndex = Controller.getIndex, go = Controller.go;
    var resolve = Components2.Direction.resolve;
    var placeholder = Elements.pagination;
    var items = [];
    var list;
    var paginationClasses;
    function mount() {
        destroy();
        on([
            $ca9ce22b174df7eb$export$db40ab7c0855fa5c,
            $ca9ce22b174df7eb$export$7f4701ac5e05e39f,
            $ca9ce22b174df7eb$export$28dea85f216954dc
        ], mount);
        var enabled = options.pagination;
        placeholder && $ca9ce22b174df7eb$var$display(placeholder, enabled ? "" : "none");
        if (enabled) {
            on([
                $ca9ce22b174df7eb$export$2aa493d7c3275167,
                $ca9ce22b174df7eb$export$49801896908b5e33,
                $ca9ce22b174df7eb$export$ff8164bff3202b9
            ], update);
            createPagination();
            update();
            emit($ca9ce22b174df7eb$export$bf89a4e4349c9778, {
                list: list,
                items: items
            }, getAt(Splide2.index));
        }
    }
    function destroy() {
        if (list) {
            $ca9ce22b174df7eb$var$remove(placeholder ? $ca9ce22b174df7eb$var$slice(list.children) : list);
            $ca9ce22b174df7eb$var$removeClass(list, paginationClasses);
            $ca9ce22b174df7eb$var$empty(items);
            list = null;
        }
        event.destroy();
    }
    function createPagination() {
        var length = Splide2.length;
        var classes = options.classes, i18n = options.i18n, perPage = options.perPage;
        var max = hasFocus() ? Controller.getEnd() + 1 : $ca9ce22b174df7eb$var$ceil(length / perPage);
        list = placeholder || $ca9ce22b174df7eb$var$create("ul", classes.pagination, Elements.track.parentElement);
        $ca9ce22b174df7eb$var$addClass(list, paginationClasses = $ca9ce22b174df7eb$export$cbf8e5a0ab95eda3 + "--" + getDirection());
        $ca9ce22b174df7eb$var$setAttribute(list, $ca9ce22b174df7eb$var$ROLE, "tablist");
        $ca9ce22b174df7eb$var$setAttribute(list, $ca9ce22b174df7eb$var$ARIA_LABEL, i18n.select);
        $ca9ce22b174df7eb$var$setAttribute(list, $ca9ce22b174df7eb$var$ARIA_ORIENTATION, getDirection() === $ca9ce22b174df7eb$export$97170d9824b89709 ? "vertical" : "");
        for(var i = 0; i < max; i++){
            var li = $ca9ce22b174df7eb$var$create("li", null, list);
            var button = $ca9ce22b174df7eb$var$create("button", {
                class: classes.page,
                type: "button"
            }, li);
            var controls = Slides.getIn(i).map(function(Slide) {
                return Slide.slide.id;
            });
            var text = !hasFocus() && perPage > 1 ? i18n.pageX : i18n.slideX;
            bind(button, "click", $ca9ce22b174df7eb$var$apply(onClick, i));
            if (options.paginationKeyboard) bind(button, "keydown", $ca9ce22b174df7eb$var$apply(onKeydown, i));
            $ca9ce22b174df7eb$var$setAttribute(li, $ca9ce22b174df7eb$var$ROLE, "presentation");
            $ca9ce22b174df7eb$var$setAttribute(button, $ca9ce22b174df7eb$var$ROLE, "tab");
            $ca9ce22b174df7eb$var$setAttribute(button, $ca9ce22b174df7eb$var$ARIA_CONTROLS, controls.join(" "));
            $ca9ce22b174df7eb$var$setAttribute(button, $ca9ce22b174df7eb$var$ARIA_LABEL, $ca9ce22b174df7eb$var$format(text, i + 1));
            $ca9ce22b174df7eb$var$setAttribute(button, $ca9ce22b174df7eb$var$TAB_INDEX, -1);
            items.push({
                li: li,
                button: button,
                page: i
            });
        }
    }
    function onClick(page) {
        go(">" + page, true);
    }
    function onKeydown(page, e) {
        var length = items.length;
        var key = $ca9ce22b174df7eb$var$normalizeKey(e);
        var dir = getDirection();
        var nextPage = -1;
        if (key === resolve($ca9ce22b174df7eb$var$ARROW_RIGHT, false, dir)) nextPage = ++page % length;
        else if (key === resolve($ca9ce22b174df7eb$var$ARROW_LEFT, false, dir)) nextPage = (--page + length) % length;
        else if (key === "Home") nextPage = 0;
        else if (key === "End") nextPage = length - 1;
        var item = items[nextPage];
        if (item) {
            $ca9ce22b174df7eb$var$focus(item.button);
            go(">" + nextPage);
            $ca9ce22b174df7eb$var$prevent(e, true);
        }
    }
    function getDirection() {
        return options.paginationDirection || options.direction;
    }
    function getAt(index) {
        return items[Controller.toPage(index)];
    }
    function update() {
        var prev = getAt(getIndex(true));
        var curr = getAt(getIndex());
        if (prev) {
            var button = prev.button;
            $ca9ce22b174df7eb$var$removeClass(button, $ca9ce22b174df7eb$export$72d36ecf3758cb4b);
            $ca9ce22b174df7eb$var$removeAttribute(button, $ca9ce22b174df7eb$var$ARIA_SELECTED);
            $ca9ce22b174df7eb$var$setAttribute(button, $ca9ce22b174df7eb$var$TAB_INDEX, -1);
        }
        if (curr) {
            var _button = curr.button;
            $ca9ce22b174df7eb$var$addClass(_button, $ca9ce22b174df7eb$export$72d36ecf3758cb4b);
            $ca9ce22b174df7eb$var$setAttribute(_button, $ca9ce22b174df7eb$var$ARIA_SELECTED, true);
            $ca9ce22b174df7eb$var$setAttribute(_button, $ca9ce22b174df7eb$var$TAB_INDEX, "");
        }
        emit($ca9ce22b174df7eb$export$eb2019082ed6de0b, {
            list: list,
            items: items
        }, prev, curr);
    }
    return {
        items: items,
        mount: mount,
        destroy: destroy,
        getAt: getAt,
        update: update
    };
}
var $ca9ce22b174df7eb$var$TRIGGER_KEYS = [
    " ",
    "Enter"
];
function $ca9ce22b174df7eb$var$Sync(Splide2, Components2, options) {
    var isNavigation = options.isNavigation, slideFocus = options.slideFocus;
    var events = [];
    function mount() {
        Splide2.splides.forEach(function(target) {
            if (!target.isParent) {
                sync(Splide2, target.splide);
                sync(target.splide, Splide2);
            }
        });
        if (isNavigation) navigate();
    }
    function destroy() {
        events.forEach(function(event) {
            event.destroy();
        });
        $ca9ce22b174df7eb$var$empty(events);
    }
    function remount() {
        destroy();
        mount();
    }
    function sync(splide, target) {
        var event = $ca9ce22b174df7eb$export$f188226459c8a3ff(splide);
        event.on($ca9ce22b174df7eb$export$2aa493d7c3275167, function(index, prev, dest) {
            target.go(target.is($ca9ce22b174df7eb$export$f42383286ed1223d) ? dest : index);
        });
        events.push(event);
    }
    function navigate() {
        var event = $ca9ce22b174df7eb$export$f188226459c8a3ff(Splide2);
        var on = event.on;
        on($ca9ce22b174df7eb$export$5adb665701eda1ce, onClick);
        on($ca9ce22b174df7eb$export$6d5af59619d10e6a, onKeydown);
        on([
            $ca9ce22b174df7eb$export$d300dc1a2634364b,
            $ca9ce22b174df7eb$export$db40ab7c0855fa5c
        ], update);
        events.push(event);
        event.emit($ca9ce22b174df7eb$export$84015c33508f94ec, Splide2.splides);
    }
    function update() {
        $ca9ce22b174df7eb$var$setAttribute(Components2.Elements.list, $ca9ce22b174df7eb$var$ARIA_ORIENTATION, options.direction === $ca9ce22b174df7eb$export$97170d9824b89709 ? "vertical" : "");
    }
    function onClick(Slide) {
        Splide2.go(Slide.index);
    }
    function onKeydown(Slide, e) {
        if ($ca9ce22b174df7eb$var$includes($ca9ce22b174df7eb$var$TRIGGER_KEYS, $ca9ce22b174df7eb$var$normalizeKey(e))) {
            onClick(Slide);
            $ca9ce22b174df7eb$var$prevent(e);
        }
    }
    return {
        setup: $ca9ce22b174df7eb$var$apply(Components2.Media.set, {
            slideFocus: $ca9ce22b174df7eb$var$isUndefined(slideFocus) ? isNavigation : slideFocus
        }, true),
        mount: mount,
        destroy: destroy,
        remount: remount
    };
}
function $ca9ce22b174df7eb$var$Wheel(Splide2, Components2, options) {
    var _EventInterface12 = $ca9ce22b174df7eb$export$f188226459c8a3ff(Splide2), bind = _EventInterface12.bind;
    var lastTime = 0;
    function mount() {
        if (options.wheel) bind(Components2.Elements.track, "wheel", onWheel, $ca9ce22b174df7eb$var$SCROLL_LISTENER_OPTIONS);
    }
    function onWheel(e) {
        if (e.cancelable) {
            var deltaY = e.deltaY;
            var backwards = deltaY < 0;
            var timeStamp = $ca9ce22b174df7eb$var$timeOf(e);
            var _min = options.wheelMinThreshold || 0;
            var sleep = options.wheelSleep || 0;
            if ($ca9ce22b174df7eb$var$abs(deltaY) > _min && timeStamp - lastTime > sleep) {
                Splide2.go(backwards ? "<" : ">");
                lastTime = timeStamp;
            }
            shouldPrevent(backwards) && $ca9ce22b174df7eb$var$prevent(e);
        }
    }
    function shouldPrevent(backwards) {
        return !options.releaseWheel || Splide2.state.is($ca9ce22b174df7eb$var$MOVING) || Components2.Controller.getAdjacent(backwards) !== -1;
    }
    return {
        mount: mount
    };
}
var $ca9ce22b174df7eb$var$SR_REMOVAL_DELAY = 90;
function $ca9ce22b174df7eb$var$Live(Splide2, Components2, options) {
    var _EventInterface13 = $ca9ce22b174df7eb$export$f188226459c8a3ff(Splide2), on = _EventInterface13.on;
    var track = Components2.Elements.track;
    var enabled = options.live && !options.isNavigation;
    var sr = $ca9ce22b174df7eb$var$create("span", $ca9ce22b174df7eb$export$bb78d7c200da8960);
    var interval = $ca9ce22b174df7eb$export$46ad21b25b6dccf0($ca9ce22b174df7eb$var$SR_REMOVAL_DELAY, $ca9ce22b174df7eb$var$apply(toggle, false));
    function mount() {
        if (enabled) {
            disable(!Components2.Autoplay.isPaused());
            $ca9ce22b174df7eb$var$setAttribute(track, $ca9ce22b174df7eb$var$ARIA_ATOMIC, true);
            sr.textContent = "\u2026";
            on($ca9ce22b174df7eb$export$23663268a31b79e2, $ca9ce22b174df7eb$var$apply(disable, true));
            on($ca9ce22b174df7eb$export$16a1e4f3d0368265, $ca9ce22b174df7eb$var$apply(disable, false));
            on([
                $ca9ce22b174df7eb$export$fe5802204b967f0d,
                $ca9ce22b174df7eb$export$ff8164bff3202b9
            ], $ca9ce22b174df7eb$var$apply(toggle, true));
        }
    }
    function toggle(active) {
        $ca9ce22b174df7eb$var$setAttribute(track, $ca9ce22b174df7eb$var$ARIA_BUSY, active);
        if (active) {
            $ca9ce22b174df7eb$var$append(track, sr);
            interval.start();
        } else {
            $ca9ce22b174df7eb$var$remove(sr);
            interval.cancel();
        }
    }
    function destroy() {
        $ca9ce22b174df7eb$var$removeAttribute(track, [
            $ca9ce22b174df7eb$var$ARIA_LIVE,
            $ca9ce22b174df7eb$var$ARIA_ATOMIC,
            $ca9ce22b174df7eb$var$ARIA_BUSY
        ]);
        $ca9ce22b174df7eb$var$remove(sr);
    }
    function disable(disabled) {
        if (enabled) $ca9ce22b174df7eb$var$setAttribute(track, $ca9ce22b174df7eb$var$ARIA_LIVE, disabled ? "off" : "polite");
    }
    return {
        mount: mount,
        disable: disable,
        destroy: destroy
    };
}
var $ca9ce22b174df7eb$var$ComponentConstructors = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    Media: $ca9ce22b174df7eb$var$Media,
    Direction: $ca9ce22b174df7eb$var$Direction,
    Elements: $ca9ce22b174df7eb$var$Elements,
    Slides: $ca9ce22b174df7eb$var$Slides,
    Layout: $ca9ce22b174df7eb$var$Layout,
    Clones: $ca9ce22b174df7eb$var$Clones,
    Move: $ca9ce22b174df7eb$var$Move,
    Controller: $ca9ce22b174df7eb$var$Controller,
    Arrows: $ca9ce22b174df7eb$var$Arrows,
    Autoplay: $ca9ce22b174df7eb$var$Autoplay,
    Cover: $ca9ce22b174df7eb$var$Cover,
    Scroll: $ca9ce22b174df7eb$var$Scroll,
    Drag: $ca9ce22b174df7eb$var$Drag,
    Keyboard: $ca9ce22b174df7eb$var$Keyboard,
    LazyLoad: $ca9ce22b174df7eb$var$LazyLoad,
    Pagination: $ca9ce22b174df7eb$var$Pagination,
    Sync: $ca9ce22b174df7eb$var$Sync,
    Wheel: $ca9ce22b174df7eb$var$Wheel,
    Live: $ca9ce22b174df7eb$var$Live
});
var $ca9ce22b174df7eb$var$I18N = {
    prev: "Previous slide",
    next: "Next slide",
    first: "Go to first slide",
    last: "Go to last slide",
    slideX: "Go to slide %s",
    pageX: "Go to page %s",
    play: "Start autoplay",
    pause: "Pause autoplay",
    carousel: "carousel",
    slide: "slide",
    select: "Select a slide to show",
    slideLabel: "%s of %s"
};
var $ca9ce22b174df7eb$export$f484e977a69c6ba6 = {
    type: "slide",
    role: "region",
    speed: 400,
    perPage: 1,
    cloneStatus: true,
    arrows: true,
    pagination: true,
    paginationKeyboard: true,
    interval: 5e3,
    pauseOnHover: true,
    pauseOnFocus: true,
    resetProgress: true,
    easing: "cubic-bezier(0.25, 1, 0.5, 1)",
    drag: true,
    direction: "ltr",
    trimSpace: true,
    focusableNodes: "a, button, textarea, input, select, iframe",
    live: true,
    classes: $ca9ce22b174df7eb$export$ba41d43e4a419565,
    i18n: $ca9ce22b174df7eb$var$I18N,
    reducedMotion: {
        speed: 0,
        rewindSpeed: 0,
        autoplay: "pause"
    }
};
function $ca9ce22b174df7eb$var$Fade(Splide2, Components2, options) {
    var Slides = Components2.Slides;
    function mount() {
        $ca9ce22b174df7eb$export$f188226459c8a3ff(Splide2).on([
            $ca9ce22b174df7eb$export$d300dc1a2634364b,
            $ca9ce22b174df7eb$export$7f4701ac5e05e39f
        ], init);
    }
    function init() {
        Slides.forEach(function(Slide) {
            Slide.style("transform", "translateX(-" + 100 * Slide.index + "%)");
        });
    }
    function start(index, done) {
        Slides.style("transition", "opacity " + options.speed + "ms " + options.easing);
        $ca9ce22b174df7eb$var$nextTick(done);
    }
    return {
        mount: mount,
        start: start,
        cancel: $ca9ce22b174df7eb$var$noop
    };
}
function $ca9ce22b174df7eb$var$Slide(Splide2, Components2, options) {
    var Move = Components2.Move, Controller = Components2.Controller, Scroll = Components2.Scroll;
    var list = Components2.Elements.list;
    var transition = $ca9ce22b174df7eb$var$apply($ca9ce22b174df7eb$var$style, list, "transition");
    var endCallback;
    function mount() {
        $ca9ce22b174df7eb$export$f188226459c8a3ff(Splide2).bind(list, "transitionend", function(e) {
            if (e.target === list && endCallback) {
                cancel();
                endCallback();
            }
        });
    }
    function start(index, done) {
        var destination = Move.toPosition(index, true);
        var position = Move.getPosition();
        var speed = getSpeed(index);
        if ($ca9ce22b174df7eb$var$abs(destination - position) >= 1 && speed >= 1) {
            if (options.useScroll) Scroll.scroll(destination, speed, false, done);
            else {
                transition("transform " + speed + "ms " + options.easing);
                Move.translate(destination, true);
                endCallback = done;
            }
        } else {
            Move.jump(index);
            done();
        }
    }
    function cancel() {
        transition("");
        Scroll.cancel();
    }
    function getSpeed(index) {
        var rewindSpeed = options.rewindSpeed;
        if (Splide2.is($ca9ce22b174df7eb$export$e5a58a5ee5b54c22) && rewindSpeed) {
            var prev = Controller.getIndex(true);
            var end = Controller.getEnd();
            if (prev === 0 && index >= end || prev >= end && index === 0) return rewindSpeed;
        }
        return options.speed;
    }
    return {
        mount: mount,
        start: start,
        cancel: cancel
    };
}
var $ca9ce22b174df7eb$var$_Splide = /*#__PURE__*/ function() {
    function _Splide(target, options) {
        this.event = $ca9ce22b174df7eb$export$f188226459c8a3ff();
        this.Components = {};
        this.state = $ca9ce22b174df7eb$export$7254cc27399e90bd($ca9ce22b174df7eb$var$CREATED);
        this.splides = [];
        this._o = {};
        this._E = {};
        var root = $ca9ce22b174df7eb$var$isString(target) ? $ca9ce22b174df7eb$var$query(document, target) : target;
        $ca9ce22b174df7eb$var$assert(root, root + " is invalid.");
        this.root = root;
        options = $ca9ce22b174df7eb$var$merge({
            label: $ca9ce22b174df7eb$var$getAttribute(root, $ca9ce22b174df7eb$var$ARIA_LABEL) || "",
            labelledby: $ca9ce22b174df7eb$var$getAttribute(root, $ca9ce22b174df7eb$var$ARIA_LABELLEDBY) || ""
        }, $ca9ce22b174df7eb$export$f484e977a69c6ba6, _Splide.defaults, options || {});
        try {
            $ca9ce22b174df7eb$var$merge(options, JSON.parse($ca9ce22b174df7eb$var$getAttribute(root, $ca9ce22b174df7eb$var$DATA_ATTRIBUTE)));
        } catch (e) {
            $ca9ce22b174df7eb$var$assert(false, "Invalid JSON");
        }
        this._o = Object.create($ca9ce22b174df7eb$var$merge({}, options));
    }
    var _proto = _Splide.prototype;
    _proto.mount = function mount(Extensions, Transition) {
        var _this = this;
        var state = this.state, Components2 = this.Components;
        $ca9ce22b174df7eb$var$assert(state.is([
            $ca9ce22b174df7eb$var$CREATED,
            $ca9ce22b174df7eb$var$DESTROYED
        ]), "Already mounted!");
        state.set($ca9ce22b174df7eb$var$CREATED);
        this._C = Components2;
        this._T = Transition || this._T || (this.is($ca9ce22b174df7eb$export$742b62a5690c060) ? $ca9ce22b174df7eb$var$Fade : $ca9ce22b174df7eb$var$Slide);
        this._E = Extensions || this._E;
        var Constructors = $ca9ce22b174df7eb$var$assign({}, $ca9ce22b174df7eb$var$ComponentConstructors, this._E, {
            Transition: this._T
        });
        $ca9ce22b174df7eb$var$forOwn(Constructors, function(Component, key) {
            var component = Component(_this, Components2, _this._o);
            Components2[key] = component;
            component.setup && component.setup();
        });
        $ca9ce22b174df7eb$var$forOwn(Components2, function(component) {
            component.mount && component.mount();
        });
        this.emit($ca9ce22b174df7eb$export$d300dc1a2634364b);
        $ca9ce22b174df7eb$var$addClass(this.root, $ca9ce22b174df7eb$export$7761661e2d5b9388);
        state.set($ca9ce22b174df7eb$var$IDLE);
        this.emit($ca9ce22b174df7eb$export$d8dac49b4532735a);
        return this;
    };
    _proto.sync = function sync(splide) {
        this.splides.push({
            splide: splide
        });
        splide.splides.push({
            splide: this,
            isParent: true
        });
        if (this.state.is($ca9ce22b174df7eb$var$IDLE)) {
            this._C.Sync.remount();
            splide.Components.Sync.remount();
        }
        return this;
    };
    _proto.go = function go(control) {
        this._C.Controller.go(control);
        return this;
    };
    _proto.on = function on(events, callback) {
        this.event.on(events, callback);
        return this;
    };
    _proto.off = function off(events) {
        this.event.off(events);
        return this;
    };
    _proto.emit = function emit(event) {
        var _this$event;
        (_this$event = this.event).emit.apply(_this$event, [
            event
        ].concat($ca9ce22b174df7eb$var$slice(arguments, 1)));
        return this;
    };
    _proto.add = function add(slides, index) {
        this._C.Slides.add(slides, index);
        return this;
    };
    _proto.remove = function remove(matcher) {
        this._C.Slides.remove(matcher);
        return this;
    };
    _proto.is = function is(type) {
        return this._o.type === type;
    };
    _proto.refresh = function refresh() {
        this.emit($ca9ce22b174df7eb$export$7f4701ac5e05e39f);
        return this;
    };
    _proto.destroy = function destroy(completely) {
        if (completely === void 0) completely = true;
        var event = this.event, state = this.state;
        if (state.is($ca9ce22b174df7eb$var$CREATED)) $ca9ce22b174df7eb$export$f188226459c8a3ff(this).on($ca9ce22b174df7eb$export$d8dac49b4532735a, this.destroy.bind(this, completely));
        else {
            $ca9ce22b174df7eb$var$forOwn(this._C, function(component) {
                component.destroy && component.destroy(completely);
            }, true);
            event.emit($ca9ce22b174df7eb$export$88c4cf7419e470cd);
            event.destroy();
            completely && $ca9ce22b174df7eb$var$empty(this.splides);
            state.set($ca9ce22b174df7eb$var$DESTROYED);
        }
        return this;
    };
    $ca9ce22b174df7eb$var$_createClass(_Splide, [
        {
            key: "options",
            get: function get() {
                return this._o;
            },
            set: function set(options) {
                this._C.Media.set(options, true, true);
            }
        },
        {
            key: "length",
            get: function get() {
                return this._C.Slides.getLength(true);
            }
        },
        {
            key: "index",
            get: function get() {
                return this._C.Controller.getIndex();
            }
        }
    ]);
    return _Splide;
}();
var $ca9ce22b174df7eb$export$24494c7438c070bf = $ca9ce22b174df7eb$var$_Splide;
$ca9ce22b174df7eb$export$24494c7438c070bf.defaults = {};
$ca9ce22b174df7eb$export$24494c7438c070bf.STATES = $ca9ce22b174df7eb$var$STATES;
var $ca9ce22b174df7eb$var$CLASS_RENDERED = "is-rendered";
var $ca9ce22b174df7eb$var$RENDERER_DEFAULT_CONFIG = {
    listTag: "ul",
    slideTag: "li"
};
var $ca9ce22b174df7eb$var$Style = /*#__PURE__*/ function() {
    function Style(id, options) {
        this.styles = {};
        this.id = id;
        this.options = options;
    }
    var _proto2 = Style.prototype;
    _proto2.rule = function rule(selector, prop, value, breakpoint) {
        breakpoint = breakpoint || "default";
        var selectors = this.styles[breakpoint] = this.styles[breakpoint] || {};
        var styles = selectors[selector] = selectors[selector] || {};
        styles[prop] = value;
    };
    _proto2.build = function build() {
        var _this2 = this;
        var css = "";
        if (this.styles.default) css += this.buildSelectors(this.styles.default);
        Object.keys(this.styles).sort(function(n, m) {
            return _this2.options.mediaQuery === "min" ? +n - +m : +m - +n;
        }).forEach(function(breakpoint) {
            if (breakpoint !== "default") {
                css += "@media screen and (max-width: " + breakpoint + "px) {";
                css += _this2.buildSelectors(_this2.styles[breakpoint]);
                css += "}";
            }
        });
        return css;
    };
    _proto2.buildSelectors = function buildSelectors(selectors) {
        var _this3 = this;
        var css = "";
        $ca9ce22b174df7eb$var$forOwn(selectors, function(styles, selector) {
            selector = ("#" + _this3.id + " " + selector).trim();
            css += selector + " {";
            $ca9ce22b174df7eb$var$forOwn(styles, function(value, prop) {
                if (value || value === 0) css += prop + ": " + value + ";";
            });
            css += "}";
        });
        return css;
    };
    return Style;
}();
var $ca9ce22b174df7eb$export$c0daaea79e41d7df = /*#__PURE__*/ function() {
    function SplideRenderer(contents, options, config, defaults) {
        this.slides = [];
        this.options = {};
        this.breakpoints = [];
        $ca9ce22b174df7eb$var$merge($ca9ce22b174df7eb$export$f484e977a69c6ba6, defaults || {});
        $ca9ce22b174df7eb$var$merge($ca9ce22b174df7eb$var$merge(this.options, $ca9ce22b174df7eb$export$f484e977a69c6ba6), options || {});
        this.contents = contents;
        this.config = $ca9ce22b174df7eb$var$assign({}, $ca9ce22b174df7eb$var$RENDERER_DEFAULT_CONFIG, config || {});
        this.id = this.config.id || $ca9ce22b174df7eb$var$uniqueId("splide");
        this.Style = new $ca9ce22b174df7eb$var$Style(this.id, this.options);
        this.Direction = $ca9ce22b174df7eb$var$Direction(null, null, this.options);
        $ca9ce22b174df7eb$var$assert(this.contents.length, "Provide at least 1 content.");
        this.init();
    }
    SplideRenderer.clean = function clean(splide) {
        var _EventInterface14 = $ca9ce22b174df7eb$export$f188226459c8a3ff(splide), on = _EventInterface14.on;
        var root = splide.root;
        var clones = $ca9ce22b174df7eb$var$queryAll(root, "." + $ca9ce22b174df7eb$export$2c1ba4a4f1aa4947);
        on($ca9ce22b174df7eb$export$d300dc1a2634364b, function() {
            $ca9ce22b174df7eb$var$remove($ca9ce22b174df7eb$var$child(root, "style"));
        });
        $ca9ce22b174df7eb$var$remove(clones);
    };
    var _proto3 = SplideRenderer.prototype;
    _proto3.init = function init() {
        this.parseBreakpoints();
        this.initSlides();
        this.registerRootStyles();
        this.registerTrackStyles();
        this.registerSlideStyles();
        this.registerListStyles();
    };
    _proto3.initSlides = function initSlides() {
        var _this4 = this;
        $ca9ce22b174df7eb$var$push(this.slides, this.contents.map(function(content, index) {
            content = $ca9ce22b174df7eb$var$isString(content) ? {
                html: content
            } : content;
            content.styles = content.styles || {};
            content.attrs = content.attrs || {};
            _this4.cover(content);
            var classes = _this4.options.classes.slide + " " + (index === 0 ? $ca9ce22b174df7eb$export$72d36ecf3758cb4b : "");
            $ca9ce22b174df7eb$var$assign(content.attrs, {
                class: (classes + " " + (content.attrs.class || "")).trim(),
                style: _this4.buildStyles(content.styles)
            });
            return content;
        }));
        if (this.isLoop()) this.generateClones(this.slides);
    };
    _proto3.registerRootStyles = function registerRootStyles() {
        var _this5 = this;
        this.breakpoints.forEach(function(_ref2) {
            var width = _ref2[0], options = _ref2[1];
            _this5.Style.rule(" ", "max-width", $ca9ce22b174df7eb$var$unit(options.width), width);
        });
    };
    _proto3.registerTrackStyles = function registerTrackStyles() {
        var _this6 = this;
        var Style2 = this.Style;
        var selector = "." + $ca9ce22b174df7eb$export$7738b09ac0a98952;
        this.breakpoints.forEach(function(_ref3) {
            var width = _ref3[0], options = _ref3[1];
            Style2.rule(selector, _this6.resolve("paddingLeft"), _this6.cssPadding(options, false), width);
            Style2.rule(selector, _this6.resolve("paddingRight"), _this6.cssPadding(options, true), width);
            Style2.rule(selector, "height", _this6.cssTrackHeight(options), width);
        });
    };
    _proto3.registerListStyles = function registerListStyles() {
        var _this7 = this;
        var Style2 = this.Style;
        var selector = "." + $ca9ce22b174df7eb$export$19cc2a5451235cae;
        this.breakpoints.forEach(function(_ref4) {
            var width = _ref4[0], options = _ref4[1];
            Style2.rule(selector, "transform", _this7.buildTranslate(options), width);
            if (!_this7.cssSlideHeight(options)) Style2.rule(selector, "aspect-ratio", _this7.cssAspectRatio(options), width);
        });
    };
    _proto3.registerSlideStyles = function registerSlideStyles() {
        var _this8 = this;
        var Style2 = this.Style;
        var selector = "." + $ca9ce22b174df7eb$export$8d922915837a38d3;
        this.breakpoints.forEach(function(_ref5) {
            var width = _ref5[0], options = _ref5[1];
            Style2.rule(selector, "width", _this8.cssSlideWidth(options), width);
            Style2.rule(selector, "height", _this8.cssSlideHeight(options) || "100%", width);
            Style2.rule(selector, _this8.resolve("marginRight"), $ca9ce22b174df7eb$var$unit(options.gap) || "0px", width);
            Style2.rule(selector + " > img", "display", options.cover ? "none" : "inline", width);
        });
    };
    _proto3.buildTranslate = function buildTranslate(options) {
        var _this$Direction = this.Direction, resolve = _this$Direction.resolve, orient = _this$Direction.orient;
        var values = [];
        values.push(this.cssOffsetClones(options));
        values.push(this.cssOffsetGaps(options));
        if (this.isCenter(options)) {
            values.push(this.buildCssValue(orient(-50), "%"));
            values.push.apply(values, this.cssOffsetCenter(options));
        }
        return values.filter(Boolean).map(function(value) {
            return "translate" + resolve("X") + "(" + value + ")";
        }).join(" ");
    };
    _proto3.cssOffsetClones = function cssOffsetClones(options) {
        var _this$Direction2 = this.Direction, resolve = _this$Direction2.resolve, orient = _this$Direction2.orient;
        var cloneCount = this.getCloneCount();
        if (this.isFixedWidth(options)) {
            var _this$parseCssValue = this.parseCssValue(options[resolve("fixedWidth")]), value = _this$parseCssValue.value, unit2 = _this$parseCssValue.unit;
            return this.buildCssValue(orient(value) * cloneCount, unit2);
        }
        var percent = 100 * cloneCount / options.perPage;
        return orient(percent) + "%";
    };
    _proto3.cssOffsetCenter = function cssOffsetCenter(options) {
        var _this$Direction3 = this.Direction, resolve = _this$Direction3.resolve, orient = _this$Direction3.orient;
        if (this.isFixedWidth(options)) {
            var _this$parseCssValue2 = this.parseCssValue(options[resolve("fixedWidth")]), value = _this$parseCssValue2.value, unit2 = _this$parseCssValue2.unit;
            return [
                this.buildCssValue(orient(value / 2), unit2)
            ];
        }
        var values = [];
        var perPage = options.perPage, gap = options.gap;
        values.push(orient(50 / perPage) + "%");
        if (gap) {
            var _this$parseCssValue3 = this.parseCssValue(gap), _value = _this$parseCssValue3.value, _unit = _this$parseCssValue3.unit;
            var gapOffset = (_value / perPage - _value) / 2;
            values.push(this.buildCssValue(orient(gapOffset), _unit));
        }
        return values;
    };
    _proto3.cssOffsetGaps = function cssOffsetGaps(options) {
        var cloneCount = this.getCloneCount();
        if (cloneCount && options.gap) {
            var orient = this.Direction.orient;
            var _this$parseCssValue4 = this.parseCssValue(options.gap), value = _this$parseCssValue4.value, unit2 = _this$parseCssValue4.unit;
            if (this.isFixedWidth(options)) return this.buildCssValue(orient(value * cloneCount), unit2);
            var perPage = options.perPage;
            var gaps = cloneCount / perPage;
            return this.buildCssValue(orient(gaps * value), unit2);
        }
        return "";
    };
    _proto3.resolve = function resolve(prop) {
        return $ca9ce22b174df7eb$var$camelToKebab(this.Direction.resolve(prop));
    };
    _proto3.cssPadding = function cssPadding(options, right) {
        var padding = options.padding;
        var prop = this.Direction.resolve(right ? "right" : "left", true);
        return padding && $ca9ce22b174df7eb$var$unit(padding[prop] || ($ca9ce22b174df7eb$var$isObject(padding) ? 0 : padding)) || "0px";
    };
    _proto3.cssTrackHeight = function cssTrackHeight(options) {
        var height = "";
        if (this.isVertical()) {
            height = this.cssHeight(options);
            $ca9ce22b174df7eb$var$assert(height, '"height" is missing.');
            height = "calc(" + height + " - " + this.cssPadding(options, false) + " - " + this.cssPadding(options, true) + ")";
        }
        return height;
    };
    _proto3.cssHeight = function cssHeight(options) {
        return $ca9ce22b174df7eb$var$unit(options.height);
    };
    _proto3.cssSlideWidth = function cssSlideWidth(options) {
        return options.autoWidth ? "" : $ca9ce22b174df7eb$var$unit(options.fixedWidth) || (this.isVertical() ? "" : this.cssSlideSize(options));
    };
    _proto3.cssSlideHeight = function cssSlideHeight(options) {
        return $ca9ce22b174df7eb$var$unit(options.fixedHeight) || (this.isVertical() ? options.autoHeight ? "" : this.cssSlideSize(options) : this.cssHeight(options));
    };
    _proto3.cssSlideSize = function cssSlideSize(options) {
        var gap = $ca9ce22b174df7eb$var$unit(options.gap);
        return "calc((100%" + (gap && " + " + gap) + ")/" + (options.perPage || 1) + (gap && " - " + gap) + ")";
    };
    _proto3.cssAspectRatio = function cssAspectRatio(options) {
        var heightRatio = options.heightRatio;
        return heightRatio ? "" + 1 / heightRatio : "";
    };
    _proto3.buildCssValue = function buildCssValue(value, unit2) {
        return "" + value + unit2;
    };
    _proto3.parseCssValue = function parseCssValue(value) {
        if ($ca9ce22b174df7eb$var$isString(value)) {
            var number = parseFloat(value) || 0;
            var unit2 = value.replace(/\d*(\.\d*)?/, "") || "px";
            return {
                value: number,
                unit: unit2
            };
        }
        return {
            value: value,
            unit: "px"
        };
    };
    _proto3.parseBreakpoints = function parseBreakpoints() {
        var _this9 = this;
        var breakpoints = this.options.breakpoints;
        this.breakpoints.push([
            "default",
            this.options
        ]);
        if (breakpoints) $ca9ce22b174df7eb$var$forOwn(breakpoints, function(options, width) {
            _this9.breakpoints.push([
                width,
                $ca9ce22b174df7eb$var$merge($ca9ce22b174df7eb$var$merge({}, _this9.options), options)
            ]);
        });
    };
    _proto3.isFixedWidth = function isFixedWidth(options) {
        return !!options[this.Direction.resolve("fixedWidth")];
    };
    _proto3.isLoop = function isLoop() {
        return this.options.type === $ca9ce22b174df7eb$export$f42383286ed1223d;
    };
    _proto3.isCenter = function isCenter(options) {
        if (options.focus === "center") {
            if (this.isLoop()) return true;
            if (this.options.type === $ca9ce22b174df7eb$export$e5a58a5ee5b54c22) return !this.options.trimSpace;
        }
        return false;
    };
    _proto3.isVertical = function isVertical() {
        return this.options.direction === $ca9ce22b174df7eb$export$97170d9824b89709;
    };
    _proto3.buildClasses = function buildClasses() {
        var options = this.options;
        return [
            $ca9ce22b174df7eb$export$93b21159ad85c843,
            $ca9ce22b174df7eb$export$93b21159ad85c843 + "--" + options.type,
            $ca9ce22b174df7eb$export$93b21159ad85c843 + "--" + options.direction,
            options.drag && $ca9ce22b174df7eb$export$93b21159ad85c843 + "--draggable",
            options.isNavigation && $ca9ce22b174df7eb$export$93b21159ad85c843 + "--nav",
            $ca9ce22b174df7eb$export$72d36ecf3758cb4b,
            !this.config.hidden && $ca9ce22b174df7eb$var$CLASS_RENDERED
        ].filter(Boolean).join(" ");
    };
    _proto3.buildAttrs = function buildAttrs(attrs) {
        var attr = "";
        $ca9ce22b174df7eb$var$forOwn(attrs, function(value, key) {
            attr += value ? " " + $ca9ce22b174df7eb$var$camelToKebab(key) + "=\"" + value + "\"" : "";
        });
        return attr.trim();
    };
    _proto3.buildStyles = function buildStyles(styles) {
        var style = "";
        $ca9ce22b174df7eb$var$forOwn(styles, function(value, key) {
            style += " " + $ca9ce22b174df7eb$var$camelToKebab(key) + ":" + value + ";";
        });
        return style.trim();
    };
    _proto3.renderSlides = function renderSlides() {
        var _this10 = this;
        var tag = this.config.slideTag;
        return this.slides.map(function(content) {
            return "<" + tag + " " + _this10.buildAttrs(content.attrs) + ">" + (content.html || "") + "</" + tag + ">";
        }).join("");
    };
    _proto3.cover = function cover(content) {
        var styles = content.styles, _content$html = content.html, html = _content$html === void 0 ? "" : _content$html;
        if (this.options.cover && !this.options.lazyLoad) {
            var src = html.match(/<img.*?src\s*=\s*(['"])(.+?)\1.*?>/);
            if (src && src[2]) styles.background = "center/cover no-repeat url('" + src[2] + "')";
        }
    };
    _proto3.generateClones = function generateClones(contents) {
        var classes = this.options.classes;
        var count = this.getCloneCount();
        var slides = contents.slice();
        while(slides.length < count)$ca9ce22b174df7eb$var$push(slides, slides);
        $ca9ce22b174df7eb$var$push(slides.slice(-count).reverse(), slides.slice(0, count)).forEach(function(content, index) {
            var attrs = $ca9ce22b174df7eb$var$assign({}, content.attrs, {
                class: content.attrs.class + " " + classes.clone
            });
            var clone = $ca9ce22b174df7eb$var$assign({}, content, {
                attrs: attrs
            });
            index < count ? contents.unshift(clone) : contents.push(clone);
        });
    };
    _proto3.getCloneCount = function getCloneCount() {
        if (this.isLoop()) {
            var options = this.options;
            if (options.clones) return options.clones;
            var perPage = $ca9ce22b174df7eb$var$max.apply(void 0, this.breakpoints.map(function(_ref6) {
                var options2 = _ref6[1];
                return options2.perPage;
            }));
            return perPage * ((options.flickMaxPages || 1) + 1);
        }
        return 0;
    };
    _proto3.renderArrows = function renderArrows() {
        var html = "";
        html += "<div class=\"" + this.options.classes.arrows + "\">";
        html += this.renderArrow(true);
        html += this.renderArrow(false);
        html += "</div>";
        return html;
    };
    _proto3.renderArrow = function renderArrow(prev) {
        var _this$options = this.options, classes = _this$options.classes, i18n = _this$options.i18n;
        var attrs = {
            class: classes.arrow + " " + (prev ? classes.prev : classes.next),
            type: "button",
            ariaLabel: prev ? i18n.prev : i18n.next
        };
        return "<button " + this.buildAttrs(attrs) + "><svg xmlns=\"" + $ca9ce22b174df7eb$var$XML_NAME_SPACE + "\" viewBox=\"0 0 " + $ca9ce22b174df7eb$var$SIZE + " " + $ca9ce22b174df7eb$var$SIZE + "\" width=\"" + $ca9ce22b174df7eb$var$SIZE + "\" height=\"" + $ca9ce22b174df7eb$var$SIZE + "\"><path d=\"" + (this.options.arrowPath || $ca9ce22b174df7eb$var$PATH) + "\" /></svg></button>";
    };
    _proto3.html = function html() {
        var _this$config = this.config, rootClass = _this$config.rootClass, listTag = _this$config.listTag, arrows = _this$config.arrows, beforeTrack = _this$config.beforeTrack, afterTrack = _this$config.afterTrack, slider = _this$config.slider, beforeSlider = _this$config.beforeSlider, afterSlider = _this$config.afterSlider;
        var html = "";
        html += "<div id=\"" + this.id + "\" class=\"" + this.buildClasses() + " " + (rootClass || "") + "\">";
        html += "<style>" + this.Style.build() + "</style>";
        if (slider) {
            html += beforeSlider || "";
            html += "<div class=\"splide__slider\">";
        }
        html += beforeTrack || "";
        if (arrows) html += this.renderArrows();
        html += "<div class=\"splide__track\">";
        html += "<" + listTag + " class=\"splide__list\">";
        html += this.renderSlides();
        html += "</" + listTag + ">";
        html += "</div>";
        html += afterTrack || "";
        if (slider) {
            html += "</div>";
            html += afterSlider || "";
        }
        html += "</div>";
        return html;
    };
    return SplideRenderer;
}();


/*!
 * @splidejs/splide-extension-grid
 * Version  : 0.4.1
 * License  : MIT
 * Copyright: 2022 Naotoshi Fujita
 */ function $d4f4b079fc3411b2$var$empty$1(array) {
    array.length = 0;
}
function $d4f4b079fc3411b2$var$slice$1(arrayLike, start, end) {
    return Array.prototype.slice.call(arrayLike, start, end);
}
function $d4f4b079fc3411b2$var$apply$1(func) {
    return func.bind.apply(func, [
        null
    ].concat($d4f4b079fc3411b2$var$slice$1(arguments, 1)));
}
function $d4f4b079fc3411b2$var$typeOf$1(type, subject) {
    return typeof subject === type;
}
var $d4f4b079fc3411b2$var$isArray$1 = Array.isArray;
$d4f4b079fc3411b2$var$apply$1($d4f4b079fc3411b2$var$typeOf$1, "function");
$d4f4b079fc3411b2$var$apply$1($d4f4b079fc3411b2$var$typeOf$1, "string");
$d4f4b079fc3411b2$var$apply$1($d4f4b079fc3411b2$var$typeOf$1, "undefined");
function $d4f4b079fc3411b2$var$toArray$1(value) {
    return $d4f4b079fc3411b2$var$isArray$1(value) ? value : [
        value
    ];
}
function $d4f4b079fc3411b2$var$forEach$1(values, iteratee) {
    $d4f4b079fc3411b2$var$toArray$1(values).forEach(iteratee);
}
var $d4f4b079fc3411b2$var$ownKeys$1 = Object.keys;
function $d4f4b079fc3411b2$var$forOwn$1(object, iteratee, right) {
    if (object) {
        var keys = $d4f4b079fc3411b2$var$ownKeys$1(object);
        keys = right ? keys.reverse() : keys;
        for(var i = 0; i < keys.length; i++){
            var key = keys[i];
            if (key !== "__proto__") {
                if (iteratee(object[key], key) === false) break;
            }
        }
    }
    return object;
}
function $d4f4b079fc3411b2$var$assign$1(object) {
    $d4f4b079fc3411b2$var$slice$1(arguments, 1).forEach(function(source) {
        $d4f4b079fc3411b2$var$forOwn$1(source, function(value, key) {
            object[key] = source[key];
        });
    });
    return object;
}
var $d4f4b079fc3411b2$var$PROJECT_CODE$1 = "splide";
function $d4f4b079fc3411b2$var$EventBinder() {
    var listeners = [];
    function bind(targets, events, callback, options) {
        forEachEvent(targets, events, function(target, event, namespace) {
            var isEventTarget = "addEventListener" in target;
            var remover = isEventTarget ? target.removeEventListener.bind(target, event, callback, options) : target["removeListener"].bind(target, callback);
            isEventTarget ? target.addEventListener(event, callback, options) : target["addListener"](callback);
            listeners.push([
                target,
                event,
                namespace,
                callback,
                remover
            ]);
        });
    }
    function unbind(targets, events, callback) {
        forEachEvent(targets, events, function(target, event, namespace) {
            listeners = listeners.filter(function(listener) {
                if (listener[0] === target && listener[1] === event && listener[2] === namespace && (!callback || listener[3] === callback)) {
                    listener[4]();
                    return false;
                }
                return true;
            });
        });
    }
    function dispatch(target, type, detail) {
        var e;
        var bubbles = true;
        if (typeof CustomEvent === "function") e = new CustomEvent(type, {
            bubbles: bubbles,
            detail: detail
        });
        else {
            e = document.createEvent("CustomEvent");
            e.initCustomEvent(type, bubbles, false, detail);
        }
        target.dispatchEvent(e);
        return e;
    }
    function forEachEvent(targets, events, iteratee) {
        $d4f4b079fc3411b2$var$forEach$1(targets, function(target) {
            target && $d4f4b079fc3411b2$var$forEach$1(events, function(events2) {
                events2.split(" ").forEach(function(eventNS) {
                    var fragment = eventNS.split(".");
                    iteratee(target, fragment[0], fragment[1]);
                });
            });
        });
    }
    function destroy() {
        listeners.forEach(function(data) {
            data[4]();
        });
        $d4f4b079fc3411b2$var$empty$1(listeners);
    }
    return {
        bind: bind,
        unbind: unbind,
        dispatch: dispatch,
        destroy: destroy
    };
}
var $d4f4b079fc3411b2$var$EVENT_VISIBLE = "visible";
var $d4f4b079fc3411b2$var$EVENT_HIDDEN = "hidden";
var $d4f4b079fc3411b2$var$EVENT_REFRESH = "refresh";
var $d4f4b079fc3411b2$var$EVENT_UPDATED = "updated";
var $d4f4b079fc3411b2$var$EVENT_DESTROY = "destroy";
function $d4f4b079fc3411b2$var$EventInterface(Splide2) {
    var bus = Splide2 ? Splide2.event.bus : document.createDocumentFragment();
    var binder = $d4f4b079fc3411b2$var$EventBinder();
    function on(events, callback) {
        binder.bind(bus, $d4f4b079fc3411b2$var$toArray$1(events).join(" "), function(e) {
            callback.apply(callback, $d4f4b079fc3411b2$var$isArray$1(e.detail) ? e.detail : []);
        });
    }
    function emit(event) {
        binder.dispatch(bus, event, $d4f4b079fc3411b2$var$slice$1(arguments, 1));
    }
    if (Splide2) Splide2.event.on($d4f4b079fc3411b2$var$EVENT_DESTROY, binder.destroy);
    return $d4f4b079fc3411b2$var$assign$1(binder, {
        bus: bus,
        on: on,
        off: $d4f4b079fc3411b2$var$apply$1(binder.unbind, bus),
        emit: emit
    });
}
var $d4f4b079fc3411b2$var$CLASS_ROOT = $d4f4b079fc3411b2$var$PROJECT_CODE$1;
var $d4f4b079fc3411b2$var$CLASS_SLIDE = $d4f4b079fc3411b2$var$PROJECT_CODE$1 + "__slide";
var $d4f4b079fc3411b2$var$CLASS_CONTAINER = $d4f4b079fc3411b2$var$CLASS_SLIDE + "__container";
function $d4f4b079fc3411b2$var$empty(array) {
    array.length = 0;
}
function $d4f4b079fc3411b2$var$slice(arrayLike, start, end) {
    return Array.prototype.slice.call(arrayLike, start, end);
}
function $d4f4b079fc3411b2$var$apply(func) {
    return func.bind(null, ...$d4f4b079fc3411b2$var$slice(arguments, 1));
}
function $d4f4b079fc3411b2$var$typeOf(type, subject) {
    return typeof subject === type;
}
function $d4f4b079fc3411b2$var$isObject(subject) {
    return !$d4f4b079fc3411b2$var$isNull(subject) && $d4f4b079fc3411b2$var$typeOf("object", subject);
}
const $d4f4b079fc3411b2$var$isArray = Array.isArray;
$d4f4b079fc3411b2$var$apply($d4f4b079fc3411b2$var$typeOf, "function");
const $d4f4b079fc3411b2$var$isString = $d4f4b079fc3411b2$var$apply($d4f4b079fc3411b2$var$typeOf, "string");
const $d4f4b079fc3411b2$var$isUndefined = $d4f4b079fc3411b2$var$apply($d4f4b079fc3411b2$var$typeOf, "undefined");
function $d4f4b079fc3411b2$var$isNull(subject) {
    return subject === null;
}
function $d4f4b079fc3411b2$var$isHTMLElement(subject) {
    return subject instanceof HTMLElement;
}
function $d4f4b079fc3411b2$var$toArray(value) {
    return $d4f4b079fc3411b2$var$isArray(value) ? value : [
        value
    ];
}
function $d4f4b079fc3411b2$var$forEach(values, iteratee) {
    $d4f4b079fc3411b2$var$toArray(values).forEach(iteratee);
}
function $d4f4b079fc3411b2$var$push(array, items) {
    array.push(...$d4f4b079fc3411b2$var$toArray(items));
    return array;
}
function $d4f4b079fc3411b2$var$toggleClass(elm, classes, add) {
    if (elm) $d4f4b079fc3411b2$var$forEach(classes, (name)=>{
        if (name) elm.classList[add ? "add" : "remove"](name);
    });
}
function $d4f4b079fc3411b2$var$addClass(elm, classes) {
    $d4f4b079fc3411b2$var$toggleClass(elm, $d4f4b079fc3411b2$var$isString(classes) ? classes.split(" ") : classes, true);
}
function $d4f4b079fc3411b2$var$append(parent, children) {
    $d4f4b079fc3411b2$var$forEach(children, parent.appendChild.bind(parent));
}
function $d4f4b079fc3411b2$var$matches(elm, selector) {
    return $d4f4b079fc3411b2$var$isHTMLElement(elm) && (elm["msMatchesSelector"] || elm.matches).call(elm, selector);
}
function $d4f4b079fc3411b2$var$children(parent, selector) {
    const children2 = parent ? $d4f4b079fc3411b2$var$slice(parent.children) : [];
    return selector ? children2.filter((child)=>$d4f4b079fc3411b2$var$matches(child, selector)) : children2;
}
function $d4f4b079fc3411b2$var$child(parent, selector) {
    return selector ? $d4f4b079fc3411b2$var$children(parent, selector)[0] : parent.firstElementChild;
}
const $d4f4b079fc3411b2$var$ownKeys = Object.keys;
function $d4f4b079fc3411b2$var$forOwn(object, iteratee, right) {
    if (object) {
        let keys = $d4f4b079fc3411b2$var$ownKeys(object);
        keys = right ? keys.reverse() : keys;
        for(let i = 0; i < keys.length; i++){
            const key = keys[i];
            if (key !== "__proto__") {
                if (iteratee(object[key], key) === false) break;
            }
        }
    }
    return object;
}
function $d4f4b079fc3411b2$var$assign(object) {
    $d4f4b079fc3411b2$var$slice(arguments, 1).forEach((source)=>{
        $d4f4b079fc3411b2$var$forOwn(source, (value, key)=>{
            object[key] = source[key];
        });
    });
    return object;
}
function $d4f4b079fc3411b2$var$omit(object, keys) {
    $d4f4b079fc3411b2$var$toArray(keys || $d4f4b079fc3411b2$var$ownKeys(object)).forEach((key)=>{
        delete object[key];
    });
}
function $d4f4b079fc3411b2$var$removeAttribute(elms, attrs) {
    $d4f4b079fc3411b2$var$forEach(elms, (elm)=>{
        $d4f4b079fc3411b2$var$forEach(attrs, (attr)=>{
            elm && elm.removeAttribute(attr);
        });
    });
}
function $d4f4b079fc3411b2$var$setAttribute(elms, attrs, value) {
    if ($d4f4b079fc3411b2$var$isObject(attrs)) $d4f4b079fc3411b2$var$forOwn(attrs, (value2, name)=>{
        $d4f4b079fc3411b2$var$setAttribute(elms, name, value2);
    });
    else $d4f4b079fc3411b2$var$forEach(elms, (elm)=>{
        $d4f4b079fc3411b2$var$isNull(value) || value === "" ? $d4f4b079fc3411b2$var$removeAttribute(elm, attrs) : elm.setAttribute(attrs, String(value));
    });
}
function $d4f4b079fc3411b2$var$create(tag, attrs, parent) {
    const elm = document.createElement(tag);
    if (attrs) $d4f4b079fc3411b2$var$isString(attrs) ? $d4f4b079fc3411b2$var$addClass(elm, attrs) : $d4f4b079fc3411b2$var$setAttribute(elm, attrs);
    parent && $d4f4b079fc3411b2$var$append(parent, elm);
    return elm;
}
function $d4f4b079fc3411b2$var$style(elm, prop, value) {
    if ($d4f4b079fc3411b2$var$isUndefined(value)) return getComputedStyle(elm)[prop];
    if (!$d4f4b079fc3411b2$var$isNull(value)) elm.style[prop] = `${value}`;
}
function $d4f4b079fc3411b2$var$hasClass(elm, className) {
    return elm && elm.classList.contains(className);
}
function $d4f4b079fc3411b2$var$remove(nodes) {
    $d4f4b079fc3411b2$var$forEach(nodes, (node)=>{
        if (node && node.parentNode) node.parentNode.removeChild(node);
    });
}
function $d4f4b079fc3411b2$var$queryAll(parent, selector) {
    return selector ? $d4f4b079fc3411b2$var$slice(parent.querySelectorAll(selector)) : [];
}
function $d4f4b079fc3411b2$var$removeClass(elm, classes) {
    $d4f4b079fc3411b2$var$toggleClass(elm, classes, false);
}
function $d4f4b079fc3411b2$var$unit(value) {
    return $d4f4b079fc3411b2$var$isString(value) ? value : value ? `${value}px` : "";
}
const $d4f4b079fc3411b2$var$PROJECT_CODE = "splide";
function $d4f4b079fc3411b2$var$assert(condition, message) {
    if (!condition) throw new Error(`[${$d4f4b079fc3411b2$var$PROJECT_CODE}] ${message || ""}`);
}
const { min: $d4f4b079fc3411b2$var$min, max: $d4f4b079fc3411b2$var$max, floor: $d4f4b079fc3411b2$var$floor, ceil: $d4f4b079fc3411b2$var$ceil, abs: $d4f4b079fc3411b2$var$abs } = Math;
function $d4f4b079fc3411b2$var$pad(number) {
    return number < 10 ? `0${number}` : `${number}`;
}
const $d4f4b079fc3411b2$var$CLASS_SLIDE_ROW = `${$d4f4b079fc3411b2$var$CLASS_SLIDE}__row`;
const $d4f4b079fc3411b2$var$CLASS_SLIDE_COL = `${$d4f4b079fc3411b2$var$CLASS_SLIDE}--col`;
const $d4f4b079fc3411b2$var$DEFAULTS = {
    rows: 1,
    cols: 1,
    dimensions: [],
    gap: {}
};
function $d4f4b079fc3411b2$var$Dimension(options) {
    function normalize() {
        const { rows: rows, cols: cols, dimensions: dimensions } = options;
        return $d4f4b079fc3411b2$var$isArray(dimensions) && dimensions.length ? dimensions : [
            [
                rows,
                cols
            ]
        ];
    }
    function get(index) {
        const dimensions = normalize();
        return dimensions[$d4f4b079fc3411b2$var$min(index, dimensions.length - 1)];
    }
    function getAt(index) {
        const dimensions = normalize();
        let rows, cols, aggregator = 0;
        for(let i = 0; i < dimensions.length; i++){
            const dimension = dimensions[i];
            rows = dimension[0] || 1;
            cols = dimension[1] || 1;
            aggregator += rows * cols;
            if (index < aggregator) break;
        }
        $d4f4b079fc3411b2$var$assert(rows && cols, "Invalid dimension");
        return [
            rows,
            cols
        ];
    }
    return {
        get: get,
        getAt: getAt
    };
}
function $d4f4b079fc3411b2$var$Layout(Splide2, gridOptions, Dimension) {
    const { on: on, destroy: destroyEvent } = $d4f4b079fc3411b2$var$EventInterface(Splide2);
    const { Components: Components, options: options } = Splide2;
    const { resolve: resolve } = Components.Direction;
    const { forEach: forEach } = Components.Slides;
    function mount() {
        layout();
        if (options.slideFocus) {
            on($d4f4b079fc3411b2$var$EVENT_VISIBLE, onVisible);
            on($d4f4b079fc3411b2$var$EVENT_HIDDEN, onHidden);
        }
    }
    function destroy() {
        forEach((Slide)=>{
            const { slide: slide } = Slide;
            toggleTabIndex(slide, false);
            getRowsIn(slide).forEach((cell)=>{
                $d4f4b079fc3411b2$var$removeAttribute(cell, "style");
            });
            getColsIn(slide).forEach((colSlide)=>{
                cover(colSlide, true);
                $d4f4b079fc3411b2$var$removeAttribute(colSlide, "style");
            });
        });
        destroyEvent();
    }
    function layout() {
        forEach((Slide)=>{
            const { slide: slide } = Slide;
            const [rows, cols] = Dimension.get(Slide.isClone ? Slide.slideIndex : Slide.index);
            layoutRow(rows, slide);
            layoutCol(cols, slide);
            getColsIn(Slide.slide).forEach((colSlide, index)=>{
                colSlide.id = `${Slide.slide.id}-col${$d4f4b079fc3411b2$var$pad(index + 1)}`;
                if (Splide2.options.cover) cover(colSlide);
            });
        });
    }
    function layoutRow(rows, slide) {
        const { row: rowGap } = gridOptions.gap;
        const height = `calc(${100 / rows}%${rowGap ? ` - ${$d4f4b079fc3411b2$var$unit(rowGap)} * ${(rows - 1) / rows}` : ""})`;
        getRowsIn(slide).forEach((rowElm, index, rowElms)=>{
            $d4f4b079fc3411b2$var$style(rowElm, "height", height);
            $d4f4b079fc3411b2$var$style(rowElm, "display", "flex");
            $d4f4b079fc3411b2$var$style(rowElm, "margin", `0 0 ${$d4f4b079fc3411b2$var$unit(rowGap)} 0`);
            $d4f4b079fc3411b2$var$style(rowElm, "padding", 0);
            if (index === rowElms.length - 1) $d4f4b079fc3411b2$var$style(rowElm, "marginBottom", 0);
        });
    }
    function layoutCol(cols, slide) {
        const { col: colGap } = gridOptions.gap;
        const width = `calc(${100 / cols}%${colGap ? ` - ${$d4f4b079fc3411b2$var$unit(colGap)} * ${(cols - 1) / cols}` : ""})`;
        getColsIn(slide).forEach((colElm, index, colElms)=>{
            $d4f4b079fc3411b2$var$style(colElm, "width", width);
            if (index !== colElms.length - 1) $d4f4b079fc3411b2$var$style(colElm, resolve("marginRight"), $d4f4b079fc3411b2$var$unit(colGap));
        });
    }
    function cover(colSlide, uncover) {
        const container = $d4f4b079fc3411b2$var$child(colSlide, `.${$d4f4b079fc3411b2$var$CLASS_CONTAINER}`);
        const img = $d4f4b079fc3411b2$var$child(container || colSlide, "img");
        if (img && img.src) {
            $d4f4b079fc3411b2$var$style(container || colSlide, "background", uncover ? "" : `center/cover no-repeat url("${img.src}")`);
            $d4f4b079fc3411b2$var$style(img, "display", uncover ? "" : "none");
        }
    }
    function getRowsIn(slide) {
        return $d4f4b079fc3411b2$var$queryAll(slide, `.${$d4f4b079fc3411b2$var$CLASS_SLIDE_ROW}`);
    }
    function getColsIn(slide) {
        return $d4f4b079fc3411b2$var$queryAll(slide, `.${$d4f4b079fc3411b2$var$CLASS_SLIDE_COL}`);
    }
    function toggleTabIndex(slide, add) {
        getColsIn(slide).forEach((colSlide)=>{
            $d4f4b079fc3411b2$var$setAttribute(colSlide, "tabindex", add ? 0 : null);
        });
    }
    function onVisible(Slide) {
        toggleTabIndex(Slide.slide, true);
    }
    function onHidden(Slide) {
        toggleTabIndex(Slide.slide, false);
    }
    return {
        mount: mount,
        destroy: destroy
    };
}
function $d4f4b079fc3411b2$export$ef2184bd89960b14(Splide2, Components2, options) {
    const { on: on, off: off } = $d4f4b079fc3411b2$var$EventInterface(Splide2);
    const { Elements: Elements } = Components2;
    const gridOptions = {};
    const Dimension$1 = $d4f4b079fc3411b2$var$Dimension(gridOptions);
    const Layout$1 = $d4f4b079fc3411b2$var$Layout(Splide2, gridOptions, Dimension$1);
    const modifier = `${$d4f4b079fc3411b2$var$CLASS_ROOT}--grid`;
    const originalSlides = [];
    function mount() {
        init();
        on($d4f4b079fc3411b2$var$EVENT_UPDATED, init);
    }
    function init() {
        $d4f4b079fc3411b2$var$omit(gridOptions);
        $d4f4b079fc3411b2$var$assign(gridOptions, $d4f4b079fc3411b2$var$DEFAULTS, options.grid || {});
        if (shouldBuild()) {
            destroy();
            $d4f4b079fc3411b2$var$push(originalSlides, Elements.slides);
            $d4f4b079fc3411b2$var$addClass(Splide2.root, modifier);
            $d4f4b079fc3411b2$var$append(Elements.list, build());
            off($d4f4b079fc3411b2$var$EVENT_REFRESH);
            on($d4f4b079fc3411b2$var$EVENT_REFRESH, layout);
            refresh();
        } else if (isActive()) {
            destroy();
            refresh();
        }
    }
    function destroy() {
        if (isActive()) {
            const { slides: slides } = Elements;
            Layout$1.destroy();
            originalSlides.forEach((slide)=>{
                $d4f4b079fc3411b2$var$removeClass(slide, $d4f4b079fc3411b2$var$CLASS_SLIDE_COL);
                $d4f4b079fc3411b2$var$append(Elements.list, slide);
            });
            $d4f4b079fc3411b2$var$remove(slides);
            $d4f4b079fc3411b2$var$removeClass(Splide2.root, modifier);
            $d4f4b079fc3411b2$var$empty(slides);
            $d4f4b079fc3411b2$var$push(slides, originalSlides);
            $d4f4b079fc3411b2$var$empty(originalSlides);
            off($d4f4b079fc3411b2$var$EVENT_REFRESH);
        }
    }
    function refresh() {
        Splide2.refresh();
    }
    function layout() {
        if (isActive()) Layout$1.mount();
    }
    function build() {
        const outerSlides = [];
        let row = 0, col = 0;
        let outerSlide, rowSlide;
        originalSlides.forEach((slide, index)=>{
            const [rows, cols] = Dimension$1.getAt(index);
            if (!col) {
                if (!row) {
                    outerSlide = $d4f4b079fc3411b2$var$create(slide.tagName, $d4f4b079fc3411b2$var$CLASS_SLIDE);
                    outerSlides.push(outerSlide);
                }
                rowSlide = buildRow(rows, slide, outerSlide);
            }
            buildCol(cols, slide, rowSlide);
            if (++col >= cols) {
                col = 0;
                row = ++row >= rows ? 0 : row;
            }
        });
        return outerSlides;
    }
    function buildRow(rows, slide, outerSlide) {
        const tag = slide.tagName.toLowerCase() === "li" ? "ul" : "div";
        return $d4f4b079fc3411b2$var$create(tag, $d4f4b079fc3411b2$var$CLASS_SLIDE_ROW, outerSlide);
    }
    function buildCol(cols, slide, rowSlide) {
        $d4f4b079fc3411b2$var$addClass(slide, $d4f4b079fc3411b2$var$CLASS_SLIDE_COL);
        $d4f4b079fc3411b2$var$append(rowSlide, slide);
        return slide;
    }
    function shouldBuild() {
        if (options.grid) {
            const { rows: rows, cols: cols, dimensions: dimensions } = gridOptions;
            return rows > 1 || cols > 1 || $d4f4b079fc3411b2$var$isArray(dimensions) && dimensions.length > 0;
        }
        return false;
    }
    function isActive() {
        return $d4f4b079fc3411b2$var$hasClass(Splide2.root, modifier);
    }
    return {
        mount: mount,
        destroy: destroy
    };
}



const $c2451cd7f9fe8fd7$var$sliders = {
    init () {
        this.initImmediately('.jsUspsSlider', this.textSlider.bind(this));
        this.initImmediately('.jsHeroSlider', this.heroSlider.bind(this));
        this.initImmediately('.jsProdSlider', this.prodSlider.bind(this));
        this.initImmediately('#mainImage', this.setProdThumbnailsSlider.bind(this));
        this.initImmediately('#thumbnails', this.setProdThumbnailsSlider.bind(this));
        this.initOnScroll('.jsBrandsSlider', this.brandsSlider.bind(this));
        this.initOnScroll('.jsIndustrySlider', this.industrySlider.bind(this));
        this.initOnScroll('.jsReviewsSlider', this.reviewsSlider.bind(this));
        this.initOnScroll('.jsTeamSlider', this.teamSlider.bind(this));
        this.initOnScroll('.jsHistorySlider', this.historySlider.bind(this));
        this.initOnScroll('.jsCustomerSlider', this.customerSlider.bind(this));
        this.resetSlider();
    },
    resetSlider () {
        window.addEventListener('reset', ()=>{
            this.initImmediately('#mainImage', this.setProdThumbnailsSlider.bind(this));
            this.initImmediately('#thumbnails', this.setProdThumbnailsSlider.bind(this));
        });
    },
    initImmediately (selector, callback) {
        const elements = document.querySelectorAll(selector);
        elements.forEach((el)=>{
            if (el.dataset.sliderInitialized === 'true') return;
            el.dataset.sliderInitialized = 'true';
            callback(el);
        });
    },
    initOnScroll (selector, callback) {
        const elements = document.querySelectorAll(selector);
        if (!elements.length) return;
        if (!('IntersectionObserver' in window)) {
            elements.forEach((el)=>{
                if (el.dataset.sliderInitialized === 'true') return;
                el.dataset.sliderInitialized = 'true';
                callback(el);
            });
            return;
        }
        const observer = new IntersectionObserver((entries, obs)=>{
            entries.forEach((entry)=>{
                if (!entry.isIntersecting) return;
                const el = entry.target;
                if (el.dataset.sliderInitialized === 'true') {
                    obs.unobserve(el);
                    return;
                }
                el.dataset.sliderInitialized = 'true';
                obs.unobserve(el);
                callback(el);
            });
        }, {
            root: null,
            rootMargin: '200px 0px',
            threshold: 0
        });
        elements.forEach((el)=>{
            if (el.dataset.sliderInitialized === 'true') return;
            observer.observe(el);
        });
    },
    heroSlider (el) {
        const loadSlideAssets = (slide)=>{
            if (!slide || slide.dataset.assetsLoaded === 'true') return;
            const picture = slide.querySelector('picture');
            if (!picture) return;
            const sources = picture.querySelectorAll('source[data-srcset]');
            const img = picture.querySelector('img[data-src]');
            sources.forEach((source)=>{
                const dataSrcset = source.getAttribute('data-srcset');
                if (!dataSrcset) return;
                source.setAttribute('srcset', dataSrcset);
                source.removeAttribute('data-srcset');
            });
            if (img) {
                const dataSrc = img.getAttribute('data-src');
                if (dataSrc) {
                    img.setAttribute('src', dataSrc);
                    img.removeAttribute('data-src');
                }
            }
            slide.dataset.assetsLoaded = 'true';
        };
        const slider = new (0, $ca9ce22b174df7eb$export$24494c7438c070bf)(el, {
            type: 'slide',
            rewind: true,
            perPage: 1,
            pagination: false,
            arrows: true
        });
        slider.on('mounted move', ()=>{
            const activeSlide = el.querySelector('.splide__slide.is-active');
            const prevSlide = el.querySelector('.splide__slide.is-prev');
            const nextSlide = el.querySelector('.splide__slide.is-next');
            loadSlideAssets(activeSlide);
            loadSlideAssets(prevSlide);
            loadSlideAssets(nextSlide);
        });
        slider.mount();
    },
    prodSlider (item) {
        const slideCount = item.querySelectorAll('.splide__slide').length;
        new (0, $ca9ce22b174df7eb$export$24494c7438c070bf)(item, {
            type: 'slide',
            arrows: true,
            gap: 10,
            perPage: 5,
            perMove: 1,
            rewind: true,
            speed: 650,
            easing: 'cubic-bezier(0.25, 1, 0.5, 1)',
            waitForTransition: true,
            pagination: slideCount >= 5,
            padding: {
                right: '7%'
            },
            breakpoints: {
                1200: {
                    perPage: 2,
                    perMove: 1,
                    padding: {
                        right: '25%'
                    },
                    pagination: slideCount >= 3
                },
                767: {
                    perPage: 1,
                    perMove: 1,
                    pagination: slideCount >= 2
                }
            }
        }).mount();
    },
    teamSlider (item) {
        new (0, $ca9ce22b174df7eb$export$24494c7438c070bf)(item, {
            type: 'loop',
            arrows: true,
            gap: 15,
            perPage: 4,
            perMove: 1,
            rewind: true,
            easing: 'cubic-bezier(0.25, 1, 0.5, 1)',
            waitForTransition: true,
            pagination: true,
            breakpoints: {
                1200: {
                    perPage: 2,
                    perMove: 1,
                    pagination: true
                },
                767: {
                    perPage: 1,
                    perMove: 1,
                    pagination: true
                }
            }
        }).mount();
    },
    historySlider (item) {
        new (0, $ca9ce22b174df7eb$export$24494c7438c070bf)(item, {
            type: 'loop',
            arrows: true,
            perPage: 1,
            perMove: 1,
            rewind: true,
            easing: 'cubic-bezier(0.25, 1, 0.5, 1)',
            waitForTransition: true,
            pagination: false
        }).mount();
    },
    reviewsSlider (item) {
        new (0, $ca9ce22b174df7eb$export$24494c7438c070bf)(item, {
            type: 'slide',
            arrows: true,
            gap: 30,
            perPage: 2,
            perMove: 1,
            pagination: true,
            rewind: true,
            speed: 650,
            easing: 'cubic-bezier(0.25, 1, 0.5, 1)',
            waitForTransition: true,
            breakpoints: {
                1200: {
                    perPage: 1,
                    perMove: 1,
                    grid: {
                        rows: 2,
                        cols: 1,
                        gap: {
                            row: '20px',
                            col: '20px'
                        }
                    }
                },
                767: {
                    perPage: 1,
                    perMove: 1,
                    grid: {
                        rows: 2,
                        cols: 1,
                        gap: {
                            row: '20px',
                            col: '20px'
                        }
                    }
                }
            }
        }).mount({
            Grid: $d4f4b079fc3411b2$export$ef2184bd89960b14
        });
    },
    customerSlider (item) {
        new (0, $ca9ce22b174df7eb$export$24494c7438c070bf)(item, {
            type: 'loop',
            arrows: false,
            gap: 20,
            perPage: 6,
            perMove: 1,
            pagination: true,
            autoplay: true,
            rewind: true,
            speed: 650,
            easing: 'cubic-bezier(0.25, 1, 0.5, 1)',
            waitForTransition: true,
            reducedMotion: {
                interval: 4000,
                speed: 800,
                autoplay: true
            },
            breakpoints: {
                1200: {
                    gap: 15,
                    perPage: 3,
                    perMove: 1
                },
                767: {
                    perPage: 1,
                    perMove: 1
                }
            }
        }).mount();
    },
    brandsSlider (item) {
        new (0, $ca9ce22b174df7eb$export$24494c7438c070bf)(item, {
            type: 'loop',
            arrows: true,
            pagination: false,
            gap: 14,
            perPage: 8,
            perMove: 1,
            speed: 650,
            easing: 'cubic-bezier(0.25, 1, 0.5, 1)',
            waitForTransition: true,
            breakpoints: {
                1200: {
                    perPage: 1,
                    perMove: 1,
                    grid: {
                        rows: 2,
                        cols: 4,
                        gap: {
                            row: '15px',
                            col: '25px'
                        }
                    }
                },
                767: {
                    perPage: 1,
                    perMove: 1,
                    grid: {
                        rows: 2,
                        cols: 2,
                        gap: {
                            row: '15px',
                            col: '15px'
                        }
                    }
                }
            }
        }).mount({
            Grid: $d4f4b079fc3411b2$export$ef2184bd89960b14
        });
    },
    industrySlider (item) {
        new (0, $ca9ce22b174df7eb$export$24494c7438c070bf)(item, {
            type: 'loop',
            arrows: true,
            pagination: true,
            gap: 13,
            perPage: 5,
            perMove: 1,
            speed: 650,
            easing: 'cubic-bezier(0.25, 1, 0.5, 1)',
            waitForTransition: true,
            breakpoints: {
                1200: {
                    gap: 24,
                    perPage: 3,
                    perMove: 1
                },
                767: {
                    gap: 15,
                    perPage: 2,
                    perMove: 1
                }
            }
        }).mount();
    },
    textSlider (item) {
        new (0, $ca9ce22b174df7eb$export$24494c7438c070bf)(item, {
            type: 'loop',
            perPage: 1,
            perMove: 1,
            arrows: false,
            pagination: false,
            destroy: true,
            reducedMotion: {
                interval: 4000,
                speed: 800,
                autoplay: true
            },
            breakpoints: {
                1200: {
                    destroy: false
                }
            }
        }).mount();
    },
    setProdThumbnailsSlider (item) {
        const productMainImages = document.getElementById("mainImage");
        const thumbnails = document.getElementById("thumbnails");
        if (productMainImages && thumbnails) {
            const slideCount = productMainImages.querySelectorAll('.splide__slide').length;
            const main = new (0, $ca9ce22b174df7eb$export$24494c7438c070bf)(productMainImages, {
                type: "fade",
                rewind: true,
                pagination: false,
                arrows: false,
                breakpoints: {
                    1200: {
                        pagination: slideCount > 1
                    }
                }
            });
            const thumbnailsNav = new (0, $ca9ce22b174df7eb$export$24494c7438c070bf)(thumbnails, {
                type: 'slide',
                direction: "ttb",
                isNavigation: true,
                pagination: false,
                rewind: true,
                height: '390px',
                arrows: slideCount > 3,
                gap: "10px"
            });
            main.sync(thumbnailsNav);
            main.mount();
            thumbnailsNav.mount();
        }
    }
};
var $c2451cd7f9fe8fd7$export$2e2bcd8739ae039 = $c2451cd7f9fe8fd7$var$sliders;



const $fecaf8c6db57680a$var$stickyHeader = {
    header: null,
    mainContent: null,
    line: null,
    lineWrap: null,
    popups: document.querySelectorAll('.jsStickyPopup'),
    cartBtn: document.querySelectorAll('.jsInView'),
    lastScrollTop: 0,
    initialized: false,
    refreshElements () {
        this.header = document.getElementById('jsStickyHeader');
        this.mainContent = document.getElementById('main-content');
        this.line = document.getElementById('jsCartLine');
        this.lineWrap = document.getElementById('jsLineWrap');
        this.popups = document.querySelectorAll('.jsStickyPopup');
        // Refresh because Neto may replace these during a variation change.
        this.cartBtn = document.querySelectorAll('.jsInView');
    },
    init () {
        const start = ()=>{
            if (this.initialized) return;
            this.initialized = true;
            this.refreshElements();
            this.setClass();
            this.reset();
            this.handleScroll();
        };
        if (document.readyState === 'loading') window.addEventListener('DOMContentLoaded', start, {
            once: true
        });
        else start();
    },
    reset () {
        window.addEventListener('reset', ()=>{
            this.refreshElements();
            requestAnimationFrame(()=>{
                this.setScroll();
            });
        });
    },
    setClass () {
        document.addEventListener('scroll', ()=>{
            this.handleScroll();
        }, {
            passive: true
        });
    },
    handleScroll () {
        const scrollTop = window.scrollY || document.documentElement.scrollTop;
        if (this.header && this.mainContent) {
            const scrollingDown = scrollTop > this.lastScrollTop;
            this.header.classList.toggle('down', scrollingDown);
            this.header.classList.toggle('up', !scrollingDown);
            this.mainContent.classList.toggle('down', scrollingDown);
            this.mainContent.classList.toggle('up', !scrollingDown);
        }
        if (scrollTop === 0) {
            this.header?.classList.remove('up', 'down');
            this.mainContent?.classList.remove('up', 'down');
            this.line?.classList.remove('activeClass');
            this.popups.forEach((popup)=>{
                popup.classList.remove('activeScroll');
            });
        } else this.popups.forEach((popup)=>{
            popup.classList.add('activeScroll');
        });
        this.lastScrollTop = Math.max(scrollTop, 0);
        this.setScroll();
    },
    setScroll () {
        if (!this.lineWrap || !this.header || !this.cartBtn.length) return;
        const cartBtnInView = Array.from(this.cartBtn).some((button)=>(0, $33151c6d3bf6cc96$export$62976f5619263b39)(button));
        const shouldShow = window.scrollY > 0 && !cartBtnInView;
        this.lineWrap.classList.toggle('activeClass', shouldShow);
        this.header.classList.toggle('activeLine', shouldShow);
    }
};
var $fecaf8c6db57680a$export$2e2bcd8739ae039 = $fecaf8c6db57680a$var$stickyHeader;


const $314b550233ac0c7d$var$readMore = {
    wrap: document.querySelectorAll('.jsReadMore'),
    init () {
        this.setBtn();
    },
    setBtn () {
        this.wrap.forEach((item)=>{
            const elWrap = item.querySelector('.jsReadMoreWrap');
            const elBody = item.querySelector('.jsReadMoreBody');
            const btn = item.querySelector('.jsReadMoreTrigger');
            const height = elBody.offsetHeight;
            const itemHeight = elWrap.offsetHeight;
            if (!btn) return;
            if (height <= itemHeight) btn.classList.add('d-none');
            btn.addEventListener('click', ()=>{
                if (btn.dataset.open === 'false') {
                    btn.dataset.open = 'true';
                    elWrap.style.maxHeight = height + 30 + 'px';
                    btn.innerText = 'Read Less ';
                } else {
                    btn.dataset.open = 'false';
                    elWrap.style.maxHeight = itemHeight + 'px';
                    btn.innerText = 'Read More';
                }
            });
        });
    }
};
var $314b550233ac0c7d$export$2e2bcd8739ae039 = $314b550233ac0c7d$var$readMore;



const $61e60b05d877614a$var$accordian = {
    accordian: document.querySelectorAll('.jsAccordian'),
    scrollToEl: undefined,
    init () {
        this.setAccordian();
    },
    setAccordian () {
        this.accordian.forEach((item)=>{
            const width = item.dataset.width ? item.dataset.width : '999999';
            const offset = item.dataset.offset;
            if ((0, $33151c6d3bf6cc96$export$c99e242bffb864af) < parseInt(width)) {
                const items = item.querySelectorAll('.jsAccordianItem');
                this.setItems(items);
                this.setMultipleToggle(item, items);
                if (offset) item.addEventListener('transitionend', ()=>{
                    this.scrollPosition(offset);
                });
            }
        });
    },
    setItems (items) {
        items.forEach((item)=>{
            const parent = item.parentElement;
            const sibiling = item.nextElementSibling;
            const sibilingHeight = sibiling.offsetHeight;
            const height = item.offsetHeight;
            if (item.dataset.open === 'true') {
                parent.style.maxHeight = height + sibilingHeight + 'px';
                item.classList.add('activeClass');
                item.parentElement?.classList.add('activeClass');
            }
            item.addEventListener('click', (e)=>{
                e.preventDefault();
                if (item.dataset.open === 'false') {
                    this.scrollToEl = parent;
                    item.dataset.open = 'true';
                    parent.style.maxHeight = height + sibilingHeight + 'px';
                    item.classList.add('activeClass');
                    item.parentElement?.classList.add('activeClass');
                    item.parentElement?.classList.add('activeClass');
                } else {
                    this.scrollToEl = undefined;
                    item.dataset.open = 'false';
                    parent.style.maxHeight = height + 'px';
                    item.classList.remove('activeClass');
                    item.parentElement?.classList.remove('activeClass');
                    item.parentElement?.classList.remove('activeClass');
                }
            });
        });
    },
    setMultipleToggle (item, items) {
        const expendAll = item.querySelector('.jsAccordianExpandOpenAll');
        const closeAll = item.querySelector('.jsAccordianCollapseAll');
        expendAll?.addEventListener('click', ()=>{
            expendAll.classList.add('activeClass');
            closeAll?.classList.remove('activeClass');
            this.openAll(items);
        });
        expendAll?.click();
        closeAll?.addEventListener('click', ()=>{
            closeAll.classList.add('activeClass');
            expendAll?.classList.remove('activeClass');
            this.closeAll(items);
        });
    },
    closeAll (items) {
        items.forEach((item)=>{
            const parent = item.parentElement;
            const height = item.offsetHeight;
            item.dataset.open = 'false';
            parent.style.maxHeight = height + 'px';
            item.classList.remove('activeClass');
        });
    },
    openAll (items) {
        items.forEach((item)=>{
            const parent = item.parentElement;
            const sibiling = item.nextElementSibling;
            const sibilingHeight = sibiling.offsetHeight;
            const height = item.offsetHeight;
            item.dataset.open = 'true';
            parent.style.maxHeight = height + sibilingHeight + 'px';
            item.classList.add('activeClass');
        });
    },
    scrollPosition (offset) {
        if (this.scrollToEl) window.scrollTo({
            top: this.scrollToEl.offsetTop - +offset,
            behavior: 'smooth'
        });
    }
};
var $61e60b05d877614a$export$2e2bcd8739ae039 = $61e60b05d877614a$var$accordian;


const $6f303ce421a095d9$var$showMoreFilters = {
    filterWrap: document.querySelectorAll('.jsFilterWrap'),
    init () {
        this.toggleFilters();
    },
    toggleFilters () {
        this.filterWrap.forEach((filter)=>{
            const singleFilters = filter.querySelectorAll('.jsFilter');
            const btns = filter.querySelector('.jsShowMore');
            if (singleFilters.length > 8 && btns) {
                filter.classList.add('filter-less');
                if (btns.style) btns.style.display = 'block';
            } else if (btns && btns.style) btns.style.display = 'none';
            if (btns) btns.addEventListener('click', ()=>{
                filter.classList.toggle('filter-less');
                filter.style.height = filter.classList.contains('filter-less') ? 'auto' : 'auto';
                if (btns.textContent) btns.textContent = filter.classList.contains('filter-less') ? '+ Show More' : '- Show Less';
            });
        });
    }
};
var $6f303ce421a095d9$export$2e2bcd8739ae039 = $6f303ce421a095d9$var$showMoreFilters;


const $27d4b33184ed96e1$var$stickyFilters = {
    stuckClass: "activeClass",
    init () {
        this.setStickyClass();
    },
    setStickyClass () {
        const onScroll = ()=>{
            const els = document.querySelectorAll(".cat-main__section");
            const deskNav = document.getElementById('jsDeskNav');
            const header = document.getElementById('jsStickyHeader');
            const catList = document.getElementById('jsCatList');
            els.forEach((el)=>{
                const stickyTop = parseFloat(getComputedStyle(el).top) || 0;
                const rect = el.getBoundingClientRect();
                const isStuck = rect.top <= stickyTop + 1;
                el.classList.toggle(this.stuckClass, isStuck);
                deskNav?.classList.toggle(this.stuckClass, isStuck);
                header?.classList.toggle(this.stuckClass, isStuck);
                catList?.classList.toggle(this.stuckClass, isStuck);
            });
        };
        window.addEventListener("scroll", onScroll, {
            passive: true
        });
        window.addEventListener("resize", onScroll);
        onScroll();
    }
};
var $27d4b33184ed96e1$export$2e2bcd8739ae039 = $27d4b33184ed96e1$var$stickyFilters;



const $7f7b779d59f7c599$var$scrollCart = {
    cartLine: document.getElementById('addToCartLine'),
    cartBtn: document.querySelectorAll('.jsInView'),
    init () {
        window.addEventListener('DOMContentLoaded', this.setScroll.bind(this));
        window.addEventListener('scroll', this.setScroll.bind(this));
    },
    setScroll () {
        if (!this.cartBtn || !this.cartLine) return;
        const anyInView = Array.from(this.cartBtn).some((btn)=>(0, $33151c6d3bf6cc96$export$62976f5619263b39)(btn));
        if (anyInView) this.cartLine.classList.add('activeClass');
        else this.cartLine.classList.remove('activeClass');
    }
};
var $7f7b779d59f7c599$export$2e2bcd8739ae039 = $7f7b779d59f7c599$var$scrollCart;


const $d36e03d6f0c7c813$var$tabs = {
    init () {
        this.setTabs();
    },
    setTabs () {
        document.addEventListener('click', (event)=>{
            const tab = event.target.closest('[data-tab]');
            if (!tab) return;
            const groupName = tab.dataset.tab;
            if (!groupName) return;
            const tabs = document.querySelectorAll(`[data-tab="${groupName}"]`);
            const contents = document.querySelectorAll(`[data-tab-body="${groupName}"]`);
            const index = Array.from(tabs).indexOf(tab);
            tabs.forEach((item, itemIndex)=>{
                item.classList.remove('activeClass');
                contents[itemIndex]?.classList.remove('activeClass');
            });
            tab.classList.add('activeClass');
            contents[index]?.classList.add('activeClass');
        });
    }
};
var $d36e03d6f0c7c813$export$2e2bcd8739ae039 = $d36e03d6f0c7c813$var$tabs;


(0, $33151c6d3bf6cc96$export$4a59b34ae617836)();
(0, $33151c6d3bf6cc96$export$f531f92e2a15358f)();
(0, $c11f0a32cd89d9db$export$2e2bcd8739ae039).init();
(0, $240c1a48eb8b8a29$export$2e2bcd8739ae039).init();
(0, $d4e2d81e80d5910a$export$2e2bcd8739ae039).init();
(0, $90d1518f9fdd1c26$export$2e2bcd8739ae039).init();
(0, $2f802d016426be0c$export$2e2bcd8739ae039).init();
(0, $c2451cd7f9fe8fd7$export$2e2bcd8739ae039).init();
(0, $fecaf8c6db57680a$export$2e2bcd8739ae039).init();
(0, $314b550233ac0c7d$export$2e2bcd8739ae039).init();
(0, $61e60b05d877614a$export$2e2bcd8739ae039).init();
// trade.init();
(0, $6f303ce421a095d9$export$2e2bcd8739ae039).init();
(0, $27d4b33184ed96e1$export$2e2bcd8739ae039).init();
(0, $d36e03d6f0c7c813$export$2e2bcd8739ae039).init();
(0, $7f7b779d59f7c599$export$2e2bcd8739ae039).init();

})();
//# sourceMappingURL=main.js.map
